/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Trafikportalen API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

/**
 * @summary Health check
 */
export const healthCheckResponse = zod.object({
  status: zod.string(),
  database_version: zod.string().optional(),
});

/**
 * Get the current users tenant
 * @summary Get tenant
 */
export const getTenantResponseAnonymizationIntervalDaysMin = 0;

export const getTenantResponse = zod
  .object({
    id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    name: zod.string(),
    logo: zod.string().url(),
    support_email: zod
      .string()
      .email()
      .nullable()
      .describe(
        'Address end users contact for help with the site. Null if the tenant has not set one. Read-only; maintained directly in the database.',
      ),
  })
  .describe('Public tenant information')
  .and(
    zod.object({
      required_internal_invoicing_details: zod.array(
        zod.enum([
          'external_customer_id',
          'cost_center',
          'account',
          'counterparty',
          'purpose',
          'project',
          'object',
          'activity',
          'article',
        ]),
      ),
      required_external_invoicing_details: zod.array(
        zod.enum([
          'external_customer_id',
          'cost_center',
          'account',
          'counterparty',
          'purpose',
          'project',
          'object',
          'activity',
          'article',
        ]),
      ),
      optional_internal_invoicing_details: zod.array(
        zod.enum([
          'external_customer_id',
          'cost_center',
          'account',
          'counterparty',
          'purpose',
          'project',
          'object',
          'activity',
          'article',
        ]),
      ),
      optional_external_invoicing_details: zod.array(
        zod.enum([
          'external_customer_id',
          'cost_center',
          'account',
          'counterparty',
          'purpose',
          'project',
          'object',
          'activity',
          'article',
        ]),
      ),
      faq_company: zod.string(),
      faq_school: zod.string(),
      privacy_policy: zod.string(),
      support: zod.string(),
      terms_and_conditions: zod.string(),
      areff_card_type: zod.string(),
      areff_bearer_id: zod.string(),
      anonymization_interval_days: zod
        .number()
        .min(getTenantResponseAnonymizationIntervalDaysMin)
        .describe('Days before data is anonymized. 0 disables anonymization.'),
    }),
  );

/**
 * Updates the tenants information
 * @summary Update tenant
 */
export const tenantUpdateBodyAnonymizationIntervalDaysMin = 0;

export const tenantUpdateBody = zod.object({
  name: zod.string().optional(),
  logo: zod.string().url().optional(),
  faq_company: zod.string().optional(),
  faq_school: zod.string().optional(),
  privacy_policy: zod.string().optional(),
  support: zod.string().optional(),
  terms_and_conditions: zod.string().optional(),
  areff_card_type: zod.string().optional(),
  areff_bearer_id: zod.string().optional(),
  anonymization_interval_days: zod
    .number()
    .min(tenantUpdateBodyAnonymizationIntervalDaysMin)
    .optional()
    .describe('Days before data is anonymized. 0 disables anonymization.'),
});

export const tenantUpdateResponseAnonymizationIntervalDaysMin = 0;

export const tenantUpdateResponse = zod
  .object({
    id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    name: zod.string(),
    logo: zod.string().url(),
    support_email: zod
      .string()
      .email()
      .nullable()
      .describe(
        'Address end users contact for help with the site. Null if the tenant has not set one. Read-only; maintained directly in the database.',
      ),
  })
  .describe('Public tenant information')
  .and(
    zod.object({
      required_internal_invoicing_details: zod.array(
        zod.enum([
          'external_customer_id',
          'cost_center',
          'account',
          'counterparty',
          'purpose',
          'project',
          'object',
          'activity',
          'article',
        ]),
      ),
      required_external_invoicing_details: zod.array(
        zod.enum([
          'external_customer_id',
          'cost_center',
          'account',
          'counterparty',
          'purpose',
          'project',
          'object',
          'activity',
          'article',
        ]),
      ),
      optional_internal_invoicing_details: zod.array(
        zod.enum([
          'external_customer_id',
          'cost_center',
          'account',
          'counterparty',
          'purpose',
          'project',
          'object',
          'activity',
          'article',
        ]),
      ),
      optional_external_invoicing_details: zod.array(
        zod.enum([
          'external_customer_id',
          'cost_center',
          'account',
          'counterparty',
          'purpose',
          'project',
          'object',
          'activity',
          'article',
        ]),
      ),
      faq_company: zod.string(),
      faq_school: zod.string(),
      privacy_policy: zod.string(),
      support: zod.string(),
      terms_and_conditions: zod.string(),
      areff_card_type: zod.string(),
      areff_bearer_id: zod.string(),
      anonymization_interval_days: zod
        .number()
        .min(tenantUpdateResponseAnonymizationIntervalDaysMin)
        .describe('Days before data is anonymized. 0 disables anonymization.'),
    }),
  );

/**
 * Get a list of all payers for the current tenant
 * @summary List payers in tenant
 */

export const listPayersForTenantResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
      reference: zod.string(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod.string().uuid(),
      details: zod.record(zod.string(), zod.string()),
    }),
  );
export const listPayersForTenantResponse = zod.array(
  listPayersForTenantResponseItem,
);

/**
 * Lists all users in the tenant
 * @summary List tenant users
 */
export const listTenantUsersResponseItem = zod.object({
  id: zod.string().uuid(),
  email: zod.string().email(),
  firstname: zod.string(),
  lastname: zod.string(),
  created_at: zod.string().datetime({}),
  updated_at: zod.string().datetime({}),
  user_profiles: zod.array(
    zod.object({
      id: zod.string().uuid(),
      email: zod.string().email(),
      tenant_id: zod.string(),
      tenant: zod.string(),
      role_id: zod.string().uuid(),
      role: zod.string(),
      active: zod.boolean(),
      organization_id: zod.string().uuid().optional(),
      organization: zod.string().optional(),
      last_used: zod.string().datetime({}).optional(),
      expires_at: zod.string().datetime({}).optional(),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    }),
  ),
});
export const listTenantUsersResponse = zod.array(listTenantUsersResponseItem);

/**
 * As a tenant administrator, update billing and payment information for an organization
 * @summary Update organization payer information
 */
export const tenantUpdatePayerParams = zod.object({
  payerID: zod
    .string()
    .uuid()
    .describe('The unique identifier of the payer to update'),
});

export const tenantUpdatePayerBody = zod
  .object({
    address: zod.object({
      street: zod.string().min(1),
      zip_code: zod
        .string()
        .min(1)
        .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
      city: zod.string().min(1),
      care_of: zod
        .string()
        .min(1)
        .optional()
        .describe(
          "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
        ),
    }),
    reference: zod.string(),
  })
  .and(
    zod.object({
      details: zod.record(zod.string(), zod.string()),
    }),
  );

export const tenantUpdatePayerResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
      reference: zod.string(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod.string().uuid(),
      details: zod.record(zod.string(), zod.string()),
    }),
  );

/**
 * As a tenant administrator, update payment details information for an organization
 * @summary Update organization payer details
 */
export const tenantUpdatePayerDetailsParams = zod.object({
  payerID: zod.string().uuid(),
});

export const tenantUpdatePayerDetailsBody = zod.record(
  zod.string(),
  zod.string(),
);

export const tenantUpdatePayerDetailsResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
      reference: zod.string(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod.string().uuid(),
      details: zod.record(zod.string(), zod.string()),
    }),
  );

/**
 * Invite a tenant user to the system.
 * @summary Invite a tenant user
 */
export const inviteTenantUserBody = zod.object({
  email: zod.string().email(),
  first_name: zod.string(),
  last_name: zod.string(),
  user_type: zod.enum(['admin', 'bearer-manager', 'viewer']),
});

/**
 * Returns organization users (admins and viewers) grouped by organization ID
 * @summary List tenant organization users
 */
export const listTenantOrganizationUsersQueryParams = zod.object({
  organization_ids: zod
    .array(
      zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
    )
    .optional()
    .describe('Optional list of organization IDs to filter (empty = all orgs)'),
});

export const listTenantOrganizationUsersResponse = zod
  .record(
    zod.string(),
    zod.array(
      zod.object({
        id: zod.string().uuid().describe('User ID'),
        email: zod.string().email(),
        firstname: zod.string(),
        lastname: zod.string(),
        user_profile: zod.object({
          id: zod.string().uuid(),
          email: zod.string().email(),
          tenant_id: zod.string(),
          tenant: zod.string(),
          role_id: zod.string().uuid(),
          role: zod.string(),
          active: zod.boolean(),
          organization_id: zod.string().uuid().optional(),
          organization: zod.string().optional(),
          last_used: zod.string().datetime({}).optional(),
          expires_at: zod.string().datetime({}).optional(),
          created_at: zod.string().datetime({}),
          updated_at: zod.string().datetime({}),
        }),
      }),
    ),
  )
  .describe(
    'Map of organization IDs (as strings) to arrays of organization users (admins and viewers)',
  );

/**
 * Returns the ticket claims on school collections across all organizations in the tenant
 * @summary List school collection ticket claims for the tenant
 */
export const listTenantCollectionTicketClaimsQueryParams = zod.object({
  collection_type: zod
    .array(
      zod.enum([
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
    )
    .optional()
    .describe(
      'Optional list of school collection types to filter (empty = all school types)',
    ),
  organization_ids: zod
    .array(
      zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
    )
    .optional()
    .describe(
      'Optional list of organization IDs to filter (empty = all organizations)',
    ),
});

export const listTenantCollectionTicketClaimsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        valid_from: zod.string().datetime({}).optional(),
        valid_to: zod.string().datetime({}).optional(),
      })
      .and(
        zod.object({
          type: zod.enum(['single', 'partial-payment']),
          revoke_strategy: zod.enum(['none', 'revoke']),
          reissuance_allowed: zod.boolean(),
          relational: zod.boolean(),
          stina_product_id: zod.string().optional(),
        }),
      ),
  )
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      department_id: zod.string().uuid(),
      collection_id: zod.string().uuid(),
      non_invoiced: zod
        .boolean()
        .describe(
          'Tickets issued under the claim are not billed. Only sysadmins can set it, through the tenant claim endpoints',
        ),
    }),
  );
export const listTenantCollectionTicketClaimsResponse = zod.array(
  listTenantCollectionTicketClaimsResponseItem,
);

/**
 * Creates one ticket claim per organization on that organization's collection of the given school type
 * @summary Create school collection ticket claims for several organizations
 */

export const createTenantCollectionTicketClaimsBody = zod.object({
  collection_type: zod.enum([
    'school-transportation',
    'school-student-travel',
    'school-child-and-youth',
  ]),
  organization_ids: zod
    .array(
      zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
    )
    .min(1)
    .describe(
      "One claim is created per organization, on that organization's collection of the given type",
    ),
  data: zod
    .object({
      valid_from: zod.string().datetime({}).optional(),
      valid_to: zod.string().datetime({}).optional(),
    })
    .and(
      zod.object({
        type: zod.enum(['single', 'partial-payment']),
        revoke_strategy: zod.enum(['none', 'revoke']),
        reissuance_allowed: zod.boolean(),
        relational: zod.boolean(),
        stina_product_id: zod.string().optional(),
      }),
    ),
  non_invoiced: zod
    .boolean()
    .optional()
    .describe(
      'Tickets issued under the created claims are not billed. Defaults to false',
    ),
});

/**
 * Updates the validity dates and, when given, the non-invoiced flag of the listed ticket claims.

`data` replaces both validity dates of every listed claim: an omitted `valid_from` or `valid_to`
clears that date rather than keeping it. Send the current dates back to leave them unchanged,
including when only `non_invoiced` is being changed. Clearing `valid_from` makes a pending claim
active immediately, after which its `non_invoiced` flag can no longer be changed.

 * @summary Update several school collection ticket claims
 */

export const updateTenantCollectionTicketClaimsBody = zod.object({
  collection_ticket_claim_ids: zod.array(zod.string().uuid()).min(1),
  data: zod.object({
    valid_from: zod.string().datetime({}).optional(),
    valid_to: zod.string().datetime({}).optional(),
  }),
  non_invoiced: zod
    .boolean()
    .optional()
    .describe(
      'When true, tickets issued under the claims are not billed. Omit to leave unchanged. Can only change before a claim starts',
    ),
});

export const updateTenantCollectionTicketClaimsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        valid_from: zod.string().datetime({}).optional(),
        valid_to: zod.string().datetime({}).optional(),
      })
      .and(
        zod.object({
          type: zod.enum(['single', 'partial-payment']),
          revoke_strategy: zod.enum(['none', 'revoke']),
          reissuance_allowed: zod.boolean(),
          relational: zod.boolean(),
          stina_product_id: zod.string().optional(),
        }),
      ),
  )
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      department_id: zod.string().uuid(),
      collection_id: zod.string().uuid(),
      non_invoiced: zod
        .boolean()
        .describe(
          'Tickets issued under the claim are not billed. Only sysadmins can set it, through the tenant claim endpoints',
        ),
    }),
  );
export const updateTenantCollectionTicketClaimsResponse = zod.array(
  updateTenantCollectionTicketClaimsResponseItem,
);

/**
 * Deletes the listed ticket claims
 * @summary Delete several school collection ticket claims
 */

export const deleteTenantCollectionTicketClaimsBody = zod.object({
  collection_ticket_claim_ids: zod.array(zod.string().uuid()).min(1),
});

export const deleteTenantCollectionTicketClaimsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        valid_from: zod.string().datetime({}).optional(),
        valid_to: zod.string().datetime({}).optional(),
      })
      .and(
        zod.object({
          type: zod.enum(['single', 'partial-payment']),
          revoke_strategy: zod.enum(['none', 'revoke']),
          reissuance_allowed: zod.boolean(),
          relational: zod.boolean(),
          stina_product_id: zod.string().optional(),
        }),
      ),
  )
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      department_id: zod.string().uuid(),
      collection_id: zod.string().uuid(),
      non_invoiced: zod
        .boolean()
        .describe(
          'Tickets issued under the claim are not billed. Only sysadmins can set it, through the tenant claim endpoints',
        ),
    }),
  );
export const deleteTenantCollectionTicketClaimsResponse = zod.array(
  deleteTenantCollectionTicketClaimsResponseItem,
);

/**
 * Get a list of all organizations for the current tenant
 * @summary List organizations
 */
export const listOrganizationsResponseOrganizationNumberRegExp = new RegExp(
  '^\\d{6}-\\d{4}$',
);

export const listOrganizationsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string(),
        organization_number: zod
          .string()
          .regex(listOrganizationsResponseOrganizationNumberRegExp),
        state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
        credit: zod.number().optional(),
        discount_codes: zod
          .record(
            zod.string(),
            zod.object({
              half_product: zod
                .string()
                .optional()
                .describe('Discount code for half product'),
              full_product: zod
                .string()
                .optional()
                .describe('Discount code for full product'),
            }),
          )
          .describe('Discount codes per collection type'),
        enabled_collection_types: zod
          .array(
            zod.enum([
              'school-transportation',
              'school-student-travel',
              'school-child-and-youth',
            ]),
          )
          .describe('Opt-in collection types enabled for this organization'),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
        selfmanaged_school_claims: zod
          .boolean()
          .optional()
          .describe(
            'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
          ),
      })
      .and(
        zod.object({
          is_internal: zod.boolean(),
        }),
      ),
  );
export const listOrganizationsResponse = zod.array(
  listOrganizationsResponseItem,
);

/**
 * Get the current users organization
 * @summary Get organization by id
 */
export const getOrganizationByIDParams = zod.object({
  organizationID: zod.string().uuid(),
});

export const getOrganizationByIDResponseOrganizationNumberRegExp = new RegExp(
  '^\\d{6}-\\d{4}$',
);

export const getOrganizationByIDResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string(),
        organization_number: zod
          .string()
          .regex(getOrganizationByIDResponseOrganizationNumberRegExp),
        state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
        credit: zod.number().optional(),
        discount_codes: zod
          .record(
            zod.string(),
            zod.object({
              half_product: zod
                .string()
                .optional()
                .describe('Discount code for half product'),
              full_product: zod
                .string()
                .optional()
                .describe('Discount code for full product'),
            }),
          )
          .describe('Discount codes per collection type'),
        enabled_collection_types: zod
          .array(
            zod.enum([
              'school-transportation',
              'school-student-travel',
              'school-child-and-youth',
            ]),
          )
          .describe('Opt-in collection types enabled for this organization'),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
        selfmanaged_school_claims: zod
          .boolean()
          .optional()
          .describe(
            'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
          ),
      })
      .and(
        zod.object({
          is_internal: zod.boolean(),
        }),
      ),
  );

/**
 * Update the current users organization
 * @summary Update organization by id
 */
export const updateOrganizationByIDParams = zod.object({
  organizationID: zod.string().uuid(),
});

export const updateOrganizationByIDBodyOrganizationNumberRegExp = new RegExp(
  '^\\d{6}-\\d{4}$',
);

export const updateOrganizationByIDBody = zod.object({
  name: zod.string(),
  organization_number: zod
    .string()
    .regex(updateOrganizationByIDBodyOrganizationNumberRegExp),
  state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
  credit: zod.number().optional(),
  discount_codes: zod
    .record(
      zod.string(),
      zod.object({
        half_product: zod
          .string()
          .optional()
          .describe('Discount code for half product'),
        full_product: zod
          .string()
          .optional()
          .describe('Discount code for full product'),
      }),
    )
    .describe('Discount codes per collection type'),
  enabled_collection_types: zod
    .array(
      zod.enum([
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
    )
    .describe('Opt-in collection types enabled for this organization'),
  gln: zod.string().optional(),
  einvoice_email: zod.string().email().optional(),
  selfmanaged_school_claims: zod
    .boolean()
    .optional()
    .describe(
      'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
    ),
});

export const updateOrganizationByIDResponseOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const updateOrganizationByIDResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string(),
        organization_number: zod
          .string()
          .regex(updateOrganizationByIDResponseOrganizationNumberRegExp),
        state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
        credit: zod.number().optional(),
        discount_codes: zod
          .record(
            zod.string(),
            zod.object({
              half_product: zod
                .string()
                .optional()
                .describe('Discount code for half product'),
              full_product: zod
                .string()
                .optional()
                .describe('Discount code for full product'),
            }),
          )
          .describe('Discount codes per collection type'),
        enabled_collection_types: zod
          .array(
            zod.enum([
              'school-transportation',
              'school-student-travel',
              'school-child-and-youth',
            ]),
          )
          .describe('Opt-in collection types enabled for this organization'),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
        selfmanaged_school_claims: zod
          .boolean()
          .optional()
          .describe(
            'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
          ),
      })
      .and(
        zod.object({
          is_internal: zod.boolean(),
        }),
      ),
  );

/**
 * Create a temporary admin user-profile for yourself
 * @summary Create a temporary admin user-profile for yourself
 */
export const impersonateOrganizationAdminParams = zod.object({
  organizationID: zod.string().uuid(),
});

export const impersonateOrganizationAdminResponse = zod.object({
  user_profile_id: zod.string().uuid(),
});

/**
 * Sets the allowed tags for the organization
 * @summary Set allowed tags
 */
export const setAllowedOrganizationTagsParams = zod.object({
  organizationID: zod.string().uuid(),
});

export const setAllowedOrganizationTagsBody = zod.object({
  collection_type: zod.enum([
    'master',
    'school-transportation',
    'school-student-travel',
    'school-child-and-youth',
  ]),
  tags: zod.array(zod.string().uuid()),
});

export const setAllowedOrganizationTagsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tag_id: zod.string(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    title: zod.string(),
    created_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      collection_type: zod.enum([
        'master',
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
    }),
  );
export const setAllowedOrganizationTagsResponse = zod.array(
  setAllowedOrganizationTagsResponseItem,
);

/**
 * Get the organization allowed tags
 * @summary Get allowed tags
 */
export const getAllowedOrganizationTagsParams = zod.object({
  organizationID: zod.string().uuid(),
});

export const getAllowedOrganizationTagsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tag_id: zod.string(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    title: zod.string(),
    created_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      collection_type: zod.enum([
        'master',
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
    }),
  );
export const getAllowedOrganizationTagsResponse = zod.array(
  getAllowedOrganizationTagsResponseItem,
);

/**
 * Sets the allowed offer groups for the organization
 * @summary Set allowed offer groups
 */
export const setAllowedOrganizationOfferGroupsParams = zod.object({
  organizationID: zod.string().uuid(),
});

export const setAllowedOrganizationOfferGroupsBody = zod.object({
  collection_type: zod.enum([
    'master',
    'school-transportation',
    'school-student-travel',
    'school-child-and-youth',
  ]),
  offers: zod.array(zod.string().uuid()),
});

export const setAllowedOrganizationOfferGroupsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    group_key: zod.string(),
    sales_channel: zod.enum(['corporate', 'school', 'benefit']),
    product_class: zod.string(),
    title: zod.string(),
    created_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      collection_type: zod.enum([
        'master',
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
    }),
  );
export const setAllowedOrganizationOfferGroupsResponse = zod.array(
  setAllowedOrganizationOfferGroupsResponseItem,
);

/**
 * Get the organization allowed offer groups
 * @summary Get allowed offer groups
 */
export const getAllowedOrganizationOfferGroupsParams = zod.object({
  organizationID: zod.string().uuid(),
});

export const getAllowedOrganizationOfferGroupsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    group_key: zod.string(),
    sales_channel: zod.enum(['corporate', 'school', 'benefit']),
    product_class: zod.string(),
    title: zod.string(),
    created_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      collection_type: zod.enum([
        'master',
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
    }),
  );
export const getAllowedOrganizationOfferGroupsResponse = zod.array(
  getAllowedOrganizationOfferGroupsResponseItem,
);

/**
 * Create a new payer with details
 * @summary Create payer with details
 */
export const createPayerWithDetailsParams = zod.object({
  organizationID: zod.string().uuid(),
});

export const createPayerWithDetailsBody = zod
  .object({
    address: zod.object({
      street: zod.string().min(1),
      zip_code: zod
        .string()
        .min(1)
        .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
      city: zod.string().min(1),
      care_of: zod
        .string()
        .min(1)
        .optional()
        .describe(
          "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
        ),
    }),
    reference: zod.string(),
  })
  .and(
    zod.object({
      details: zod.record(zod.string(), zod.string()),
    }),
  )
  .and(
    zod.object({
      department_id: zod.string().uuid().optional(),
    }),
  );

/**
 * Activate or inactivate an organization
 * @summary Update organization state
 */
export const patchOrganizationStateParams = zod.object({
  organizationID: zod.string().uuid(),
});

export const patchOrganizationStateBody = zod.object({
  state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
});

export const patchOrganizationStateResponseOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const patchOrganizationStateResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string(),
        organization_number: zod
          .string()
          .regex(patchOrganizationStateResponseOrganizationNumberRegExp),
        state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
        credit: zod.number().optional(),
        discount_codes: zod
          .record(
            zod.string(),
            zod.object({
              half_product: zod
                .string()
                .optional()
                .describe('Discount code for half product'),
              full_product: zod
                .string()
                .optional()
                .describe('Discount code for full product'),
            }),
          )
          .describe('Discount codes per collection type'),
        enabled_collection_types: zod
          .array(
            zod.enum([
              'school-transportation',
              'school-student-travel',
              'school-child-and-youth',
            ]),
          )
          .describe('Opt-in collection types enabled for this organization'),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
        selfmanaged_school_claims: zod
          .boolean()
          .optional()
          .describe(
            'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
          ),
      })
      .and(
        zod.object({
          is_internal: zod.boolean(),
        }),
      ),
  );

/**
 * Get the current users organization
 * @summary Get current organization
 */
export const getCurrentOrganizationResponseOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const getCurrentOrganizationResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string(),
        organization_number: zod
          .string()
          .regex(getCurrentOrganizationResponseOrganizationNumberRegExp),
        state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
        credit: zod.number().optional(),
        discount_codes: zod
          .record(
            zod.string(),
            zod.object({
              half_product: zod
                .string()
                .optional()
                .describe('Discount code for half product'),
              full_product: zod
                .string()
                .optional()
                .describe('Discount code for full product'),
            }),
          )
          .describe('Discount codes per collection type'),
        enabled_collection_types: zod
          .array(
            zod.enum([
              'school-transportation',
              'school-student-travel',
              'school-child-and-youth',
            ]),
          )
          .describe('Opt-in collection types enabled for this organization'),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
        selfmanaged_school_claims: zod
          .boolean()
          .optional()
          .describe(
            'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
          ),
      })
      .and(
        zod.object({
          is_internal: zod.boolean(),
        }),
      ),
  );

/**
 * Manually create a new organization
 * @summary Create organization manually
 */
export const createOrganizationManualBodyOrganizationNumberRegExp = new RegExp(
  '^\\d{6}-\\d{4}$',
);

export const createOrganizationManualBody = zod
  .object({
    name: zod.string(),
    organization_number: zod
      .string()
      .regex(createOrganizationManualBodyOrganizationNumberRegExp),
    state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
    credit: zod.number().optional(),
    discount_codes: zod
      .record(
        zod.string(),
        zod.object({
          half_product: zod
            .string()
            .optional()
            .describe('Discount code for half product'),
          full_product: zod
            .string()
            .optional()
            .describe('Discount code for full product'),
        }),
      )
      .describe('Discount codes per collection type'),
    enabled_collection_types: zod
      .array(
        zod.enum([
          'school-transportation',
          'school-student-travel',
          'school-child-and-youth',
        ]),
      )
      .describe('Opt-in collection types enabled for this organization'),
    gln: zod.string().optional(),
    einvoice_email: zod.string().email().optional(),
    selfmanaged_school_claims: zod
      .boolean()
      .optional()
      .describe(
        'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
      ),
  })
  .and(
    zod.object({
      is_internal: zod.boolean(),
    }),
  )
  .and(
    zod.object({
      enabled_collection_types: zod
        .array(
          zod.enum([
            'school-transportation',
            'school-student-travel',
            'school-child-and-youth',
          ]),
        )
        .describe('Opt-in collection types to enable for the new organization'),
      payer_details: zod.record(zod.string(), zod.string()),
      credit: zod.number().optional(),
      is_internal: zod.boolean(),
    }),
  )
  .and(
    zod.object({
      payer_address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
      payer_reference: zod.string(),
      delivery_address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
    }),
  );

export const createOrganizationManualResponseOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const createOrganizationManualResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string(),
        organization_number: zod
          .string()
          .regex(createOrganizationManualResponseOrganizationNumberRegExp),
        state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
        credit: zod.number().optional(),
        discount_codes: zod
          .record(
            zod.string(),
            zod.object({
              half_product: zod
                .string()
                .optional()
                .describe('Discount code for half product'),
              full_product: zod
                .string()
                .optional()
                .describe('Discount code for full product'),
            }),
          )
          .describe('Discount codes per collection type'),
        enabled_collection_types: zod
          .array(
            zod.enum([
              'school-transportation',
              'school-student-travel',
              'school-child-and-youth',
            ]),
          )
          .describe('Opt-in collection types enabled for this organization'),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
        selfmanaged_school_claims: zod
          .boolean()
          .optional()
          .describe(
            'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
          ),
      })
      .and(
        zod.object({
          is_internal: zod.boolean(),
        }),
      ),
  );

/**
 * Get the travellers per organization
 * @summary Get travellers per organization
 */
export const getTravellersPerOrganizationResponseTravellerNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const getTravellersPerOrganizationResponseTravellerPhoneRegExp =
  new RegExp('^\\+[1-9][0-9]{1,14}$');

export const getTravellersPerOrganizationResponseItem = zod.object({
  traveller: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        first_name: zod.string().optional(),
        last_name: zod.string().optional(),
        email: zod.string().optional(),
        national_identity_number: zod
          .string()
          .regex(
            getTravellersPerOrganizationResponseTravellerNationalIdentityNumberRegExp,
          )
          .optional(),
        phone: zod
          .string()
          .regex(getTravellersPerOrganizationResponseTravellerPhoneRegExp)
          .optional(),
        delivery_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
      }),
    )
    .and(
      zod.object({
        organization_id: zod
          .string()
          .uuid()
          .describe('The unique identifier of an organization\n'),
        anonymized_at: zod.string().datetime({}).optional(),
        deleted_at: zod
          .string()
          .datetime({})
          .optional()
          .describe(
            'When the traveller was deleted. The global search is the only\ntraveller endpoint that returns deleted travellers; every other\ntraveller endpoint excludes them.\n',
          ),
        bobcat_private_email: zod.string().email().optional(),
        bobcat_private_id: zod.string().optional(),
        bobcat_alltix_id: zod.string().optional(),
        favored_bobcat_bearer_id: zod.string().optional(),
        keywords: zod
          .array(zod.string())
          .describe(
            'Searchable keywords associated with the traveller, such as the\nnational identity numbers of people the traveller has purchased\ntickets for. Read-only — cannot be set through the API.\n',
          ),
      }),
    ),
  memberships: zod.array(
    zod.object({
      collection_member_id: zod.string().uuid(),
      collection_id: zod.string().uuid(),
      collection_name: zod.string(),
      collection_type: zod.enum([
        'master',
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
      department_id: zod.string().uuid(),
      department_name: zod.string(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
    }),
  ),
});
export const getTravellersPerOrganizationResponse = zod.array(
  getTravellersPerOrganizationResponseItem,
);

/**
 * Lists all users in the organization
 * @summary List organization users
 */
export const listOrganizationUsersResponseItem = zod.object({
  id: zod.string().uuid(),
  email: zod.string().email(),
  firstname: zod.string(),
  lastname: zod.string(),
  created_at: zod.string().datetime({}),
  updated_at: zod.string().datetime({}),
  user_profiles: zod.array(
    zod.object({
      id: zod.string().uuid(),
      email: zod.string().email(),
      tenant_id: zod.string(),
      tenant: zod.string(),
      role_id: zod.string().uuid(),
      role: zod.string(),
      active: zod.boolean(),
      organization_id: zod.string().uuid().optional(),
      organization: zod.string().optional(),
      last_used: zod.string().datetime({}).optional(),
      expires_at: zod.string().datetime({}).optional(),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    }),
  ),
});
export const listOrganizationUsersResponse = zod.array(
  listOrganizationUsersResponseItem,
);

/**
 * Get the user organization allowed offer groups
 * @summary Get user organization allowed offer groups
 */
export const getUserAllowedOrganizationOfferGroupsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    group_key: zod.string(),
    sales_channel: zod.enum(['corporate', 'school', 'benefit']),
    product_class: zod.string(),
    title: zod.string(),
    created_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      collection_type: zod.enum([
        'master',
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
    }),
  );
export const getUserAllowedOrganizationOfferGroupsResponse = zod.array(
  getUserAllowedOrganizationOfferGroupsResponseItem,
);

/**
 * Get the user organization allowed tags
 * @summary Get user organization allowed tags
 */
export const getUserAllowedOrganizationTagsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tag_id: zod.string(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    title: zod.string(),
    created_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      collection_type: zod.enum([
        'master',
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
    }),
  );
export const getUserAllowedOrganizationTagsResponse = zod.array(
  getUserAllowedOrganizationTagsResponseItem,
);

/**
 * Invite a organization user to the system.
 * @summary Invite a organization user
 */
export const inviteOrganizationUserBody = zod.object({
  email: zod.string().email(),
  first_name: zod.string(),
  last_name: zod.string(),
  user_type: zod.enum(['admin', 'bearer-manager', 'viewer']),
});

/**
 * Update organization user role as editor or viewer
 * @summary Update organization user role
 */
export const updateOrganizationUserRoleBody = zod.object({
  userID: zod
    .string()
    .uuid()
    .describe('ID of the user whose organization role should be updated'),
  type: zod
    .enum(['editor', 'bearer-manager', 'viewer'])
    .describe('The target organization role for the user'),
});

export const updateOrganizationUserRoleResponse = zod.object({
  id: zod.string().uuid(),
  email: zod.string().email(),
  firstname: zod.string(),
  lastname: zod.string(),
  created_at: zod.string().datetime({}),
  updated_at: zod.string().datetime({}),
  user_profiles: zod.array(
    zod.object({
      id: zod.string().uuid(),
      email: zod.string().email(),
      tenant_id: zod.string(),
      tenant: zod.string(),
      role_id: zod.string().uuid(),
      role: zod.string(),
      active: zod.boolean(),
      organization_id: zod.string().uuid().optional(),
      organization: zod.string().optional(),
      last_used: zod.string().datetime({}).optional(),
      expires_at: zod.string().datetime({}).optional(),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    }),
  ),
});

/**
 * Get a list of all organization applications for the current tenant
 * @summary List organization applications
 */

export const listOrganizationApplicationsResponseOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const listOrganizationApplicationsResponseContactPhoneMin = 8;

export const listOrganizationApplicationsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string().min(1),
        organization_number: zod
          .string()
          .regex(listOrganizationApplicationsResponseOrganizationNumberRegExp),
        contact_first_name: zod.string().min(1),
        contact_last_name: zod.string().min(1),
        contact_email: zod.string().email(),
        contact_phone: zod
          .string()
          .min(listOrganizationApplicationsResponseContactPhoneMin),
        invoicing_address: zod.object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        }),
        delivery_address: zod.object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        }),
        invoicing_reference: zod.string().min(1),
        suggested_cost_center: zod.string().optional(),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
      })
      .and(
        zod.object({
          tenant_id: zod
            .string()
            .describe(
              'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
            ),
        }),
      ),
  )
  .and(
    zod.object({
      status: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
      reason: zod
        .string()
        .optional()
        .describe('The reason for the application status'),
    }),
  );
export const listOrganizationApplicationsResponse = zod.array(
  listOrganizationApplicationsResponseItem,
);

/**
 * Update the selected organization application
 * @summary Update an organization application
 */
export const updateOrganizationApplicationParams = zod.object({
  organizationApplicationID: zod.string().uuid(),
});

export const updateOrganizationApplicationBodyOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const updateOrganizationApplicationBodyContactPhoneMin = 8;

export const updateOrganizationApplicationBody = zod.object({
  name: zod.string().min(1),
  organization_number: zod
    .string()
    .regex(updateOrganizationApplicationBodyOrganizationNumberRegExp),
  contact_first_name: zod.string().min(1),
  contact_last_name: zod.string().min(1),
  contact_email: zod.string().email(),
  contact_phone: zod
    .string()
    .min(updateOrganizationApplicationBodyContactPhoneMin),
  invoicing_address: zod.object({
    street: zod.string().min(1),
    zip_code: zod
      .string()
      .min(1)
      .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
    city: zod.string().min(1),
    care_of: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
      ),
  }),
  delivery_address: zod.object({
    street: zod.string().min(1),
    zip_code: zod
      .string()
      .min(1)
      .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
    city: zod.string().min(1),
    care_of: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
      ),
  }),
  invoicing_reference: zod.string().min(1),
  suggested_cost_center: zod.string().optional(),
  gln: zod.string().optional(),
  einvoice_email: zod.string().email().optional(),
});

export const updateOrganizationApplicationResponseOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const updateOrganizationApplicationResponseContactPhoneMin = 8;

export const updateOrganizationApplicationResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string().min(1),
        organization_number: zod
          .string()
          .regex(updateOrganizationApplicationResponseOrganizationNumberRegExp),
        contact_first_name: zod.string().min(1),
        contact_last_name: zod.string().min(1),
        contact_email: zod.string().email(),
        contact_phone: zod
          .string()
          .min(updateOrganizationApplicationResponseContactPhoneMin),
        invoicing_address: zod.object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        }),
        delivery_address: zod.object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        }),
        invoicing_reference: zod.string().min(1),
        suggested_cost_center: zod.string().optional(),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
      })
      .and(
        zod.object({
          tenant_id: zod
            .string()
            .describe(
              'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
            ),
        }),
      ),
  )
  .and(
    zod.object({
      status: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
      reason: zod
        .string()
        .optional()
        .describe('The reason for the application status'),
    }),
  );

/**
 * Approve the selected organization application
 * @summary Approve an organization application
 */
export const approveOrganizationApplicationParams = zod.object({
  organizationApplicationID: zod.string().uuid(),
});

export const approveOrganizationApplicationBody = zod.object({
  enabled_collection_types: zod
    .array(
      zod.enum([
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
    )
    .describe('Opt-in collection types to enable for the new organization'),
  payer_details: zod.record(zod.string(), zod.string()),
  credit: zod.number().optional(),
  is_internal: zod.boolean(),
});

export const approveOrganizationApplicationResponseOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const approveOrganizationApplicationResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string(),
        organization_number: zod
          .string()
          .regex(
            approveOrganizationApplicationResponseOrganizationNumberRegExp,
          ),
        state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
        credit: zod.number().optional(),
        discount_codes: zod
          .record(
            zod.string(),
            zod.object({
              half_product: zod
                .string()
                .optional()
                .describe('Discount code for half product'),
              full_product: zod
                .string()
                .optional()
                .describe('Discount code for full product'),
            }),
          )
          .describe('Discount codes per collection type'),
        enabled_collection_types: zod
          .array(
            zod.enum([
              'school-transportation',
              'school-student-travel',
              'school-child-and-youth',
            ]),
          )
          .describe('Opt-in collection types enabled for this organization'),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
        selfmanaged_school_claims: zod
          .boolean()
          .optional()
          .describe(
            'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
          ),
      })
      .and(
        zod.object({
          is_internal: zod.boolean(),
        }),
      ),
  );

/**
 * Reject the selected organization application
 * @summary Reject an organization application
 */
export const rejectOrganizationApplicationParams = zod.object({
  organizationApplicationID: zod.string().uuid(),
});

export const rejectOrganizationApplicationBody = zod.object({
  reason: zod.string().describe('The reason for rejecting the application'),
});

export const rejectOrganizationApplicationResponseOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const rejectOrganizationApplicationResponseContactPhoneMin = 8;

export const rejectOrganizationApplicationResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string().min(1),
        organization_number: zod
          .string()
          .regex(rejectOrganizationApplicationResponseOrganizationNumberRegExp),
        contact_first_name: zod.string().min(1),
        contact_last_name: zod.string().min(1),
        contact_email: zod.string().email(),
        contact_phone: zod
          .string()
          .min(rejectOrganizationApplicationResponseContactPhoneMin),
        invoicing_address: zod.object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        }),
        delivery_address: zod.object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        }),
        invoicing_reference: zod.string().min(1),
        suggested_cost_center: zod.string().optional(),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
      })
      .and(
        zod.object({
          tenant_id: zod
            .string()
            .describe(
              'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
            ),
        }),
      ),
  )
  .and(
    zod.object({
      status: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
      reason: zod
        .string()
        .optional()
        .describe('The reason for the application status'),
    }),
  );

/**
 * Get the departments as list
 * @summary Get departments as list
 */

export const getDepartmentsListResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      parent_id: zod.string().uuid().optional(),
      name: zod.string().min(1),
      organization_number: zod.string().optional(),
      delivery_address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
    }),
  )
  .and(
    zod.object({
      deleted_at: zod.string().datetime({}).optional(),
      organization_id: zod.string().uuid(),
      payer_id: zod.string().uuid().optional(),
    }),
  );
export const getDepartmentsListResponse = zod.array(
  getDepartmentsListResponseItem,
);

/**
 * @summary Create a department
 */

export const createDepartmentBody = zod.object({
  parent_id: zod.string().uuid().optional(),
  name: zod.string().min(1),
  organization_number: zod.string().optional(),
  delivery_address: zod.object({
    street: zod.string().min(1),
    zip_code: zod
      .string()
      .min(1)
      .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
    city: zod.string().min(1),
    care_of: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
      ),
  }),
});

/**
 * Returns the user's access privileges for all accessible departments in their organization
 * @summary Get user's department access levels
 */
export const getDepartmentsAccessResponseAccessibleDepartmentsMin = 0;

export const getDepartmentsAccessResponseViewerDepartmentsMin = 0;

export const getDepartmentsAccessResponseBearerManagerDepartmentsMin = 0;

export const getDepartmentsAccessResponseEditorDepartmentsMin = 0;

export const getDepartmentsAccessResponse = zod.object({
  accessible_departments: zod
    .number()
    .min(getDepartmentsAccessResponseAccessibleDepartmentsMin)
    .describe(
      'Count of departments with viewer, bearer-manager or editor access',
    ),
  viewer_departments: zod
    .number()
    .min(getDepartmentsAccessResponseViewerDepartmentsMin)
    .describe('Count of departments with viewer-level access'),
  bearer_manager_departments: zod
    .number()
    .min(getDepartmentsAccessResponseBearerManagerDepartmentsMin)
    .describe('Count of departments with bearer-manager-level access'),
  editor_departments: zod
    .number()
    .min(getDepartmentsAccessResponseEditorDepartmentsMin)
    .describe('Count of departments with editor-level access'),
  departments: zod
    .record(
      zod.string(),
      zod.object({
        parent_id: zod
          .string()
          .uuid()
          .nullish()
          .describe('UUID of the parent department, null for root departments'),
        access_level: zod
          .enum(['none', 'viewer', 'bearer-manager', 'editor'])
          .describe(
            'Access level for department resources. bearer-manager is viewer plus the bearer and card operations on travellers and tickets.',
          ),
        department_name: zod
          .string()
          .describe('Human-readable name of the department for UI display'),
      }),
    )
    .describe('Map of ALL department IDs to access information'),
});

/**
 * Get the department tree for the current organization
 * @summary Get department tree
 */
export const getCurrentDepartmentTreeResponse = zod.object({
  id: zod.string().uuid(),
  name: zod.string(),
  children: zod.array(zod.unknown()),
  admin: zod.boolean(),
  type: zod.enum([
    'master',
    'school-transportation',
    'school-student-travel',
    'school-child-and-youth',
  ]),
});

/**
 * Get the department by id
 * @summary Get department by id
 */
export const getDepartmentByIDParams = zod.object({
  departmentID: zod.string().uuid(),
});

export const getDepartmentByIDResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      parent_id: zod.string().uuid().optional(),
      name: zod.string().min(1),
      organization_number: zod.string().optional(),
      delivery_address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
    }),
  )
  .and(
    zod.object({
      deleted_at: zod.string().datetime({}).optional(),
      organization_id: zod.string().uuid(),
      payer_id: zod.string().uuid().optional(),
    }),
  );

/**
 * Update the selected department
 * @summary Update department by id
 */
export const updateDepartmentByIDParams = zod.object({
  departmentID: zod.string().uuid(),
});

export const updateDepartmentByIDBody = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      parent_id: zod.string().uuid().optional(),
      name: zod.string().min(1),
      organization_number: zod.string().optional(),
      delivery_address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
    }),
  )
  .and(
    zod.object({
      deleted_at: zod.string().datetime({}).optional(),
      organization_id: zod.string().uuid(),
      payer_id: zod.string().uuid().optional(),
    }),
  );

export const updateDepartmentByIDResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      parent_id: zod.string().uuid().optional(),
      name: zod.string().min(1),
      organization_number: zod.string().optional(),
      delivery_address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
    }),
  )
  .and(
    zod.object({
      deleted_at: zod.string().datetime({}).optional(),
      organization_id: zod.string().uuid(),
      payer_id: zod.string().uuid().optional(),
    }),
  );

/**
 * Delete the selected department
 * @summary Delete department by id
 */
export const deleteDepartmentByIDParams = zod.object({
  departmentID: zod.string().uuid(),
});

export const deleteDepartmentByIDResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      parent_id: zod.string().uuid().optional(),
      name: zod.string().min(1),
      organization_number: zod.string().optional(),
      delivery_address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
    }),
  )
  .and(
    zod.object({
      deleted_at: zod.string().datetime({}).optional(),
      organization_id: zod.string().uuid(),
      payer_id: zod.string().uuid().optional(),
    }),
  );

/**
 * Get all collections for the specified department
 * @summary Get collections for specific department
 */
export const getCollectionsForDepartmentParams = zod.object({
  departmentID: zod.string().uuid(),
});

export const getCollectionsForDepartmentResponseItem = zod.object({
  id: zod.string().uuid(),
  name: zod.string(),
  department_id: zod.string().uuid(),
  organization_id: zod.string().uuid(),
  tenant_id: zod.string(),
  valid_from: zod.string().datetime({}).optional(),
  valid_to: zod.string().datetime({}).optional(),
  updated_at: zod.string().datetime({}),
  created_at: zod.string().datetime({}),
  type: zod.string(),
  import_strategy: zod.string(),
});
export const getCollectionsForDepartmentResponse = zod.array(
  getCollectionsForDepartmentResponseItem,
);

/**
 * Returns all travellers for the specified department
 * @summary Get travellers per department
 */
export const getTravellersForDepartmentParams = zod.object({
  departmentID: zod.string().uuid(),
});

export const getTravellersForDepartmentResponseTravellerNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const getTravellersForDepartmentResponseTravellerPhoneRegExp =
  new RegExp('^\\+[1-9][0-9]{1,14}$');

export const getTravellersForDepartmentResponseItem = zod.object({
  traveller: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        first_name: zod.string().optional(),
        last_name: zod.string().optional(),
        email: zod.string().optional(),
        national_identity_number: zod
          .string()
          .regex(
            getTravellersForDepartmentResponseTravellerNationalIdentityNumberRegExp,
          )
          .optional(),
        phone: zod
          .string()
          .regex(getTravellersForDepartmentResponseTravellerPhoneRegExp)
          .optional(),
        delivery_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
      }),
    )
    .and(
      zod.object({
        organization_id: zod
          .string()
          .uuid()
          .describe('The unique identifier of an organization\n'),
        anonymized_at: zod.string().datetime({}).optional(),
        deleted_at: zod
          .string()
          .datetime({})
          .optional()
          .describe(
            'When the traveller was deleted. The global search is the only\ntraveller endpoint that returns deleted travellers; every other\ntraveller endpoint excludes them.\n',
          ),
        bobcat_private_email: zod.string().email().optional(),
        bobcat_private_id: zod.string().optional(),
        bobcat_alltix_id: zod.string().optional(),
        favored_bobcat_bearer_id: zod.string().optional(),
        keywords: zod
          .array(zod.string())
          .describe(
            'Searchable keywords associated with the traveller, such as the\nnational identity numbers of people the traveller has purchased\ntickets for. Read-only — cannot be set through the API.\n',
          ),
      }),
    ),
  memberships: zod.array(
    zod.object({
      collection_member_id: zod.string().uuid(),
      collection_id: zod.string().uuid(),
      collection_name: zod.string(),
      collection_type: zod.enum([
        'master',
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
      department_id: zod.string().uuid(),
      department_name: zod.string(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
    }),
  ),
});
export const getTravellersForDepartmentResponse = zod.array(
  getTravellersForDepartmentResponseItem,
);

/**
 * Returns payer for the specified department
 * @summary Get payer per department
 */
export const getPayerForDepartmentParams = zod.object({
  departmentID: zod.string().uuid(),
});

export const getPayerForDepartmentResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        id: zod.string().uuid(),
        tenant_id: zod
          .string()
          .describe(
            'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
          ),
        created_at: zod.string().datetime({}),
        updated_at: zod.string().datetime({}),
      })
      .and(
        zod.object({
          address: zod.object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          }),
          reference: zod.string(),
        }),
      )
      .and(
        zod.object({
          organization_id: zod.string().uuid(),
          details: zod.record(zod.string(), zod.string()),
        }),
      ),
  )
  .and(
    zod.object({
      is_direct_payer: zod.boolean(),
      department_name: zod.string(),
    }),
  );

/**
 * Updates information for the payer linked to a department
 * @summary Update payer for department
 */
export const updatePayerForDepartmentParams = zod.object({
  departmentID: zod.string().uuid(),
});

export const updatePayerForDepartmentBody = zod.object({
  address: zod.object({
    street: zod.string().min(1),
    zip_code: zod
      .string()
      .min(1)
      .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
    city: zod.string().min(1),
    care_of: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
      ),
  }),
  reference: zod.string(),
});

export const updatePayerForDepartmentResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        id: zod.string().uuid(),
        tenant_id: zod
          .string()
          .describe(
            'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
          ),
        created_at: zod.string().datetime({}),
        updated_at: zod.string().datetime({}),
      })
      .and(
        zod.object({
          address: zod.object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          }),
          reference: zod.string(),
        }),
      )
      .and(
        zod.object({
          organization_id: zod.string().uuid(),
          details: zod.record(zod.string(), zod.string()),
        }),
      ),
  )
  .and(
    zod.object({
      is_direct_payer: zod.boolean(),
      department_name: zod.string(),
    }),
  );

/**
 * Returns users for a specific department
 * @summary Get users for department
 */
export const getUsersForDepartmentParams = zod.object({
  departmentID: zod.string().uuid(),
});

export const getUsersForDepartmentResponseItem = zod
  .object({
    id: zod.string().uuid(),
    email: zod.string().email(),
    firstname: zod.string(),
    lastname: zod.string(),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    user_profiles: zod.array(
      zod.object({
        id: zod.string().uuid(),
        email: zod.string().email(),
        tenant_id: zod.string(),
        tenant: zod.string(),
        role_id: zod.string().uuid(),
        role: zod.string(),
        active: zod.boolean(),
        organization_id: zod.string().uuid().optional(),
        organization: zod.string().optional(),
        last_used: zod.string().datetime({}).optional(),
        expires_at: zod.string().datetime({}).optional(),
        created_at: zod.string().datetime({}),
        updated_at: zod.string().datetime({}),
      }),
    ),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid().describe('The ID of the department'),
      access_level: zod
        .enum(['none', 'viewer', 'bearer-manager', 'editor'])
        .describe(
          'Access level for department resources. bearer-manager is viewer plus the bearer and card operations on travellers and tickets.',
        ),
    }),
  );
export const getUsersForDepartmentResponse = zod.array(
  getUsersForDepartmentResponseItem,
);

/**
 * Removes a user from a specific department.
 * @summary Delete User from Department
 */
export const deleteDepartmentUserParams = zod.object({
  departmentID: zod.string().uuid(),
  userID: zod.string().uuid(),
});

/**
 * Get a department user and their departments
 * @summary Get department user with departments
 */
export const getDepartmentUserWithDepartmentsParams = zod.object({
  id: zod.string().uuid().describe('department user ID'),
});

export const getDepartmentUserWithDepartmentsResponse = zod
  .object({
    id: zod.string().uuid(),
    email: zod.string().email(),
    firstname: zod.string(),
    lastname: zod.string(),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    user_profiles: zod.array(
      zod.object({
        id: zod.string().uuid(),
        email: zod.string().email(),
        tenant_id: zod.string(),
        tenant: zod.string(),
        role_id: zod.string().uuid(),
        role: zod.string(),
        active: zod.boolean(),
        organization_id: zod.string().uuid().optional(),
        organization: zod.string().optional(),
        last_used: zod.string().datetime({}).optional(),
        expires_at: zod.string().datetime({}).optional(),
        created_at: zod.string().datetime({}),
        updated_at: zod.string().datetime({}),
      }),
    ),
  })
  .and(
    zod.object({
      departments: zod
        .array(
          zod.object({
            department_id: zod.string().uuid().optional(),
            name: zod.string().optional(),
            access_level: zod
              .enum(['none', 'viewer', 'bearer-manager', 'editor'])
              .optional()
              .describe(
                'Access level for department resources. bearer-manager is viewer plus the bearer and card operations on travellers and tickets.',
              ),
          }),
        )
        .optional(),
    }),
  );

/**
 * Returns users in departments the current user has access to
 * @summary List department users
 */
export const getDepartmentUsersResponseItem = zod
  .object({
    id: zod.string().uuid(),
    email: zod.string().email(),
    firstname: zod.string(),
    lastname: zod.string(),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    user_profiles: zod.array(
      zod.object({
        id: zod.string().uuid(),
        email: zod.string().email(),
        tenant_id: zod.string(),
        tenant: zod.string(),
        role_id: zod.string().uuid(),
        role: zod.string(),
        active: zod.boolean(),
        organization_id: zod.string().uuid().optional(),
        organization: zod.string().optional(),
        last_used: zod.string().datetime({}).optional(),
        expires_at: zod.string().datetime({}).optional(),
        created_at: zod.string().datetime({}),
        updated_at: zod.string().datetime({}),
      }),
    ),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid().describe('The ID of the department'),
      access_level: zod
        .enum(['none', 'viewer', 'bearer-manager', 'editor'])
        .describe(
          'Access level for department resources. bearer-manager is viewer plus the bearer and card operations on travellers and tickets.',
        ),
    }),
  );
export const getDepartmentUsersResponse = zod.array(
  getDepartmentUsersResponseItem,
);

/**
 * Creates a new invitation to a user to a department
 * @summary Invite a user to a department
 */
export const inviteUserToDepartmentBody = zod.object({
  email: zod.string().email(),
  firstname: zod.string(),
  lastname: zod.string(),
  department_id: zod.string().uuid(),
  access_level: zod
    .enum(['none', 'viewer', 'bearer-manager', 'editor'])
    .describe(
      'Access level for department resources. bearer-manager is viewer plus the bearer and card operations on travellers and tickets.',
    ),
});

/**
 * @summary Update department user
 */
export const updateDepartmentUserParams = zod.object({
  id: zod.string().uuid(),
});

export const updateDepartmentUserBody = zod.object({
  userID: zod.string().uuid(),
  departmentID: zod.string().uuid(),
  access_level: zod
    .enum(['none', 'viewer', 'bearer-manager', 'editor'])
    .describe(
      'Access level for department resources. bearer-manager is viewer plus the bearer and card operations on travellers and tickets.',
    ),
});

export const updateDepartmentUserResponse = zod.object({
  userID: zod.string().uuid(),
  departmentID: zod.string().uuid(),
  access_level: zod
    .enum(['none', 'viewer', 'bearer-manager', 'editor'])
    .describe(
      'Access level for department resources. bearer-manager is viewer plus the bearer and card operations on travellers and tickets.',
    ),
});

/**
 * Get traveller by id
 * @summary Get traveller by id
 */
export const getTravellerByIDParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const getTravellerByIDResponseTravellerNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const getTravellerByIDResponseTravellerPhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const getTravellerByIDResponse = zod.object({
  traveller: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        first_name: zod.string().optional(),
        last_name: zod.string().optional(),
        email: zod.string().optional(),
        national_identity_number: zod
          .string()
          .regex(getTravellerByIDResponseTravellerNationalIdentityNumberRegExp)
          .optional(),
        phone: zod
          .string()
          .regex(getTravellerByIDResponseTravellerPhoneRegExp)
          .optional(),
        delivery_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
      }),
    )
    .and(
      zod.object({
        organization_id: zod
          .string()
          .uuid()
          .describe('The unique identifier of an organization\n'),
        anonymized_at: zod.string().datetime({}).optional(),
        deleted_at: zod
          .string()
          .datetime({})
          .optional()
          .describe(
            'When the traveller was deleted. The global search is the only\ntraveller endpoint that returns deleted travellers; every other\ntraveller endpoint excludes them.\n',
          ),
        bobcat_private_email: zod.string().email().optional(),
        bobcat_private_id: zod.string().optional(),
        bobcat_alltix_id: zod.string().optional(),
        favored_bobcat_bearer_id: zod.string().optional(),
        keywords: zod
          .array(zod.string())
          .describe(
            'Searchable keywords associated with the traveller, such as the\nnational identity numbers of people the traveller has purchased\ntickets for. Read-only — cannot be set through the API.\n',
          ),
      }),
    ),
  memberships: zod.array(
    zod.object({
      collection_member_id: zod.string().uuid(),
      collection_id: zod.string().uuid(),
      collection_name: zod.string(),
      collection_type: zod.enum([
        'master',
        'school-transportation',
        'school-student-travel',
        'school-child-and-youth',
      ]),
      department_id: zod.string().uuid(),
      department_name: zod.string(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
    }),
  ),
});

/**
 * Update a traveller by ID. Depending on the traveller's memberships, some fields are optionally required:
- `email` is required for members of collection types:
    - `master`
    - `default`
- `national_identity_number` is required for members of collection types
  - `school-transportation`
  - `school-student-travel`
  - `school-child-and-youth`

 * @summary Update traveller
 */
export const updateTravellerByIDParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const updateTravellerByIDBodyNationalIdentityNumberRegExp = new RegExp(
  '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
);
export const updateTravellerByIDBodyPhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const updateTravellerByIDBody = zod.object({
  first_name: zod.string().optional(),
  last_name: zod.string().optional(),
  email: zod.string().optional(),
  national_identity_number: zod
    .string()
    .regex(updateTravellerByIDBodyNationalIdentityNumberRegExp)
    .optional(),
  phone: zod.string().regex(updateTravellerByIDBodyPhoneRegExp).optional(),
  delivery_address: zod
    .object({
      street: zod.string().min(1),
      zip_code: zod
        .string()
        .min(1)
        .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
      city: zod.string().min(1),
      care_of: zod
        .string()
        .min(1)
        .optional()
        .describe(
          "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
        ),
    })
    .optional(),
});

export const updateTravellerByIDResponseNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const updateTravellerByIDResponsePhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const updateTravellerByIDResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      first_name: zod.string().optional(),
      last_name: zod.string().optional(),
      email: zod.string().optional(),
      national_identity_number: zod
        .string()
        .regex(updateTravellerByIDResponseNationalIdentityNumberRegExp)
        .optional(),
      phone: zod
        .string()
        .regex(updateTravellerByIDResponsePhoneRegExp)
        .optional(),
      delivery_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      anonymized_at: zod.string().datetime({}).optional(),
      deleted_at: zod
        .string()
        .datetime({})
        .optional()
        .describe(
          'When the traveller was deleted. The global search is the only\ntraveller endpoint that returns deleted travellers; every other\ntraveller endpoint excludes them.\n',
        ),
      bobcat_private_email: zod.string().email().optional(),
      bobcat_private_id: zod.string().optional(),
      bobcat_alltix_id: zod.string().optional(),
      favored_bobcat_bearer_id: zod.string().optional(),
      keywords: zod
        .array(zod.string())
        .describe(
          'Searchable keywords associated with the traveller, such as the\nnational identity numbers of people the traveller has purchased\ntickets for. Read-only — cannot be set through the API.\n',
        ),
    }),
  );

/**
 * Every card assigned to the traveller in the user's organization, newest first, including cards since released. Requires view access to the traveller. Returns 404 if the traveller is not in the organization.
 * @summary Get a traveller's card history
 */
export const getTravellerCardHistoryParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const getTravellerCardHistoryResponseItem = zod
  .object({
    card_serial: zod.string().describe('card serial number'),
    type: zod.enum(['travelcard', 'walletcard', 'schoolcard']),
    organization_id: zod.string().uuid(),
    traveller_id: zod
      .string()
      .uuid()
      .optional()
      .describe(
        'Absent for a wallet card that is not tied to a collection member',
      ),
    bobcat_mtb_bearer_id: zod.string(),
    assigned_at: zod.string().datetime({}),
    released_at: zod
      .string()
      .datetime({})
      .optional()
      .describe('Absent while the card is still assigned'),
  })
  .describe('One period during which a card was assigned.');
export const getTravellerCardHistoryResponse = zod.array(
  getTravellerCardHistoryResponseItem,
);

/**
 * @summary Get traveller bearers
 */
export const getTravellerBearersParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const getTravellerBearersResponse = zod.object({
  alltix_bearers: zod.array(
    zod.object({
      id: zod.string(),
      type: zod.enum(['other', 'paper', 'smartcard', 'smartphone']).optional(),
      name: zod.string().optional(),
      default: zod.boolean().optional(),
      serial: zod.string().optional(),
    }),
  ),
  private_bearers: zod.array(
    zod.object({
      id: zod.string(),
      type: zod.enum(['other', 'paper', 'smartcard', 'smartphone']).optional(),
      name: zod.string().optional(),
      default: zod.boolean().optional(),
      serial: zod.string().optional(),
    }),
  ),
});

/**
 * Set the bearer that new tickets are issued against for this traveller. The bearer must belong to the traveller in bobcat and must not be blocked.
 * @summary Set the traveller favored bearer
 */
export const setTravellerFavoredBearerParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const setTravellerFavoredBearerBody = zod
  .object({
    mtb_bearer_id: zod
      .string()
      .min(1)
      .describe(
        "ID of the bobcat mtb bearer to favor. Must be an unblocked bearer belonging to the traveller's alltix or private bobcat traveller.",
      ),
  })
  .describe('Set the favored bearer for a traveller');

/**
 * Clear the favored bearer for this traveller
 * @summary Clear the traveller favored bearer
 */
export const clearTravellerFavoredBearerParams = zod.object({
  travellerID: zod.string().uuid(),
});

/**
 * Link a private bobcat account to the Traveller
 * @summary Link a private bobcat account to the Traveller
 */
export const linkTravellerBobcatAccountParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const linkTravellerBobcatAccountBody = zod.object({
  bobcat_private_email: zod.string().email().optional(),
});

export const linkTravellerBobcatAccountResponseNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const linkTravellerBobcatAccountResponsePhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const linkTravellerBobcatAccountResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      first_name: zod.string().optional(),
      last_name: zod.string().optional(),
      email: zod.string().optional(),
      national_identity_number: zod
        .string()
        .regex(linkTravellerBobcatAccountResponseNationalIdentityNumberRegExp)
        .optional(),
      phone: zod
        .string()
        .regex(linkTravellerBobcatAccountResponsePhoneRegExp)
        .optional(),
      delivery_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      anonymized_at: zod.string().datetime({}).optional(),
      deleted_at: zod
        .string()
        .datetime({})
        .optional()
        .describe(
          'When the traveller was deleted. The global search is the only\ntraveller endpoint that returns deleted travellers; every other\ntraveller endpoint excludes them.\n',
        ),
      bobcat_private_email: zod.string().email().optional(),
      bobcat_private_id: zod.string().optional(),
      bobcat_alltix_id: zod.string().optional(),
      favored_bobcat_bearer_id: zod.string().optional(),
      keywords: zod
        .array(zod.string())
        .describe(
          'Searchable keywords associated with the traveller, such as the\nnational identity numbers of people the traveller has purchased\ntickets for. Read-only — cannot be set through the API.\n',
        ),
    }),
  );

/**
 * Replaces the traveller's school card with a blank card, for the lost-card case handled by customer service. The new card must be unclaimed here and carry no bearer in bobcat. Any active products move from the old card to the new one, the traveller's issued card is swapped in place, and the old bearer is destroyed in bobcat. A blocked (blacklisted) old bearer is left in place — bobcat refuses to delete it — and the swap proceeds without moving products. The operation is idempotent: replaying it after a partial failure resumes from wherever the previous attempt stopped. Cards of other types the traveller holds are left alone. Returns 404 if the traveller holds no cards at all, and 409 if they hold cards but no single replaceable school card, if a card transfer is already in flight, or if the replacement card is blocked (blacklisted).
 * @summary Replace a Traveller's school card
 */
export const travellerReplaceSchoolCardParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const travellerReplaceSchoolCardBodyCardSerialRegExp = new RegExp(
  '^[0-9]+$',
);

export const travellerReplaceSchoolCardBody = zod
  .object({
    card_serial: zod
      .string()
      .regex(travellerReplaceSchoolCardBodyCardSerialRegExp),
  })
  .describe("Request to replace a traveller's school card with a blank one");

export const travellerReplaceSchoolCardResponseLabelMax = 100;

export const travellerReplaceSchoolCardResponse = zod.object({
  card_serial: zod.string(),
  bearer_id: zod.string(),
  label: zod
    .string()
    .max(travellerReplaceSchoolCardResponseLabelMax)
    .optional(),
});

/**
 * Import travellers from JSOn data
 * @summary Import travellers
 */

export const importTravellersBody = zod.object({
  departmentID: zod
    .string()
    .uuid()
    .optional()
    .describe(
      'Optional. If provided, the travellers will be imported into this department.',
    ),
  travellers: zod
    .array(
      zod.object({
        first_name: zod.string().optional(),
        last_name: zod.string().optional(),
        email: zod.string(),
        national_identity_number: zod.string().optional(),
        phone: zod.string().optional(),
        department: zod
          .string()
          .optional()
          .describe(
            'Optional. If provided, the traveller will be imported into this department.',
          ),
      }),
    )
    .min(1)
    .describe('The travellers to import.'),
});

export const importTravellersResponse = zod.object({
  total_rows: zod
    .number()
    .describe('The total number of rows in the import file'),
  successful: zod.number().describe('The number of successful rows'),
  failed: zod.number().describe('The number of failed/skipped rows'),
  failures: zod
    .array(
      zod.object({
        row_number: zod
          .number()
          .describe('The row number in the file (1-indexed, excluding header)'),
        data: zod.object({
          first_name: zod.string().optional(),
          last_name: zod.string().optional(),
          email: zod.string(),
          national_identity_number: zod.string().optional(),
          phone: zod.string().optional(),
          department: zod
            .string()
            .optional()
            .describe(
              'Optional. If provided, the traveller will be imported into this department.',
            ),
        }),
        reasons: zod
          .array(zod.string())
          .describe('The reasons for the failure'),
      }),
    )
    .describe('Details of all failed/skipped rows'),
});

/**
 * @summary Check email availability
 */
export const isTravellerEmailAvailableQueryParams = zod.object({
  email: zod.string().email(),
});

export const isTravellerEmailAvailableResponse = zod.object({
  available: zod.boolean(),
});

/**
 * Autocomplete search for travellers
 * @summary Autocomplete search for travellers
 */
export const travellerGlobalSearchQueryParams = zod.object({
  q: zod.string().describe('search string'),
});

export const travellerGlobalSearchResponseTravellerNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const travellerGlobalSearchResponseTravellerPhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const travellerGlobalSearchResponseItem = zod.object({
  traveller: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        first_name: zod.string().optional(),
        last_name: zod.string().optional(),
        email: zod.string().optional(),
        national_identity_number: zod
          .string()
          .regex(
            travellerGlobalSearchResponseTravellerNationalIdentityNumberRegExp,
          )
          .optional(),
        phone: zod
          .string()
          .regex(travellerGlobalSearchResponseTravellerPhoneRegExp)
          .optional(),
        delivery_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
      }),
    )
    .and(
      zod.object({
        organization_id: zod
          .string()
          .uuid()
          .describe('The unique identifier of an organization\n'),
        anonymized_at: zod.string().datetime({}).optional(),
        deleted_at: zod
          .string()
          .datetime({})
          .optional()
          .describe(
            'When the traveller was deleted. The global search is the only\ntraveller endpoint that returns deleted travellers; every other\ntraveller endpoint excludes them.\n',
          ),
        bobcat_private_email: zod.string().email().optional(),
        bobcat_private_id: zod.string().optional(),
        bobcat_alltix_id: zod.string().optional(),
        favored_bobcat_bearer_id: zod.string().optional(),
        keywords: zod
          .array(zod.string())
          .describe(
            'Searchable keywords associated with the traveller, such as the\nnational identity numbers of people the traveller has purchased\ntickets for. Read-only — cannot be set through the API.\n',
          ),
      }),
    ),
  travelcards: zod.array(
    zod.object({
      card_serial: zod.string().describe('card serial number'),
    }),
  ),
  walletcards: zod.array(
    zod.object({
      card_serial: zod.string().describe('card serial number'),
    }),
  ),
  schoolcards: zod.array(
    zod.object({
      card_serial: zod.string().describe('card serial number'),
    }),
  ),
});
export const travellerGlobalSearchResponse = zod.array(
  travellerGlobalSearchResponseItem,
);

/**
 * Get a list of all payers for the current organizations
 * @summary List payers
 */

export const listPayersResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
      reference: zod.string(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod.string().uuid(),
      details: zod.record(zod.string(), zod.string()),
    }),
  );
export const listPayersResponse = zod.array(listPayersResponseItem);

/**
 * Create a new payer
 * @summary Create payer
 */

export const createPayerBody = zod
  .object({
    address: zod.object({
      street: zod.string().min(1),
      zip_code: zod
        .string()
        .min(1)
        .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
      city: zod.string().min(1),
      care_of: zod
        .string()
        .min(1)
        .optional()
        .describe(
          "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
        ),
    }),
    reference: zod.string(),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
    }),
  );

/**
 * Get the payer by id
 * @summary Get payer by id
 */
export const getPayerByIDParams = zod.object({
  payerID: zod.string().uuid(),
});

export const getPayerByIDResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
      reference: zod.string(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod.string().uuid(),
      details: zod.record(zod.string(), zod.string()),
    }),
  );

/**
 * Update the selected payer
 * @summary Update payer by id
 */
export const updatePayerByIDParams = zod.object({
  payerID: zod.string().uuid(),
});

export const updatePayerByIDBody = zod.object({
  address: zod.object({
    street: zod.string().min(1),
    zip_code: zod
      .string()
      .min(1)
      .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
    city: zod.string().min(1),
    care_of: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
      ),
  }),
  reference: zod.string(),
});

export const updatePayerByIDResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
      reference: zod.string(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod.string().uuid(),
      details: zod.record(zod.string(), zod.string()),
    }),
  );

/**
 * Creates a new collection member (traveller).

Supplying card_serial additionally claims a blank school card for the member, so they can be ticketed immediately instead of waiting for a card to be ordered from Areff. Only school collections accept it, and only for a traveller who holds no issued card at all: a traveller who already has one, delivered or merely ordered, is a conflict, as is a student whose card transfer from another school is still in flight. The card must be unclaimed here and carry no bearer in bobcat belonging to anyone else. The member is created inactive and becomes active in the same transaction that records the card, so a partial failure can never leave a member that gets a second card ordered for them. The operation is idempotent: replaying it after a partial failure resumes from wherever the previous attempt stopped.
 * @summary Create a new collection member (traveller)
 */

export const createCollectionMemberBodyNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const createCollectionMemberBodyPhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const createCollectionMemberBodyCardSerialRegExp = new RegExp(
  '^[0-9]+$',
);

export const createCollectionMemberBody = zod
  .object({
    collection_id: zod.string().uuid(),
    guardian1_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
    guardian1_email: zod.string().email().optional(),
    guardian2_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
    guardian2_email: zod.string().email().optional(),
    school_name: zod.string().optional(),
    school_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    school_bus_stop: zod.string().optional().describe('Bus stop name'),
    half_product: zod.boolean(),
  })
  .and(
    zod.object({
      first_name: zod.string().optional(),
      last_name: zod.string().optional(),
      email: zod.string().optional(),
      national_identity_number: zod
        .string()
        .regex(createCollectionMemberBodyNationalIdentityNumberRegExp)
        .optional(),
      phone: zod
        .string()
        .regex(createCollectionMemberBodyPhoneRegExp)
        .optional(),
      delivery_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
    }),
  )
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
    }),
  )
  .and(
    zod.object({
      card_serial: zod
        .string()
        .regex(createCollectionMemberBodyCardSerialRegExp)
        .optional(),
    }),
  );

/**
 * Creates new student travel collection members
 * @summary Create new student travel collection members
 */

export const createStudentTravelCollectionMembersBodyNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const createStudentTravelCollectionMembersBodyPhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const createStudentTravelCollectionMembersBodyItem = zod
  .object({
    collection_id: zod.string().uuid(),
    guardian1_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
    guardian1_email: zod.string().email().optional(),
    guardian2_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
    guardian2_email: zod.string().email().optional(),
    school_name: zod.string().optional(),
    school_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    school_bus_stop: zod.string().optional().describe('Bus stop name'),
    half_product: zod.boolean(),
  })
  .and(
    zod.object({
      first_name: zod.string().optional(),
      last_name: zod.string().optional(),
      email: zod.string().optional(),
      national_identity_number: zod
        .string()
        .regex(
          createStudentTravelCollectionMembersBodyNationalIdentityNumberRegExp,
        )
        .optional(),
      phone: zod
        .string()
        .regex(createStudentTravelCollectionMembersBodyPhoneRegExp)
        .optional(),
      delivery_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
    }),
  )
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
    }),
  )
  .and(zod.union([zod.unknown(), zod.unknown()]))
  .and(zod.union([zod.unknown(), zod.unknown()]));
export const createStudentTravelCollectionMembersBody = zod
  .array(createStudentTravelCollectionMembersBodyItem)
  .min(1);

export const createStudentTravelCollectionMembersResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
      guardian1_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian1_email: zod.string().email().optional(),
      guardian2_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian2_email: zod.string().email().optional(),
      school_name: zod.string().optional(),
      school_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      school_bus_stop: zod.string().optional().describe('Bus stop name'),
      half_product: zod.boolean(),
    }),
  )
  .and(
    zod.object({
      manually_modified: zod.boolean(),
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      traveller_id: zod.string().uuid(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
      inactivated_at: zod.string().datetime({}).optional(),
      anonymized_at: zod.string().datetime({}).optional(),
    }),
  );
export const createStudentTravelCollectionMembersResponse = zod.array(
  createStudentTravelCollectionMembersResponseItem,
);

/**
 * Creates new school transportation collection members
 * @summary Create new school transportation collection members
 */

export const createSchoolTransportationCollectionMembersBodyNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const createSchoolTransportationCollectionMembersBodyPhoneRegExp =
  new RegExp('^\\+[1-9][0-9]{1,14}$');

export const createSchoolTransportationCollectionMembersBodyItem = zod
  .object({
    collection_id: zod.string().uuid(),
    guardian1_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
    guardian1_email: zod.string().email().optional(),
    guardian2_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
    guardian2_email: zod.string().email().optional(),
    school_name: zod.string().optional(),
    school_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    school_bus_stop: zod.string().optional().describe('Bus stop name'),
    half_product: zod.boolean(),
  })
  .and(
    zod.object({
      first_name: zod.string().optional(),
      last_name: zod.string().optional(),
      email: zod.string().optional(),
      national_identity_number: zod
        .string()
        .regex(
          createSchoolTransportationCollectionMembersBodyNationalIdentityNumberRegExp,
        )
        .optional(),
      phone: zod
        .string()
        .regex(createSchoolTransportationCollectionMembersBodyPhoneRegExp)
        .optional(),
      delivery_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
    }),
  )
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
    }),
  )
  .and(zod.union([zod.unknown(), zod.unknown()]))
  .and(zod.union([zod.unknown(), zod.unknown()]));
export const createSchoolTransportationCollectionMembersBody = zod
  .array(createSchoolTransportationCollectionMembersBodyItem)
  .min(1);

export const createSchoolTransportationCollectionMembersResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
      guardian1_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian1_email: zod.string().email().optional(),
      guardian2_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian2_email: zod.string().email().optional(),
      school_name: zod.string().optional(),
      school_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      school_bus_stop: zod.string().optional().describe('Bus stop name'),
      half_product: zod.boolean(),
    }),
  )
  .and(
    zod.object({
      manually_modified: zod.boolean(),
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      traveller_id: zod.string().uuid(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
      inactivated_at: zod.string().datetime({}).optional(),
      anonymized_at: zod.string().datetime({}).optional(),
    }),
  );
export const createSchoolTransportationCollectionMembersResponse = zod.array(
  createSchoolTransportationCollectionMembersResponseItem,
);

/**
 * Creates new child and youth collection members
 * @summary Create new child and youth collection members
 */

export const createChildAndYouthCollectionMembersBodyNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const createChildAndYouthCollectionMembersBodyPhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const createChildAndYouthCollectionMembersBodyItem = zod
  .object({
    collection_id: zod.string().uuid(),
    guardian1_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
    guardian1_email: zod.string().email().optional(),
    guardian2_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
    guardian2_email: zod.string().email().optional(),
    school_name: zod.string().optional(),
    school_address: zod
      .object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      })
      .optional(),
    school_bus_stop: zod.string().optional().describe('Bus stop name'),
    half_product: zod.boolean(),
  })
  .and(
    zod.object({
      first_name: zod.string().optional(),
      last_name: zod.string().optional(),
      email: zod.string().optional(),
      national_identity_number: zod
        .string()
        .regex(
          createChildAndYouthCollectionMembersBodyNationalIdentityNumberRegExp,
        )
        .optional(),
      phone: zod
        .string()
        .regex(createChildAndYouthCollectionMembersBodyPhoneRegExp)
        .optional(),
      delivery_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
    }),
  )
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
    }),
  )
  .and(zod.unknown());
export const createChildAndYouthCollectionMembersBody = zod
  .array(createChildAndYouthCollectionMembersBodyItem)
  .min(1);

export const createChildAndYouthCollectionMembersResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
      guardian1_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian1_email: zod.string().email().optional(),
      guardian2_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian2_email: zod.string().email().optional(),
      school_name: zod.string().optional(),
      school_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      school_bus_stop: zod.string().optional().describe('Bus stop name'),
      half_product: zod.boolean(),
    }),
  )
  .and(
    zod.object({
      manually_modified: zod.boolean(),
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      traveller_id: zod.string().uuid(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
      inactivated_at: zod.string().datetime({}).optional(),
      anonymized_at: zod.string().datetime({}).optional(),
    }),
  );
export const createChildAndYouthCollectionMembersResponse = zod.array(
  createChildAndYouthCollectionMembersResponseItem,
);

/**
 * Delete collection member, if it is the last reference to its traveller, also deletes the traveller
 * @summary Delete collection member by id
 */
export const deleteCollectionMemberByIDParams = zod.object({
  collectionMemberID: zod.string().uuid(),
});

export const deleteCollectionMemberByIDResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
      guardian1_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian1_email: zod.string().email().optional(),
      guardian2_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian2_email: zod.string().email().optional(),
      school_name: zod.string().optional(),
      school_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      school_bus_stop: zod.string().optional().describe('Bus stop name'),
      half_product: zod.boolean(),
    }),
  )
  .and(
    zod.object({
      manually_modified: zod.boolean(),
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      traveller_id: zod.string().uuid(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
      inactivated_at: zod.string().datetime({}).optional(),
      anonymized_at: zod.string().datetime({}).optional(),
    }),
  );

/**
 * Update collection member by id
 * @summary Update collection member by id
 */
export const updateCollectionMemberParams = zod.object({
  collectionMemberID: zod.string().uuid(),
});

export const updateCollectionMemberBody = zod.object({
  collection_id: zod.string().uuid(),
  guardian1_address: zod
    .object({
      street: zod.string().min(1),
      zip_code: zod
        .string()
        .min(1)
        .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
      city: zod.string().min(1),
      care_of: zod
        .string()
        .min(1)
        .optional()
        .describe(
          "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
        ),
    })
    .optional(),
  guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
  guardian1_email: zod.string().email().optional(),
  guardian2_address: zod
    .object({
      street: zod.string().min(1),
      zip_code: zod
        .string()
        .min(1)
        .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
      city: zod.string().min(1),
      care_of: zod
        .string()
        .min(1)
        .optional()
        .describe(
          "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
        ),
    })
    .optional(),
  guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
  guardian2_email: zod.string().email().optional(),
  school_name: zod.string().optional(),
  school_address: zod
    .object({
      street: zod.string().min(1),
      zip_code: zod
        .string()
        .min(1)
        .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
      city: zod.string().min(1),
      care_of: zod
        .string()
        .min(1)
        .optional()
        .describe(
          "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
        ),
    })
    .optional(),
  school_bus_stop: zod.string().optional().describe('Bus stop name'),
  half_product: zod.boolean(),
});

export const updateCollectionMemberResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
      guardian1_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian1_email: zod.string().email().optional(),
      guardian2_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian2_email: zod.string().email().optional(),
      school_name: zod.string().optional(),
      school_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      school_bus_stop: zod.string().optional().describe('Bus stop name'),
      half_product: zod.boolean(),
    }),
  )
  .and(
    zod.object({
      manually_modified: zod.boolean(),
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      traveller_id: zod.string().uuid(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
      inactivated_at: zod.string().datetime({}).optional(),
      anonymized_at: zod.string().datetime({}).optional(),
    }),
  );

/**
 * Activate a previously inactivated collection member
 * @summary Activate collection member
 */
export const activateCollectionMemberParams = zod.object({
  collectionMemberID: zod.string().uuid(),
});

export const activateCollectionMemberResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
      guardian1_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian1_email: zod.string().email().optional(),
      guardian2_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian2_email: zod.string().email().optional(),
      school_name: zod.string().optional(),
      school_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      school_bus_stop: zod.string().optional().describe('Bus stop name'),
      half_product: zod.boolean(),
    }),
  )
  .and(
    zod.object({
      manually_modified: zod.boolean(),
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      traveller_id: zod.string().uuid(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
      inactivated_at: zod.string().datetime({}).optional(),
      anonymized_at: zod.string().datetime({}).optional(),
    }),
  );

/**
 * Inactivate a collection member
 * @summary Inactivate collection member
 */
export const inactivateCollectionMemberParams = zod.object({
  collectionMemberID: zod.string().uuid(),
});

export const inactivateCollectionMemberBody = zod.object({
  inactivate_at: zod.string().datetime({}).optional(),
});

export const inactivateCollectionMemberResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      collection_id: zod.string().uuid(),
      guardian1_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian1_email: zod.string().email().optional(),
      guardian2_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian2_email: zod.string().email().optional(),
      school_name: zod.string().optional(),
      school_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
      school_bus_stop: zod.string().optional().describe('Bus stop name'),
      half_product: zod.boolean(),
    }),
  )
  .and(
    zod.object({
      manually_modified: zod.boolean(),
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      traveller_id: zod.string().uuid(),
      active: zod.boolean(),
      inactivate_at: zod.string().datetime({}).optional(),
      inactivated_at: zod.string().datetime({}).optional(),
      anonymized_at: zod.string().datetime({}).optional(),
    }),
  );

/**
 * Update collection ticket claim by id
 * @summary Update collection ticket claim by id
 */
export const updateCollectionTicketClaimParams = zod.object({
  collectionTicketClaimID: zod.string().uuid(),
});

export const updateCollectionTicketClaimBody = zod.object({
  valid_from: zod.string().datetime({}).optional(),
  valid_to: zod.string().datetime({}).optional(),
});

export const updateCollectionTicketClaimResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        valid_from: zod.string().datetime({}).optional(),
        valid_to: zod.string().datetime({}).optional(),
      })
      .and(
        zod.object({
          type: zod.enum(['single', 'partial-payment']),
          revoke_strategy: zod.enum(['none', 'revoke']),
          reissuance_allowed: zod.boolean(),
          relational: zod.boolean(),
          stina_product_id: zod.string().optional(),
        }),
      ),
  )
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      department_id: zod.string().uuid(),
      collection_id: zod.string().uuid(),
      non_invoiced: zod
        .boolean()
        .describe(
          'Tickets issued under the claim are not billed. Only sysadmins can set it, through the tenant claim endpoints',
        ),
    }),
  );

/**
 * Delete collection ticket claim by id
 * @summary Delete collection ticket claim by id
 */
export const deleteCollectionTicketClaimParams = zod.object({
  collectionTicketClaimID: zod.string().uuid(),
});

export const deleteCollectionTicketClaimResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        valid_from: zod.string().datetime({}).optional(),
        valid_to: zod.string().datetime({}).optional(),
      })
      .and(
        zod.object({
          type: zod.enum(['single', 'partial-payment']),
          revoke_strategy: zod.enum(['none', 'revoke']),
          reissuance_allowed: zod.boolean(),
          relational: zod.boolean(),
          stina_product_id: zod.string().optional(),
        }),
      ),
  )
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      department_id: zod.string().uuid(),
      collection_id: zod.string().uuid(),
      non_invoiced: zod
        .boolean()
        .describe(
          'Tickets issued under the claim are not billed. Only sysadmins can set it, through the tenant claim endpoints',
        ),
    }),
  );

/**
 * List member states for a collection ticket claim
 * @summary List member states for a collection ticket claim
 */
export const listCollectionTicketClaimMemberStatesParams = zod.object({
  collectionTicketClaimID: zod.string().uuid(),
});

export const listCollectionTicketClaimMemberStatesResponseItem = zod.object({
  collection_member_id: zod.string().uuid(),
  updated_at: zod.string().datetime({}),
  state: zod.enum([
    'unresolvable-relational-ticket',
    'card-order-failed',
    'card-ordered',
    'awaiting-card-transfer',
    'purchase-failed',
    'purchase-ordered',
    'unfulfillable',
    'fulfilled',
  ]),
  message: zod.string().optional(),
  consecutive_failures: zod.number(),
});
export const listCollectionTicketClaimMemberStatesResponse = zod.array(
  listCollectionTicketClaimMemberStatesResponseItem,
);

/**
 * Returns all members for the specified collection with traveller data
 * @summary Get collection members
 */
export const getCollectionMembersParams = zod.object({
  collectionID: zod.string().uuid().describe('Collection ID'),
});

export const getCollectionMembersResponseTravellerNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const getCollectionMembersResponseTravellerPhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const getCollectionMembersResponseItem = zod.object({
  collection_member: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        collection_id: zod.string().uuid(),
        guardian1_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
        guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
        guardian1_email: zod.string().email().optional(),
        guardian2_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
        guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
        guardian2_email: zod.string().email().optional(),
        school_name: zod.string().optional(),
        school_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
        school_bus_stop: zod.string().optional().describe('Bus stop name'),
        half_product: zod.boolean(),
      }),
    )
    .and(
      zod.object({
        manually_modified: zod.boolean(),
        organization_id: zod
          .string()
          .uuid()
          .describe('The unique identifier of an organization\n'),
        traveller_id: zod.string().uuid(),
        active: zod.boolean(),
        inactivate_at: zod.string().datetime({}).optional(),
        inactivated_at: zod.string().datetime({}).optional(),
        anonymized_at: zod.string().datetime({}).optional(),
      }),
    ),
  traveller: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        first_name: zod.string().optional(),
        last_name: zod.string().optional(),
        email: zod.string().optional(),
        national_identity_number: zod
          .string()
          .regex(
            getCollectionMembersResponseTravellerNationalIdentityNumberRegExp,
          )
          .optional(),
        phone: zod
          .string()
          .regex(getCollectionMembersResponseTravellerPhoneRegExp)
          .optional(),
        delivery_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
      }),
    )
    .and(
      zod.object({
        organization_id: zod
          .string()
          .uuid()
          .describe('The unique identifier of an organization\n'),
        anonymized_at: zod.string().datetime({}).optional(),
        deleted_at: zod
          .string()
          .datetime({})
          .optional()
          .describe(
            'When the traveller was deleted. The global search is the only\ntraveller endpoint that returns deleted travellers; every other\ntraveller endpoint excludes them.\n',
          ),
        bobcat_private_email: zod.string().email().optional(),
        bobcat_private_id: zod.string().optional(),
        bobcat_alltix_id: zod.string().optional(),
        favored_bobcat_bearer_id: zod.string().optional(),
        keywords: zod
          .array(zod.string())
          .describe(
            'Searchable keywords associated with the traveller, such as the\nnational identity numbers of people the traveller has purchased\ntickets for. Read-only — cannot be set through the API.\n',
          ),
      }),
    ),
});
export const getCollectionMembersResponse = zod.array(
  getCollectionMembersResponseItem,
);

/**
 * Import multiple collection members from structured data with support for different import strategies
 * @summary Import collection members in bulk
 */
export const importCollectionMembersParams = zod.object({
  collectionID: zod.string().uuid().describe('Collection ID'),
});

export const importCollectionMembersBody = zod.object({
  rows: zod.array(
    zod.object({
      row_number: zod.number(),
      email: zod.string().optional(),
      national_identity_number: zod.string().optional(),
      first_name: zod.string().optional(),
      last_name: zod.string().optional(),
      phone: zod.string().optional(),
      delivery_address: zod
        .object({
          street: zod.string().optional(),
          zip_code: zod
            .string()
            .optional()
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().optional(),
          care_of: zod
            .string()
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional()
        .describe(
          'Address as supplied in a bulk import row. Unlike Address, the sub-fields are not length-constrained: an import file may contain a partially filled address (e.g. an empty zip code). Completeness and format are validated per-row by the import logic so a single bad address fails just that row instead of rejecting the whole batch at the request-schema gate. No sub-field is required: all completeness and format validation is delegated to the per-row import logic.',
        ),
      guardian1_address: zod
        .object({
          street: zod.string().optional(),
          zip_code: zod
            .string()
            .optional()
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().optional(),
          care_of: zod
            .string()
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional()
        .describe(
          'Address as supplied in a bulk import row. Unlike Address, the sub-fields are not length-constrained: an import file may contain a partially filled address (e.g. an empty zip code). Completeness and format are validated per-row by the import logic so a single bad address fails just that row instead of rejecting the whole batch at the request-schema gate. No sub-field is required: all completeness and format validation is delegated to the per-row import logic.',
        ),
      guardian1_email: zod.string().optional(),
      guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian2_address: zod
        .object({
          street: zod.string().optional(),
          zip_code: zod
            .string()
            .optional()
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().optional(),
          care_of: zod
            .string()
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional()
        .describe(
          'Address as supplied in a bulk import row. Unlike Address, the sub-fields are not length-constrained: an import file may contain a partially filled address (e.g. an empty zip code). Completeness and format are validated per-row by the import logic so a single bad address fails just that row instead of rejecting the whole batch at the request-schema gate. No sub-field is required: all completeness and format validation is delegated to the per-row import logic.',
        ),
      guardian2_email: zod.string().optional(),
      guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
      school_name: zod.string().optional(),
      school_address: zod
        .object({
          street: zod.string().optional(),
          zip_code: zod
            .string()
            .optional()
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().optional(),
          care_of: zod
            .string()
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional()
        .describe(
          'Address as supplied in a bulk import row. Unlike Address, the sub-fields are not length-constrained: an import file may contain a partially filled address (e.g. an empty zip code). Completeness and format are validated per-row by the import logic so a single bad address fails just that row instead of rejecting the whole batch at the request-schema gate. No sub-field is required: all completeness and format validation is delegated to the per-row import logic.',
        ),
      school_bus_stop: zod.string().optional().describe('Bus stop name'),
      half_product: zod.boolean(),
    }),
  ),
  strategy: zod
    .enum(['replace', 'merge', 'append'])
    .describe(
      'Strategy for importing collection members:\n- `replace`: Synchronize collection to match import file (add new, update changed, remove missing). Idempotent.\n- `merge`: Add new members and update existing ones, never remove\n- `append`: Only add new members, never update or remove existing ones\n',
    ),
  file_name: zod.string().optional(),
  file_size: zod.number().optional(),
});

export const importCollectionMembersResponse = zod.object({
  import_id: zod.string().uuid(),
  changes: zod.array(
    zod.object({
      row_number: zod.number(),
      action: zod.enum([
        'added',
        'updated',
        'restored',
        'removed',
        'failed',
        'skipped',
        'confirmed',
      ]),
      traveller_id: zod.string().uuid().optional(),
      collection_member_id: zod.string().uuid().optional(),
      error_message: zod.string().optional(),
    }),
  ),
  summary: zod.object({
    added: zod.number(),
    updated: zod.number(),
    restored: zod.number(),
    removed: zod.number(),
    failed: zod.number(),
    skipped: zod.number(),
    confirmed: zod.number(),
  }),
  strategy: zod
    .enum(['replace', 'merge', 'append'])
    .describe(
      'Strategy for importing collection members:\n- `replace`: Synchronize collection to match import file (add new, update changed, remove missing). Idempotent.\n- `merge`: Add new members and update existing ones, never remove\n- `append`: Only add new members, never update or remove existing ones\n',
    ),
  created_at: zod.string().datetime({}),
  created_by: zod.string().uuid(),
  file_name: zod.string().nullish(),
  file_size: zod.number().nullish().describe('File size in bytes'),
});

/**
 * Validate import data without making any changes (dry run)
 * @summary Validate collection member import
 */
export const validateCollectionMemberImportParams = zod.object({
  collectionID: zod.string().uuid().describe('Collection ID'),
});

export const validateCollectionMemberImportBody = zod.object({
  rows: zod.array(
    zod.object({
      row_number: zod.number(),
      email: zod.string().optional(),
      national_identity_number: zod.string().optional(),
      first_name: zod.string().optional(),
      last_name: zod.string().optional(),
      phone: zod.string().optional(),
      delivery_address: zod
        .object({
          street: zod.string().optional(),
          zip_code: zod
            .string()
            .optional()
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().optional(),
          care_of: zod
            .string()
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional()
        .describe(
          'Address as supplied in a bulk import row. Unlike Address, the sub-fields are not length-constrained: an import file may contain a partially filled address (e.g. an empty zip code). Completeness and format are validated per-row by the import logic so a single bad address fails just that row instead of rejecting the whole batch at the request-schema gate. No sub-field is required: all completeness and format validation is delegated to the per-row import logic.',
        ),
      guardian1_address: zod
        .object({
          street: zod.string().optional(),
          zip_code: zod
            .string()
            .optional()
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().optional(),
          care_of: zod
            .string()
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional()
        .describe(
          'Address as supplied in a bulk import row. Unlike Address, the sub-fields are not length-constrained: an import file may contain a partially filled address (e.g. an empty zip code). Completeness and format are validated per-row by the import logic so a single bad address fails just that row instead of rejecting the whole batch at the request-schema gate. No sub-field is required: all completeness and format validation is delegated to the per-row import logic.',
        ),
      guardian1_email: zod.string().optional(),
      guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
      guardian2_address: zod
        .object({
          street: zod.string().optional(),
          zip_code: zod
            .string()
            .optional()
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().optional(),
          care_of: zod
            .string()
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional()
        .describe(
          'Address as supplied in a bulk import row. Unlike Address, the sub-fields are not length-constrained: an import file may contain a partially filled address (e.g. an empty zip code). Completeness and format are validated per-row by the import logic so a single bad address fails just that row instead of rejecting the whole batch at the request-schema gate. No sub-field is required: all completeness and format validation is delegated to the per-row import logic.',
        ),
      guardian2_email: zod.string().optional(),
      guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
      school_name: zod.string().optional(),
      school_address: zod
        .object({
          street: zod.string().optional(),
          zip_code: zod
            .string()
            .optional()
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().optional(),
          care_of: zod
            .string()
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional()
        .describe(
          'Address as supplied in a bulk import row. Unlike Address, the sub-fields are not length-constrained: an import file may contain a partially filled address (e.g. an empty zip code). Completeness and format are validated per-row by the import logic so a single bad address fails just that row instead of rejecting the whole batch at the request-schema gate. No sub-field is required: all completeness and format validation is delegated to the per-row import logic.',
        ),
      school_bus_stop: zod.string().optional().describe('Bus stop name'),
      half_product: zod.boolean(),
    }),
  ),
  strategy: zod
    .enum(['replace', 'merge', 'append'])
    .describe(
      'Strategy for importing collection members:\n- `replace`: Synchronize collection to match import file (add new, update changed, remove missing). Idempotent.\n- `merge`: Add new members and update existing ones, never remove\n- `append`: Only add new members, never update or remove existing ones\n',
    ),
  file_name: zod.string().optional(),
  file_size: zod.number().optional(),
});

export const validateCollectionMemberImportResponse = zod.object({
  import_id: zod.string().uuid(),
  changes: zod.array(
    zod.object({
      row_number: zod.number(),
      action: zod.enum([
        'added',
        'updated',
        'restored',
        'removed',
        'failed',
        'skipped',
        'confirmed',
      ]),
      traveller_id: zod.string().uuid().optional(),
      collection_member_id: zod.string().uuid().optional(),
      error_message: zod.string().optional(),
    }),
  ),
  summary: zod.object({
    added: zod.number(),
    updated: zod.number(),
    restored: zod.number(),
    removed: zod.number(),
    failed: zod.number(),
    skipped: zod.number(),
    confirmed: zod.number(),
  }),
  strategy: zod
    .enum(['replace', 'merge', 'append'])
    .describe(
      'Strategy for importing collection members:\n- `replace`: Synchronize collection to match import file (add new, update changed, remove missing). Idempotent.\n- `merge`: Add new members and update existing ones, never remove\n- `append`: Only add new members, never update or remove existing ones\n',
    ),
  created_at: zod.string().datetime({}),
  created_by: zod.string().uuid(),
  file_name: zod.string().nullish(),
  file_size: zod.number().nullish().describe('File size in bytes'),
});

/**
 * Returns a list of all imports for a collection, ordered by creation date descending
 * @summary List collection import history
 */
export const listCollectionImportsParams = zod.object({
  collectionID: zod.string().uuid().describe('Collection ID'),
});

export const listCollectionImportsResponseItem = zod.object({
  import_id: zod.string().uuid(),
  collection_id: zod.string().uuid(),
  strategy: zod
    .enum(['replace', 'merge', 'append'])
    .describe(
      'Strategy for importing collection members:\n- `replace`: Synchronize collection to match import file (add new, update changed, remove missing). Idempotent.\n- `merge`: Add new members and update existing ones, never remove\n- `append`: Only add new members, never update or remove existing ones\n',
    ),
  summary: zod.object({
    added: zod.number(),
    updated: zod.number(),
    restored: zod.number(),
    removed: zod.number(),
    failed: zod.number(),
    skipped: zod.number(),
    confirmed: zod.number(),
  }),
  created_at: zod.string().datetime({}),
  created_by: zod.string().uuid(),
  file_name: zod.string().nullish(),
  file_size: zod.number().nullish().describe('File size in bytes'),
});
export const listCollectionImportsResponse = zod.array(
  listCollectionImportsResponseItem,
);

/**
 * @summary Get a single collection import with full change details
 */
export const getCollectionImportParams = zod.object({
  collectionID: zod.string().uuid().describe('Collection ID'),
  importID: zod.string().uuid().describe('Import ID'),
});

export const getCollectionImportResponse = zod.object({
  import_id: zod.string().uuid(),
  changes: zod.array(
    zod.object({
      row_number: zod.number(),
      action: zod.enum([
        'added',
        'updated',
        'restored',
        'removed',
        'failed',
        'skipped',
        'confirmed',
      ]),
      traveller_id: zod.string().uuid().optional(),
      collection_member_id: zod.string().uuid().optional(),
      error_message: zod.string().optional(),
    }),
  ),
  summary: zod.object({
    added: zod.number(),
    updated: zod.number(),
    restored: zod.number(),
    removed: zod.number(),
    failed: zod.number(),
    skipped: zod.number(),
    confirmed: zod.number(),
  }),
  strategy: zod
    .enum(['replace', 'merge', 'append'])
    .describe(
      'Strategy for importing collection members:\n- `replace`: Synchronize collection to match import file (add new, update changed, remove missing). Idempotent.\n- `merge`: Add new members and update existing ones, never remove\n- `append`: Only add new members, never update or remove existing ones\n',
    ),
  created_at: zod.string().datetime({}),
  created_by: zod.string().uuid(),
  file_name: zod.string().nullish(),
  file_size: zod.number().nullish().describe('File size in bytes'),
});

/**
 * Returns all ticket claims for the specified collection
 * @summary Get collection ticket claims
 */
export const getCollectionTicketClaimsParams = zod.object({
  collectionID: zod.string().uuid().describe('Collection ID'),
});

export const getCollectionTicketClaimsResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        valid_from: zod.string().datetime({}).optional(),
        valid_to: zod.string().datetime({}).optional(),
      })
      .and(
        zod.object({
          type: zod.enum(['single', 'partial-payment']),
          revoke_strategy: zod.enum(['none', 'revoke']),
          reissuance_allowed: zod.boolean(),
          relational: zod.boolean(),
          stina_product_id: zod.string().optional(),
        }),
      ),
  )
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      department_id: zod.string().uuid(),
      collection_id: zod.string().uuid(),
      non_invoiced: zod
        .boolean()
        .describe(
          'Tickets issued under the claim are not billed. Only sysadmins can set it, through the tenant claim endpoints',
        ),
    }),
  );
export const getCollectionTicketClaimsResponse = zod.array(
  getCollectionTicketClaimsResponseItem,
);

/**
 * @summary Create a collection ticket claim
 */
export const createCollectionTicketClaimParams = zod.object({
  collectionID: zod.string().uuid().describe('Collection ID'),
});

export const createCollectionTicketClaimBody = zod
  .object({
    valid_from: zod.string().datetime({}).optional(),
    valid_to: zod.string().datetime({}).optional(),
  })
  .and(
    zod.object({
      type: zod.enum(['single', 'partial-payment']),
      revoke_strategy: zod.enum(['none', 'revoke']),
      reissuance_allowed: zod.boolean(),
      relational: zod.boolean(),
      stina_product_id: zod.string().optional(),
    }),
  );

/**
 * List the API keys of the logged in account, across all of its user profiles, including revoked and expired keys.

 * @summary List API keys
 */
export const listAPIKeysResponseItem = zod.object({
  id: zod.string().uuid(),
  organization_id: zod.string().uuid(),
  organization_name: zod.string(),
  user_profile_id: zod
    .string()
    .uuid()
    .describe('The user profile the key acts as'),
  email: zod.string().describe('Email of the account the key belongs to'),
  name: zod.string(),
  key_prefix: zod
    .string()
    .describe('The first characters of the key, for telling keys apart'),
  created_at: zod.string().datetime({}),
  expires_at: zod.string().datetime({}).nullable(),
  last_used_at: zod.string().datetime({}).nullable(),
  revoked_at: zod.string().datetime({}).nullable(),
});
export const listAPIKeysResponse = zod.array(listAPIKeysResponseItem);

/**
 * Create an API key that acts as the current user profile. The key is returned in clear text in this response only.

 * @summary Create API key
 */
export const createAPIKeyBodyNameMax = 100;

export const createAPIKeyBody = zod.object({
  name: zod
    .string()
    .min(1)
    .max(createAPIKeyBodyNameMax)
    .describe('What the key is for, typically the integration that uses it'),
  expires_at: zod
    .string()
    .datetime({})
    .nullish()
    .describe(
      'When the key stops working. Omit for a key that does not expire.',
    ),
});

/**
 * Revoke an API key of the logged in account. Revoking an already revoked key is a no-op.
 * @summary Revoke API key
 */
export const revokeAPIKeyParams = zod.object({
  apiKeyID: zod.string().uuid(),
});

export const revokeAPIKeyResponse = zod.object({
  id: zod.string().uuid(),
  organization_id: zod.string().uuid(),
  organization_name: zod.string(),
  user_profile_id: zod
    .string()
    .uuid()
    .describe('The user profile the key acts as'),
  email: zod.string().describe('Email of the account the key belongs to'),
  name: zod.string(),
  key_prefix: zod
    .string()
    .describe('The first characters of the key, for telling keys apart'),
  created_at: zod.string().datetime({}),
  expires_at: zod.string().datetime({}).nullable(),
  last_used_at: zod.string().datetime({}).nullable(),
  revoked_at: zod.string().datetime({}).nullable(),
});

/**
 * List Allpay users
 * @summary List Allpay users
 */
export const listAllpayUsersQueryParams = zod.object({
  department_id: zod.string().uuid().optional(),
  traveller_id: zod.string().uuid().optional(),
});

export const listAllpayUsersResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
      collection_member_id: zod.string().uuid(),
      credit: zod.number(),
    }),
  );
export const listAllpayUsersResponse = zod.array(listAllpayUsersResponseItem);

/**
 * Create Allpay user
 * @summary Create Allpay user
 */
export const createAllpayUserBody = zod.object({
  department_id: zod.string().uuid(),
  collection_member_id: zod.string().uuid(),
  phone_number: zod.string().describe('E.164 number'),
  credit: zod.number(),
});

/**
 * Get AllpayUser by ID
 * @summary Get AllpayUser
 */
export const getAllpayUserParams = zod.object({
  id: zod.string().uuid(),
});

export const getAllpayUserResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
      collection_member_id: zod.string().uuid(),
      credit: zod.number(),
    }),
  )
  .and(
    zod.object({
      state: zod.string(),
    }),
  );

/**
 * Update AllpayUser credit limit. The new limit must fit the organization's credit limit, and may not be lower than what the Allpay user has already spent this month.

 * @summary Update AllpayUser credit limit
 */
export const updateAllpayUserCreditLimitParams = zod.object({
  id: zod.string().uuid(),
});

export const updateAllpayUserCreditLimitBody = zod.object({
  credit: zod.number(),
});

export const updateAllpayUserCreditLimitResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
      collection_member_id: zod.string().uuid(),
      credit: zod.number(),
    }),
  );

/**
 * Delete the selected AllpayUser
 * @summary Delete AllpayUser
 */
export const deleteAllpayUserParams = zod.object({
  id: zod.string().uuid(),
});

export const deleteAllpayUserResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      department_id: zod.string().uuid(),
      collection_member_id: zod.string().uuid(),
      credit: zod.number(),
    }),
  );

/**
 * Gets what the Allpay user has spent this month, as reported by Allpay. Allpay calls this the uninvoiced total; it covers the current month whether or not Allpay has invoiced it yet. A credit limit may not be lowered below it.

 * @summary Summary of uninvoiced transactions
 */
export const getUninvoicedSummaryParams = zod.object({
  id: zod.string().uuid(),
});

export const getUninvoicedSummaryResponse = zod.object({
  result: zod.boolean(),
  total_inc_vat: zod.number(),
});

/**
 * Imports transactions from AllPay and Alltix Resellers
 * @summary Import external transactions
 */
export const importExternalTransactionsBodyVatItemRateMin = 0;
export const importExternalTransactionsBodyVatItemRateMax = 100;

export const importExternalTransactionsBodyVatItemAmountMin = 0;

export const importExternalTransactionsBodyItem = zod.object({
  type: zod.enum(['allpay', 'alltix-resellers']),
  allpay_user_id: zod
    .string()
    .uuid()
    .optional()
    .describe('Mandatory for type=allpay'),
  department_id: zod
    .string()
    .uuid()
    .optional()
    .describe('Mandatory for type=alltix-resellers'),
  bobcat_order_id: zod.string(),
  bobcat_transaction_id: zod.string().optional(),
  created_at: zod.string().datetime({}),
  state: zod.enum(['captured', 'refunded']),
  amount_inc_vat: zod.number().describe('No decimals, expressed in cents/ören'),
  amount_ex_vat: zod.number().describe('No decimals, expressed in cents/ören'),
  vat: zod.array(
    zod.object({
      rate: zod
        .number()
        .min(importExternalTransactionsBodyVatItemRateMin)
        .max(importExternalTransactionsBodyVatItemRateMax)
        .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
      amount: zod.number().min(importExternalTransactionsBodyVatItemAmountMin),
    }),
  ),
  product: zod
    .object({
      count: zod.number(),
      title: zod.string(),
      subtitle: zod.string().optional(),
      bobcat_tags: zod.array(zod.string()),
    })
    .optional(),
  reason: zod
    .string()
    .optional()
    .describe(
      'A short (possibly single-word) description of the purpose of the\npurchase. Printed in invoice specifications.\n',
    ),
});
export const importExternalTransactionsBody = zod.array(
  importExternalTransactionsBodyItem,
);

/**
 * List Bobcat tags
 * @summary List Bobcat tags
 */
export const getBobcatTagsListResponseItem = zod.object({
  id: zod.string().uuid(),
  tag_id: zod.string(),
  tenant_id: zod
    .string()
    .describe(
      'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
    ),
  title: zod.string(),
  created_at: zod.string().datetime({}),
});
export const getBobcatTagsListResponse = zod.array(
  getBobcatTagsListResponseItem,
);

/**
 * List Bobcat offers groups
 * @summary List Bobcat offers groups
 */
export const listBobcatOfferGroupsResponseItem = zod.object({
  id: zod.string().uuid(),
  tenant_id: zod
    .string()
    .describe(
      'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
    ),
  group_key: zod.string(),
  sales_channel: zod.enum(['corporate', 'school', 'benefit']),
  product_class: zod.string(),
  title: zod.string(),
  created_at: zod.string().datetime({}),
});
export const listBobcatOfferGroupsResponse = zod.array(
  listBobcatOfferGroupsResponseItem,
);

/**
 * List Bobcat offers
 * @summary List Bobcat offers
 */
export const listBobcatOffersResponseVatItemRateMin = 0;
export const listBobcatOffersResponseVatItemRateMax = 100;

export const listBobcatOffersResponseVatItemAmountMin = 0;

export const listBobcatOffersResponseItem = zod.object({
  id: zod.string(),
  tenant_id: zod
    .string()
    .describe(
      'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
    ),
  created_at: zod.string().datetime({}),
  bobcat_offer_group_id: zod.string().uuid(),
  product_set_id: zod.string(),
  title: zod.string(),
  currency: zod.string(),
  amount_inc_vat: zod.number().describe('Monetary value in ören (1/100 SEK)'),
  vat: zod.array(
    zod.object({
      rate: zod
        .number()
        .min(listBobcatOffersResponseVatItemRateMin)
        .max(listBobcatOffersResponseVatItemRateMax)
        .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
      amount: zod.number().min(listBobcatOffersResponseVatItemAmountMin),
    }),
  ),
  tags: zod.array(zod.string()),
});
export const listBobcatOffersResponse = zod.array(listBobcatOffersResponseItem);

/**
 * Lookup Bobcat offers by tags
 * @summary Lookup bobcat offers by tags
 */
export const lookupBobcatOffersByTagsQueryParams = zod.object({
  tags: zod.string(),
});

export const lookupBobcatOffersByTagsResponseItem = zod.object({
  id: zod.string(),
  product_set_id: zod.string(),
  title: zod.string(),
});
export const lookupBobcatOffersByTagsResponse = zod.array(
  lookupBobcatOffersByTagsResponseItem,
);

/**
 * List bearers
 * @summary List bearers
 */
export const listBearersQueryParams = zod.object({
  email: zod.string().email().optional(),
  card_serial: zod.string().optional(),
});

export const listBearersResponseItem = zod.object({
  id: zod.string(),
  type: zod.enum(['other', 'paper', 'smartcard', 'smartphone']).optional(),
  name: zod.string().optional(),
  default: zod.boolean().optional(),
  serial: zod.string().optional(),
});
export const listBearersResponse = zod.array(listBearersResponseItem);

/**
 * Create a group ticket producset, using an existing productset as a template

 * @summary Create a group ticket productset
 */
export const createGroupTicketProductBody = zod.object({
  product_set_id: zod.string(),
  tc_tags: zod.array(zod.string()),
});

/**
 * Purchase a product set for one or more collection members
 * @summary Purchase a product set for one or more collection members
 */
export const purchaseProductSetForCollectionMembersBodySendEmailNotificationDefault = true;

export const purchaseProductSetForCollectionMembersBody = zod.object({
  department_id: zod.string().uuid(),
  manual_activation: zod.boolean(),
  product_set_id: zod.string(),
  product_type: zod
    .enum(['static', 'planner'])
    .describe(
      "Used for permission validation purposes.\nFor static tickets, set to 'static'.\nFor tickets returned by journey planner, set to 'planner'\n",
    ),
  recipients: zod.array(
    zod.object({
      collection_member_id: zod.string().uuid(),
      bobcat_recipient: zod
        .union([zod.unknown(), zod.unknown()])
        .describe('A purchase recipient.'),
    }),
  ),
  reason: zod
    .string()
    .optional()
    .describe(
      'A short (possibly single-word) description of the purpose of the\npurchase. Printed in invoice specifications.\n',
    ),
  send_email_notification: zod
    .boolean()
    .default(
      purchaseProductSetForCollectionMembersBodySendEmailNotificationDefault,
    )
    .describe(
      'Whether to send an email notification to traveller about newly issued ticket.\nEmail will be sent to the travellers email address.\n',
    ),
});

export const purchaseProductSetForCollectionMembersResponseTransactionVatItemRateMin = 0;
export const purchaseProductSetForCollectionMembersResponseTransactionVatItemRateMax = 100;

export const purchaseProductSetForCollectionMembersResponseTransactionVatItemAmountMin = 0;

export const purchaseProductSetForCollectionMembersResponseIssuedTicketsItemRevokeReasonDetailMax = 100;

export const purchaseProductSetForCollectionMembersResponse = zod
  .object({
    transaction: zod.object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      organization_id: zod.string().uuid(),
      department_id: zod.string().uuid(),
      order_id: zod.string().uuid(),
      collection_ticket_claim_id: zod.string().uuid().optional(),
      collection_id: zod.string().uuid().optional(),
      state: zod.enum(['captured', 'refunded']),
      refund_transaction_id: zod.string().uuid().optional(),
      refunded_transaction_id: zod.string().uuid().optional(),
      bobcat_order_id: zod
        .string()
        .optional()
        .describe(
          "The Bobcat order ID of the Bobcat purchase this transaction settles, or\nfor a refund the purchase it refunds. Absent when no Bobcat purchase is\nbehind the transaction, as for monthly partial-payment fees. The Bobcat\npurchase that issued a ticket is on the ticket's own bobcat_order_id.\n",
        ),
      bobcat_transaction_id: zod
        .string()
        .optional()
        .describe(
          'The ID of the Bobcat purchase transaction behind this transaction, with\nthe same presence as bobcat_order_id.\n',
        ),
      amount_inc_vat: zod.number(),
      amount_ex_vat: zod.number(),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
      vat: zod.array(
        zod.object({
          rate: zod
            .number()
            .min(
              purchaseProductSetForCollectionMembersResponseTransactionVatItemRateMin,
            )
            .max(
              purchaseProductSetForCollectionMembersResponseTransactionVatItemRateMax,
            )
            .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
          amount: zod
            .number()
            .min(
              purchaseProductSetForCollectionMembersResponseTransactionVatItemAmountMin,
            ),
        }),
      ),
      source: zod.enum([
        'portal',
        'allpay',
        'walletcard',
        'alltix-resellers',
        'alltix-resellers-portal',
      ]),
      sales_channel: zod.enum(['corporate', 'school', 'benefit']),
      reason: zod
        .string()
        .optional()
        .describe(
          'A short (possible single-word) description of the purpose for this\npurchase. Printed in invoice specifications.\n',
        ),
      grouping_key: zod
        .string()
        .optional()
        .describe(
          'Used to group transactions together in invoice specifications',
        ),
    }),
    order: zod
      .object({
        id: zod.string().uuid(),
        tenant_id: zod
          .string()
          .describe(
            'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
          ),
        created_at: zod.string().datetime({}),
        updated_at: zod.string().datetime({}),
      })
      .and(
        zod.object({
          organization_id: zod
            .string()
            .uuid()
            .describe('The unique identifier of an organization\n'),
          department_id: zod.string().uuid(),
          state: zod.enum(['ordered', 'pending', 'delivered', 'cancelled']),
        }),
      ),
    issued_tickets: zod.array(
      zod
        .object({
          id: zod.string().uuid().describe('The ID of the issued ticket'),
          tenant_id: zod
            .string()
            .describe(
              'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
            ),
          organization_id: zod
            .string()
            .uuid()
            .describe('The ID of the organization'),
          department_id: zod
            .string()
            .uuid()
            .describe('The ID of the department'),
          order_id: zod.string().uuid().describe('The ID of the order'),
          traveller_id: zod
            .string()
            .uuid()
            .optional()
            .describe('The ID of the traveller'),
          collection_member_id: zod
            .string()
            .uuid()
            .optional()
            .describe('The ID of the collection member'),
          collection_ticket_claim_id: zod
            .string()
            .uuid()
            .optional()
            .describe('The ID of the collection ticket claim'),
          collection_id: zod
            .string()
            .uuid()
            .optional()
            .describe('The ID of the collection'),
          state: zod.enum([
            'active',
            'inactive',
            'blacklisted',
            'cancelled',
            'expired',
            'marked_for_deletion',
            'revoked',
          ]),
          product_class: zod.string(),
          traveller_class: zod.string(),
          tags: zod.array(zod.string()),
          revoke_at: zod
            .string()
            .datetime({})
            .optional()
            .describe('The date and time when the issued ticket was revoked'),
          revoke_reason: zod
            .enum([
              'revoked_by_user',
              'ticket_claim_deleted',
              'department_deleted',
              'collection_member_inactivated',
              'claim_member_removed',
              'claim_expired',
              'address_changed',
            ])
            .optional(),
          revoke_reason_detail: zod
            .string()
            .max(
              purchaseProductSetForCollectionMembersResponseIssuedTicketsItemRevokeReasonDetailMax,
            )
            .optional()
            .describe('Extra detail about why the issued ticket was revoked'),
          revoked_by: zod
            .string()
            .uuid()
            .optional()
            .describe(
              'The ID of the user who revoked the issued ticket. Only set when revoke_reason is revoked_by_user',
            ),
          created_at: zod
            .string()
            .datetime({})
            .describe('The date and time when the issued ticket was created'),
          updated_at: zod
            .string()
            .datetime({})
            .describe(
              'The date and time when the issued ticket was last updated',
            ),
          expires_at: zod
            .string()
            .datetime({})
            .optional()
            .describe('The date and time when the issued ticket was expired'),
          bobcat_mtb_product_ids: zod
            .array(zod.string())
            .describe(
              'The list of Bobcat MTB product IDs associated with the issued ticket',
            ),
          recipient_name: zod
            .string()
            .optional()
            .describe(
              'The name of the intended recipient. Used when purchasing tickets for external recipients',
            ),
          loan_transaction_id: zod
            .string()
            .optional()
            .describe(
              'The ID of the active loan transaction. Present when the ticket is currently loaned out.',
            ),
          bobcat_purchase_transaction_id: zod
            .string()
            .optional()
            .describe(
              'The ID of the Bobcat purchase transaction that issued the ticket, not of\nits loans or refunds. Tickets bought together in one purchase share it.\nAbsent when the issuing purchase is unknown.\n',
            ),
          bobcat_order_id: zod
            .string()
            .optional()
            .describe(
              "The Bobcat order ID of the Bobcat purchase that issued the ticket. Unlike\na transaction's bobcat_order_id it does not depend on how the ticket is\nbilled, so partial-payment and non-invoiced tickets have one too. Tickets\nbought together in one purchase share it. Absent when the issuing\npurchase is unknown.\n",
            ),
        })
        .describe('IssuedTicket'),
    ),
  })
  .describe('Result of a completed purchase transaction');

/**
 * Purchase a product set for one or more external recipients
 * @summary Purchase a product set for one or more external recipients
 */
export const purchaseProductSetForExternalRecipientsBody = zod.object({
  department_id: zod.string().uuid(),
  manual_activation: zod.boolean(),
  product_set_id: zod.string(),
  product_type: zod
    .enum(['static', 'planner'])
    .describe(
      "Used for permission validation purposes.\nFor static tickets, set to 'static'.\nFor tickets returned by journey planner, set to 'planner'\n",
    ),
  recipients: zod.array(
    zod.object({
      recipient_name: zod.string(),
      recipient_email: zod.string().email().optional(),
      recipient_contact_email: zod.string().email().optional(),
      bobcat_recipient: zod
        .union([zod.unknown(), zod.unknown()])
        .describe('A purchase recipient.'),
    }),
  ),
  reason: zod
    .string()
    .optional()
    .describe(
      'A short (possibly single-word) description of the purpose of the\npurchase. Printed in invoice specifications.\n',
    ),
});

export const purchaseProductSetForExternalRecipientsResponseTransactionVatItemRateMin = 0;
export const purchaseProductSetForExternalRecipientsResponseTransactionVatItemRateMax = 100;

export const purchaseProductSetForExternalRecipientsResponseTransactionVatItemAmountMin = 0;

export const purchaseProductSetForExternalRecipientsResponseIssuedTicketsItemRevokeReasonDetailMax = 100;

export const purchaseProductSetForExternalRecipientsResponse = zod
  .object({
    transaction: zod.object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      organization_id: zod.string().uuid(),
      department_id: zod.string().uuid(),
      order_id: zod.string().uuid(),
      collection_ticket_claim_id: zod.string().uuid().optional(),
      collection_id: zod.string().uuid().optional(),
      state: zod.enum(['captured', 'refunded']),
      refund_transaction_id: zod.string().uuid().optional(),
      refunded_transaction_id: zod.string().uuid().optional(),
      bobcat_order_id: zod
        .string()
        .optional()
        .describe(
          "The Bobcat order ID of the Bobcat purchase this transaction settles, or\nfor a refund the purchase it refunds. Absent when no Bobcat purchase is\nbehind the transaction, as for monthly partial-payment fees. The Bobcat\npurchase that issued a ticket is on the ticket's own bobcat_order_id.\n",
        ),
      bobcat_transaction_id: zod
        .string()
        .optional()
        .describe(
          'The ID of the Bobcat purchase transaction behind this transaction, with\nthe same presence as bobcat_order_id.\n',
        ),
      amount_inc_vat: zod.number(),
      amount_ex_vat: zod.number(),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
      vat: zod.array(
        zod.object({
          rate: zod
            .number()
            .min(
              purchaseProductSetForExternalRecipientsResponseTransactionVatItemRateMin,
            )
            .max(
              purchaseProductSetForExternalRecipientsResponseTransactionVatItemRateMax,
            )
            .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
          amount: zod
            .number()
            .min(
              purchaseProductSetForExternalRecipientsResponseTransactionVatItemAmountMin,
            ),
        }),
      ),
      source: zod.enum([
        'portal',
        'allpay',
        'walletcard',
        'alltix-resellers',
        'alltix-resellers-portal',
      ]),
      sales_channel: zod.enum(['corporate', 'school', 'benefit']),
      reason: zod
        .string()
        .optional()
        .describe(
          'A short (possible single-word) description of the purpose for this\npurchase. Printed in invoice specifications.\n',
        ),
      grouping_key: zod
        .string()
        .optional()
        .describe(
          'Used to group transactions together in invoice specifications',
        ),
    }),
    order: zod
      .object({
        id: zod.string().uuid(),
        tenant_id: zod
          .string()
          .describe(
            'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
          ),
        created_at: zod.string().datetime({}),
        updated_at: zod.string().datetime({}),
      })
      .and(
        zod.object({
          organization_id: zod
            .string()
            .uuid()
            .describe('The unique identifier of an organization\n'),
          department_id: zod.string().uuid(),
          state: zod.enum(['ordered', 'pending', 'delivered', 'cancelled']),
        }),
      ),
    issued_tickets: zod.array(
      zod
        .object({
          id: zod.string().uuid().describe('The ID of the issued ticket'),
          tenant_id: zod
            .string()
            .describe(
              'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
            ),
          organization_id: zod
            .string()
            .uuid()
            .describe('The ID of the organization'),
          department_id: zod
            .string()
            .uuid()
            .describe('The ID of the department'),
          order_id: zod.string().uuid().describe('The ID of the order'),
          traveller_id: zod
            .string()
            .uuid()
            .optional()
            .describe('The ID of the traveller'),
          collection_member_id: zod
            .string()
            .uuid()
            .optional()
            .describe('The ID of the collection member'),
          collection_ticket_claim_id: zod
            .string()
            .uuid()
            .optional()
            .describe('The ID of the collection ticket claim'),
          collection_id: zod
            .string()
            .uuid()
            .optional()
            .describe('The ID of the collection'),
          state: zod.enum([
            'active',
            'inactive',
            'blacklisted',
            'cancelled',
            'expired',
            'marked_for_deletion',
            'revoked',
          ]),
          product_class: zod.string(),
          traveller_class: zod.string(),
          tags: zod.array(zod.string()),
          revoke_at: zod
            .string()
            .datetime({})
            .optional()
            .describe('The date and time when the issued ticket was revoked'),
          revoke_reason: zod
            .enum([
              'revoked_by_user',
              'ticket_claim_deleted',
              'department_deleted',
              'collection_member_inactivated',
              'claim_member_removed',
              'claim_expired',
              'address_changed',
            ])
            .optional(),
          revoke_reason_detail: zod
            .string()
            .max(
              purchaseProductSetForExternalRecipientsResponseIssuedTicketsItemRevokeReasonDetailMax,
            )
            .optional()
            .describe('Extra detail about why the issued ticket was revoked'),
          revoked_by: zod
            .string()
            .uuid()
            .optional()
            .describe(
              'The ID of the user who revoked the issued ticket. Only set when revoke_reason is revoked_by_user',
            ),
          created_at: zod
            .string()
            .datetime({})
            .describe('The date and time when the issued ticket was created'),
          updated_at: zod
            .string()
            .datetime({})
            .describe(
              'The date and time when the issued ticket was last updated',
            ),
          expires_at: zod
            .string()
            .datetime({})
            .optional()
            .describe('The date and time when the issued ticket was expired'),
          bobcat_mtb_product_ids: zod
            .array(zod.string())
            .describe(
              'The list of Bobcat MTB product IDs associated with the issued ticket',
            ),
          recipient_name: zod
            .string()
            .optional()
            .describe(
              'The name of the intended recipient. Used when purchasing tickets for external recipients',
            ),
          loan_transaction_id: zod
            .string()
            .optional()
            .describe(
              'The ID of the active loan transaction. Present when the ticket is currently loaned out.',
            ),
          bobcat_purchase_transaction_id: zod
            .string()
            .optional()
            .describe(
              'The ID of the Bobcat purchase transaction that issued the ticket, not of\nits loans or refunds. Tickets bought together in one purchase share it.\nAbsent when the issuing purchase is unknown.\n',
            ),
          bobcat_order_id: zod
            .string()
            .optional()
            .describe(
              "The Bobcat order ID of the Bobcat purchase that issued the ticket. Unlike\na transaction's bobcat_order_id it does not depend on how the ticket is\nbilled, so partial-payment and non-invoiced tickets have one too. Tickets\nbought together in one purchase share it. Absent when the issuing\npurchase is unknown.\n",
            ),
        })
        .describe('IssuedTicket'),
    ),
  })
  .describe('Result of a completed purchase transaction');

/**
 * @summary Submit an organization application
 */

export const submitOrganizationApplicationBodyOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const submitOrganizationApplicationBodyContactPhoneMin = 8;

export const submitOrganizationApplicationBody = zod
  .object({
    name: zod.string().min(1),
    organization_number: zod
      .string()
      .regex(submitOrganizationApplicationBodyOrganizationNumberRegExp),
    contact_first_name: zod.string().min(1),
    contact_last_name: zod.string().min(1),
    contact_email: zod.string().email(),
    contact_phone: zod
      .string()
      .min(submitOrganizationApplicationBodyContactPhoneMin),
    invoicing_address: zod.object({
      street: zod.string().min(1),
      zip_code: zod
        .string()
        .min(1)
        .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
      city: zod.string().min(1),
      care_of: zod
        .string()
        .min(1)
        .optional()
        .describe(
          "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
        ),
    }),
    delivery_address: zod.object({
      street: zod.string().min(1),
      zip_code: zod
        .string()
        .min(1)
        .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
      city: zod.string().min(1),
      care_of: zod
        .string()
        .min(1)
        .optional()
        .describe(
          "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
        ),
    }),
    invoicing_reference: zod.string().min(1),
    suggested_cost_center: zod.string().optional(),
    gln: zod.string().optional(),
    einvoice_email: zod.string().email().optional(),
  })
  .and(
    zod.object({
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
    }),
  );

/**
 * List all tenants
 * @summary List tenants
 */
export const listTenantsResponseItem = zod
  .object({
    id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    name: zod.string(),
    logo: zod.string().url(),
    support_email: zod
      .string()
      .email()
      .nullable()
      .describe(
        'Address end users contact for help with the site. Null if the tenant has not set one. Read-only; maintained directly in the database.',
      ),
  })
  .describe('Public tenant information');
export const listTenantsResponse = zod.array(listTenantsResponseItem);

/**
 * Get a list of etis journeys
 * @summary Get etis journeys
 */
export const getEtisJourneysQueryOriginStopIDMin = 2;

export const getEtisJourneysQueryDestinationStopIDMin = 2;

export const getEtisJourneysQueryParams = zod.object({
  originStopID: zod
    .number()
    .min(getEtisJourneysQueryOriginStopIDMin)
    .describe('The starting stop of the journey'),
  destinationStopID: zod
    .number()
    .min(getEtisJourneysQueryDestinationStopIDMin)
    .describe('The end stop of the journey'),
});

export const getEtisJourneysResponse = zod.object({
  journey_result_key: zod.string(),
  journeys: zod.array(
    zod.object({
      id: zod.string(),
      departure_at: zod.string().datetime({}),
      arrival_at: zod.string().datetime({}),
      zone_names: zod.string(),
      duration: zod.string(),
    }),
  ),
});

/**
 * Get a list of etis stops
 * @summary Get etis stops
 */
export const getEtisStopsQuerySearchStringMin = 2;

export const getEtisStopsQueryParams = zod.object({
  searchString: zod
    .string()
    .min(getEtisStopsQuerySearchStringMin)
    .describe('Search string to filter stops'),
});

export const getEtisStopsResponseItem = zod.object({
  id: zod.number(),
  name: zod.string(),
  x: zod.number(),
  y: zod.number(),
});
export const getEtisStopsResponse = zod.array(getEtisStopsResponseItem);

/**
 * Get a list of bobcat product sets for the etis journey
 * @summary Get bobcat product sets
 */
export const getBobcatProductSetsQueryEtisJourneyIDMin = 2;

export const getBobcatProductSetsQueryEtisJourneysResultKeyMin = 2;

export const getBobcatProductSetsQueryParams = zod.object({
  EtisJourneyID: zod
    .string()
    .min(getBobcatProductSetsQueryEtisJourneyIDMin)
    .describe('The etis journey ID'),
  EtisJourneysResultKey: zod
    .string()
    .min(getBobcatProductSetsQueryEtisJourneysResultKeyMin)
    .describe('The journey result key'),
});

export const getBobcatProductSetsResponseItem = zod.object({
  id: zod.string(),
  title: zod.string(),
  spatial_title: zod.string().optional(),
  amount: zod.number(),
  destination_name: zod.string(),
  origin_name: zod.string(),
  currency: zod.string(),
  tags: zod.array(zod.string()),
});
export const getBobcatProductSetsResponse = zod.array(
  getBobcatProductSetsResponseItem,
);

/**
 * @summary Get issued tickets for transactionID
 */
export const getIssuedTicketsWithTravellerByTransactionIDQueryParams =
  zod.object({
    transaction_id: zod.string().uuid().describe('The ID of the transaction'),
  });

export const getIssuedTicketsWithTravellerByTransactionIDResponseTicketRevokeReasonDetailMax = 100;

export const getIssuedTicketsWithTravellerByTransactionIDResponseItem = zod
  .object({
    ticket: zod
      .object({
        id: zod.string().uuid().describe('The ID of the issued ticket'),
        tenant_id: zod
          .string()
          .describe(
            'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
          ),
        organization_id: zod
          .string()
          .uuid()
          .describe('The ID of the organization'),
        department_id: zod.string().uuid().describe('The ID of the department'),
        order_id: zod.string().uuid().describe('The ID of the order'),
        traveller_id: zod
          .string()
          .uuid()
          .optional()
          .describe('The ID of the traveller'),
        collection_member_id: zod
          .string()
          .uuid()
          .optional()
          .describe('The ID of the collection member'),
        collection_ticket_claim_id: zod
          .string()
          .uuid()
          .optional()
          .describe('The ID of the collection ticket claim'),
        collection_id: zod
          .string()
          .uuid()
          .optional()
          .describe('The ID of the collection'),
        state: zod.enum([
          'active',
          'inactive',
          'blacklisted',
          'cancelled',
          'expired',
          'marked_for_deletion',
          'revoked',
        ]),
        product_class: zod.string(),
        traveller_class: zod.string(),
        tags: zod.array(zod.string()),
        revoke_at: zod
          .string()
          .datetime({})
          .optional()
          .describe('The date and time when the issued ticket was revoked'),
        revoke_reason: zod
          .enum([
            'revoked_by_user',
            'ticket_claim_deleted',
            'department_deleted',
            'collection_member_inactivated',
            'claim_member_removed',
            'claim_expired',
            'address_changed',
          ])
          .optional(),
        revoke_reason_detail: zod
          .string()
          .max(
            getIssuedTicketsWithTravellerByTransactionIDResponseTicketRevokeReasonDetailMax,
          )
          .optional()
          .describe('Extra detail about why the issued ticket was revoked'),
        revoked_by: zod
          .string()
          .uuid()
          .optional()
          .describe(
            'The ID of the user who revoked the issued ticket. Only set when revoke_reason is revoked_by_user',
          ),
        created_at: zod
          .string()
          .datetime({})
          .describe('The date and time when the issued ticket was created'),
        updated_at: zod
          .string()
          .datetime({})
          .describe(
            'The date and time when the issued ticket was last updated',
          ),
        expires_at: zod
          .string()
          .datetime({})
          .optional()
          .describe('The date and time when the issued ticket was expired'),
        bobcat_mtb_product_ids: zod
          .array(zod.string())
          .describe(
            'The list of Bobcat MTB product IDs associated with the issued ticket',
          ),
        recipient_name: zod
          .string()
          .optional()
          .describe(
            'The name of the intended recipient. Used when purchasing tickets for external recipients',
          ),
        loan_transaction_id: zod
          .string()
          .optional()
          .describe(
            'The ID of the active loan transaction. Present when the ticket is currently loaned out.',
          ),
        bobcat_purchase_transaction_id: zod
          .string()
          .optional()
          .describe(
            'The ID of the Bobcat purchase transaction that issued the ticket, not of\nits loans or refunds. Tickets bought together in one purchase share it.\nAbsent when the issuing purchase is unknown.\n',
          ),
        bobcat_order_id: zod
          .string()
          .optional()
          .describe(
            "The Bobcat order ID of the Bobcat purchase that issued the ticket. Unlike\na transaction's bobcat_order_id it does not depend on how the ticket is\nbilled, so partial-payment and non-invoiced tickets have one too. Tickets\nbought together in one purchase share it. Absent when the issuing\npurchase is unknown.\n",
          ),
      })
      .describe('IssuedTicket'),
    transaction_ticket: zod.object({
      transaction_id: zod.string().uuid(),
      issued_ticket_id: zod.string().uuid(),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
      deleted_at: zod.string().datetime({}).optional(),
      original_bearer_type: zod.enum(['smartcard', 'smartphone']).optional(),
      original_bearer: zod
        .string()
        .optional()
        .describe(
          'If smartcard, a serial number. If smartphone, an email adress',
        ),
      original_bobcat_bearer_id: zod.string().optional(),
    }),
    traveller_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the traveller'),
    traveller_first_name: zod
      .string()
      .optional()
      .describe('The first name of the traveller'),
    traveller_last_name: zod
      .string()
      .optional()
      .describe('The last name of the traveller'),
  })
  .describe('IssuedTicketWithTraveller');
export const getIssuedTicketsWithTravellerByTransactionIDResponse = zod.array(
  getIssuedTicketsWithTravellerByTransactionIDResponseItem,
);

/**
 * Get the tickets for a traveller
 * @summary Get tickets for traveller
 */
export const getTicketsForTravellerParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const getTicketsForTravellerResponseRevokeReasonDetailMax = 100;

export const getTicketsForTravellerResponseItem = zod
  .object({
    id: zod.string().uuid().describe('The ID of the issued ticket'),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    organization_id: zod.string().uuid().describe('The ID of the organization'),
    department_id: zod.string().uuid().describe('The ID of the department'),
    order_id: zod.string().uuid().describe('The ID of the order'),
    traveller_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the traveller'),
    collection_member_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the collection member'),
    collection_ticket_claim_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the collection ticket claim'),
    collection_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the collection'),
    state: zod.enum([
      'active',
      'inactive',
      'blacklisted',
      'cancelled',
      'expired',
      'marked_for_deletion',
      'revoked',
    ]),
    product_class: zod.string(),
    traveller_class: zod.string(),
    tags: zod.array(zod.string()),
    revoke_at: zod
      .string()
      .datetime({})
      .optional()
      .describe('The date and time when the issued ticket was revoked'),
    revoke_reason: zod
      .enum([
        'revoked_by_user',
        'ticket_claim_deleted',
        'department_deleted',
        'collection_member_inactivated',
        'claim_member_removed',
        'claim_expired',
        'address_changed',
      ])
      .optional(),
    revoke_reason_detail: zod
      .string()
      .max(getTicketsForTravellerResponseRevokeReasonDetailMax)
      .optional()
      .describe('Extra detail about why the issued ticket was revoked'),
    revoked_by: zod
      .string()
      .uuid()
      .optional()
      .describe(
        'The ID of the user who revoked the issued ticket. Only set when revoke_reason is revoked_by_user',
      ),
    created_at: zod
      .string()
      .datetime({})
      .describe('The date and time when the issued ticket was created'),
    updated_at: zod
      .string()
      .datetime({})
      .describe('The date and time when the issued ticket was last updated'),
    expires_at: zod
      .string()
      .datetime({})
      .optional()
      .describe('The date and time when the issued ticket was expired'),
    bobcat_mtb_product_ids: zod
      .array(zod.string())
      .describe(
        'The list of Bobcat MTB product IDs associated with the issued ticket',
      ),
    recipient_name: zod
      .string()
      .optional()
      .describe(
        'The name of the intended recipient. Used when purchasing tickets for external recipients',
      ),
    loan_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the active loan transaction. Present when the ticket is currently loaned out.',
      ),
    bobcat_purchase_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the Bobcat purchase transaction that issued the ticket, not of\nits loans or refunds. Tickets bought together in one purchase share it.\nAbsent when the issuing purchase is unknown.\n',
      ),
    bobcat_order_id: zod
      .string()
      .optional()
      .describe(
        "The Bobcat order ID of the Bobcat purchase that issued the ticket. Unlike\na transaction's bobcat_order_id it does not depend on how the ticket is\nbilled, so partial-payment and non-invoiced tickets have one too. Tickets\nbought together in one purchase share it. Absent when the issuing\npurchase is unknown.\n",
      ),
  })
  .describe('IssuedTicket')
  .and(
    zod.object({
      expires_at: zod.string().datetime({}).optional(),
      department_name: zod.string(),
      traveller_first_name: zod.string().optional(),
      traveller_last_name: zod.string().optional(),
      traveller_email: zod.string().optional(),
      collection_name: zod.string().optional(),
      collection_type: zod
        .enum([
          'master',
          'school-transportation',
          'school-student-travel',
          'school-child-and-youth',
        ])
        .optional(),
    }),
  );
export const getTicketsForTravellerResponse = zod.array(
  getTicketsForTravellerResponseItem,
);

/**
 * Get tickets for user organization
 * @summary Get tickets for user organization
 */
export const getTicketsForUserOrganizationResponseRevokeReasonDetailMax = 100;

export const getTicketsForUserOrganizationResponseItem = zod
  .object({
    id: zod.string().uuid().describe('The ID of the issued ticket'),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    organization_id: zod.string().uuid().describe('The ID of the organization'),
    department_id: zod.string().uuid().describe('The ID of the department'),
    order_id: zod.string().uuid().describe('The ID of the order'),
    traveller_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the traveller'),
    collection_member_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the collection member'),
    collection_ticket_claim_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the collection ticket claim'),
    collection_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the collection'),
    state: zod.enum([
      'active',
      'inactive',
      'blacklisted',
      'cancelled',
      'expired',
      'marked_for_deletion',
      'revoked',
    ]),
    product_class: zod.string(),
    traveller_class: zod.string(),
    tags: zod.array(zod.string()),
    revoke_at: zod
      .string()
      .datetime({})
      .optional()
      .describe('The date and time when the issued ticket was revoked'),
    revoke_reason: zod
      .enum([
        'revoked_by_user',
        'ticket_claim_deleted',
        'department_deleted',
        'collection_member_inactivated',
        'claim_member_removed',
        'claim_expired',
        'address_changed',
      ])
      .optional(),
    revoke_reason_detail: zod
      .string()
      .max(getTicketsForUserOrganizationResponseRevokeReasonDetailMax)
      .optional()
      .describe('Extra detail about why the issued ticket was revoked'),
    revoked_by: zod
      .string()
      .uuid()
      .optional()
      .describe(
        'The ID of the user who revoked the issued ticket. Only set when revoke_reason is revoked_by_user',
      ),
    created_at: zod
      .string()
      .datetime({})
      .describe('The date and time when the issued ticket was created'),
    updated_at: zod
      .string()
      .datetime({})
      .describe('The date and time when the issued ticket was last updated'),
    expires_at: zod
      .string()
      .datetime({})
      .optional()
      .describe('The date and time when the issued ticket was expired'),
    bobcat_mtb_product_ids: zod
      .array(zod.string())
      .describe(
        'The list of Bobcat MTB product IDs associated with the issued ticket',
      ),
    recipient_name: zod
      .string()
      .optional()
      .describe(
        'The name of the intended recipient. Used when purchasing tickets for external recipients',
      ),
    loan_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the active loan transaction. Present when the ticket is currently loaned out.',
      ),
    bobcat_purchase_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the Bobcat purchase transaction that issued the ticket, not of\nits loans or refunds. Tickets bought together in one purchase share it.\nAbsent when the issuing purchase is unknown.\n',
      ),
    bobcat_order_id: zod
      .string()
      .optional()
      .describe(
        "The Bobcat order ID of the Bobcat purchase that issued the ticket. Unlike\na transaction's bobcat_order_id it does not depend on how the ticket is\nbilled, so partial-payment and non-invoiced tickets have one too. Tickets\nbought together in one purchase share it. Absent when the issuing\npurchase is unknown.\n",
      ),
  })
  .describe('IssuedTicket')
  .and(
    zod.object({
      expires_at: zod.string().datetime({}).optional(),
      department_name: zod.string(),
      traveller_first_name: zod.string().optional(),
      traveller_last_name: zod.string().optional(),
      traveller_email: zod.string().optional(),
      collection_name: zod.string().optional(),
      collection_type: zod
        .enum([
          'master',
          'school-transportation',
          'school-student-travel',
          'school-child-and-youth',
        ])
        .optional(),
    }),
  );
export const getTicketsForUserOrganizationResponse = zod.array(
  getTicketsForUserOrganizationResponseItem,
);

/**
 * Revoke an issued ticket
 * @summary Revoke ticket
 */
export const revokeIssuedTicketParams = zod.object({
  ID: zod.string().uuid(),
});

export const revokeIssuedTicketBodyRevokeReasonDetailMax = 100;

export const revokeIssuedTicketBody = zod.object({
  revoke_reason_detail: zod
    .string()
    .min(1)
    .max(revokeIssuedTicketBodyRevokeReasonDetailMax)
    .optional()
    .describe(
      'Extra detail about why the ticket is revoked. Stored on the ticket and appended to the reason sent to Bobcat. The bound keeps the combined Bobcat reason under its 128-character limit.',
    ),
});

export const revokeIssuedTicketResponseRevokeReasonDetailMax = 100;

export const revokeIssuedTicketResponse = zod
  .object({
    id: zod.string().uuid().describe('The ID of the issued ticket'),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    organization_id: zod.string().uuid().describe('The ID of the organization'),
    department_id: zod.string().uuid().describe('The ID of the department'),
    order_id: zod.string().uuid().describe('The ID of the order'),
    traveller_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the traveller'),
    collection_member_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the collection member'),
    collection_ticket_claim_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the collection ticket claim'),
    collection_id: zod
      .string()
      .uuid()
      .optional()
      .describe('The ID of the collection'),
    state: zod.enum([
      'active',
      'inactive',
      'blacklisted',
      'cancelled',
      'expired',
      'marked_for_deletion',
      'revoked',
    ]),
    product_class: zod.string(),
    traveller_class: zod.string(),
    tags: zod.array(zod.string()),
    revoke_at: zod
      .string()
      .datetime({})
      .optional()
      .describe('The date and time when the issued ticket was revoked'),
    revoke_reason: zod
      .enum([
        'revoked_by_user',
        'ticket_claim_deleted',
        'department_deleted',
        'collection_member_inactivated',
        'claim_member_removed',
        'claim_expired',
        'address_changed',
      ])
      .optional(),
    revoke_reason_detail: zod
      .string()
      .max(revokeIssuedTicketResponseRevokeReasonDetailMax)
      .optional()
      .describe('Extra detail about why the issued ticket was revoked'),
    revoked_by: zod
      .string()
      .uuid()
      .optional()
      .describe(
        'The ID of the user who revoked the issued ticket. Only set when revoke_reason is revoked_by_user',
      ),
    created_at: zod
      .string()
      .datetime({})
      .describe('The date and time when the issued ticket was created'),
    updated_at: zod
      .string()
      .datetime({})
      .describe('The date and time when the issued ticket was last updated'),
    expires_at: zod
      .string()
      .datetime({})
      .optional()
      .describe('The date and time when the issued ticket was expired'),
    bobcat_mtb_product_ids: zod
      .array(zod.string())
      .describe(
        'The list of Bobcat MTB product IDs associated with the issued ticket',
      ),
    recipient_name: zod
      .string()
      .optional()
      .describe(
        'The name of the intended recipient. Used when purchasing tickets for external recipients',
      ),
    loan_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the active loan transaction. Present when the ticket is currently loaned out.',
      ),
    bobcat_purchase_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the Bobcat purchase transaction that issued the ticket, not of\nits loans or refunds. Tickets bought together in one purchase share it.\nAbsent when the issuing purchase is unknown.\n',
      ),
    bobcat_order_id: zod
      .string()
      .optional()
      .describe(
        "The Bobcat order ID of the Bobcat purchase that issued the ticket. Unlike\na transaction's bobcat_order_id it does not depend on how the ticket is\nbilled, so partial-payment and non-invoiced tickets have one too. Tickets\nbought together in one purchase share it. Absent when the issuing\npurchase is unknown.\n",
      ),
  })
  .describe('IssuedTicket');

/**
 * @summary Get bearers for issued ticket
 */
export const getBearersForIssuedTicketParams = zod.object({
  ticketID: zod.string().uuid().describe('The ID of the issued ticket'),
});

export const getBearersForIssuedTicketResponseItem = zod
  .object({
    mtb_product_id: zod.string().describe('ID of the bobcat mtb product'),
    mtb_bearer_id: zod
      .string()
      .optional()
      .describe('ID of the bearer for the bobcat mtb product'),
  })
  .describe('Bearer for issued ticket');
export const getBearersForIssuedTicketResponse = zod.array(
  getBearersForIssuedTicketResponseItem,
);

/**
 * @summary Update bearer for issued ticket
 */
export const updateBearerForIssuedTicketParams = zod.object({
  ticketID: zod.string().uuid(),
});

export const updateBearerForIssuedTicketBody = zod
  .object({
    mtb_bearer_id: zod
      .string()
      .describe('ID of the bearer for the bobcat mtb product'),
  })
  .describe('Update bearer for issued ticket');

/**
 * Get all transactions (purchases, refunds, transfers) that reference the issued ticket
 * @summary Get transactions for issued ticket
 */
export const getTransactionsForIssuedTicketParams = zod.object({
  ticketID: zod.string().uuid().describe('The ID of the issued ticket'),
});

export const getTransactionsForIssuedTicketResponseVatItemRateMin = 0;
export const getTransactionsForIssuedTicketResponseVatItemRateMax = 100;

export const getTransactionsForIssuedTicketResponseVatItemAmountMin = 0;

export const getTransactionsForIssuedTicketResponseItem = zod.object({
  id: zod.string().uuid(),
  tenant_id: zod
    .string()
    .describe(
      'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
    ),
  organization_id: zod.string().uuid(),
  department_id: zod.string().uuid(),
  order_id: zod.string().uuid(),
  collection_ticket_claim_id: zod.string().uuid().optional(),
  collection_id: zod.string().uuid().optional(),
  state: zod.enum(['captured', 'refunded']),
  refund_transaction_id: zod.string().uuid().optional(),
  refunded_transaction_id: zod.string().uuid().optional(),
  bobcat_order_id: zod
    .string()
    .optional()
    .describe(
      "The Bobcat order ID of the Bobcat purchase this transaction settles, or\nfor a refund the purchase it refunds. Absent when no Bobcat purchase is\nbehind the transaction, as for monthly partial-payment fees. The Bobcat\npurchase that issued a ticket is on the ticket's own bobcat_order_id.\n",
    ),
  bobcat_transaction_id: zod
    .string()
    .optional()
    .describe(
      'The ID of the Bobcat purchase transaction behind this transaction, with\nthe same presence as bobcat_order_id.\n',
    ),
  amount_inc_vat: zod.number(),
  amount_ex_vat: zod.number(),
  created_at: zod.string().datetime({}),
  updated_at: zod.string().datetime({}),
  vat: zod.array(
    zod.object({
      rate: zod
        .number()
        .min(getTransactionsForIssuedTicketResponseVatItemRateMin)
        .max(getTransactionsForIssuedTicketResponseVatItemRateMax)
        .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
      amount: zod
        .number()
        .min(getTransactionsForIssuedTicketResponseVatItemAmountMin),
    }),
  ),
  source: zod.enum([
    'portal',
    'allpay',
    'walletcard',
    'alltix-resellers',
    'alltix-resellers-portal',
  ]),
  sales_channel: zod.enum(['corporate', 'school', 'benefit']),
  reason: zod
    .string()
    .optional()
    .describe(
      'A short (possible single-word) description of the purpose for this\npurchase. Printed in invoice specifications.\n',
    ),
  grouping_key: zod
    .string()
    .optional()
    .describe('Used to group transactions together in invoice specifications'),
});
export const getTransactionsForIssuedTicketResponse = zod.array(
  getTransactionsForIssuedTicketResponseItem,
);

/**
 * @summary Lend issued ticket to a different bearer
 */
export const lendIssuedTicketParams = zod.object({
  ticketID: zod.string().uuid(),
});

export const lendIssuedTicketBody = zod
  .object({
    mtb_bearer_id: zod
      .string()
      .describe('ID of the target bearer for the loan'),
  })
  .describe('Lend issued ticket to a different bearer');

/**
 * Fetches the current data from Bobcat Sales for the requested issued tickets and
synchronizes any state changes (active/inactive and final states) back to the local
database. expires_at is the stored value and is never synchronized. Returns the current
Bobcat-derived data for every requested ticket: the current activation window, activation
counts and validity bounds. A maximum of 50 ids may be requested per call.

 * @summary Get Bobcat Sales data for issued tickets
 */
export const getBobcatDataForTicketsQueryParams = zod.object({
  ids: zod.string(),
});

export const getBobcatDataForTicketsResponse = zod.record(
  zod.string(),
  zod.object({
    state: zod.enum([
      'active',
      'inactive',
      'blacklisted',
      'cancelled',
      'expired',
      'marked_for_deletion',
      'revoked',
    ]),
    expires_at: zod.string().datetime({}).optional(),
    current_validity_start: zod
      .string()
      .datetime({})
      .optional()
      .describe(
        "Start of the current activation's validity. Unset until the ticket has been activated.",
      ),
    current_validity_end: zod
      .string()
      .datetime({})
      .optional()
      .describe(
        "End of the current activation's validity. Unset until the ticket has been activated.",
      ),
    activations_total: zod
      .number()
      .optional()
      .describe(
        'Total number of activations on the ticket. Present for every ticket Bobcat reports activation counts for.',
      ),
    activations_left: zod
      .number()
      .optional()
      .describe('Number of activations left on the ticket.'),
    earliest_start_of_validity: zod
      .string()
      .datetime({})
      .optional()
      .describe('Earliest time the ticket may be activated.'),
    latest_start_of_validity: zod
      .string()
      .datetime({})
      .optional()
      .describe('Latest time the ticket may be activated.'),
    end_of_activation_period: zod
      .string()
      .datetime({})
      .optional()
      .describe(
        'End of the period in which the ticket can be activated and used.',
      ),
  }),
);

/**
 * List files for the current user
 * @summary List files for user
 */
export const getFilesListQueryOffsetMin = 0;

export const getFilesListQueryLimitMax = 100;

export const getFilesListQueryParams = zod.object({
  offset: zod
    .number()
    .min(getFilesListQueryOffsetMin)
    .optional()
    .describe('pagination - how many results to skip'),
  limit: zod
    .number()
    .min(1)
    .max(getFilesListQueryLimitMax)
    .optional()
    .describe(
      'pagination - how many results to return after skip, defaults to 50',
    ),
  from: zod
    .string()
    .datetime({})
    .optional()
    .describe('beginning of time window'),
  to: zod.string().datetime({}).optional().describe('end of time window'),
  department_id: zod
    .string()
    .uuid()
    .optional()
    .describe('only return files linked to this department'),
  name: zod
    .string()
    .optional()
    .describe(
      'only return files whose name contains this text, case-insensitive',
    ),
});

export const getFilesListResponseItem = zod
  .object({
    id: zod.string().uuid(),
    created_at: zod.string().datetime({}),
    department_ids: zod
      .array(zod.string().uuid())
      .describe('List of department IDs this file is linked to'),
    organization_id: zod
      .string()
      .uuid()
      .optional()
      .describe('Organization ID (null for tenant-level files)'),
  })
  .and(
    zod.object({
      type: zod.enum([
        'invoice-specification',
        'environmental-report',
        'invoice-data',
      ]),
      mime_type: zod.string().describe('MIME type'),
      name: zod.string().describe('Filename'),
      size: zod.number().describe('Filesize in bytes'),
      url: zod.string(),
    }),
  );
export const getFilesListResponse = zod.array(getFilesListResponseItem);

/**
 * Upload files for an organization or department
 * @summary Upload files
 */
export const uploadFilesBody = zod.object({
  files: zod.array(zod.instanceof(File)),
  metadata: zod
    .string()
    .describe('JSON-stringified array of FileUploadMetadata'),
});

/**
 * Get transactions for a tenant/organization
 * @summary Get transactions for a tenant/organization
 */
export const getTransactionsQueryOffsetMin = 0;

export const getTransactionsQueryLimitMax = 100;

export const getTransactionsQueryParams = zod.object({
  offset: zod
    .number()
    .min(getTransactionsQueryOffsetMin)
    .optional()
    .describe('pagination - how many results to skip'),
  limit: zod
    .number()
    .min(1)
    .max(getTransactionsQueryLimitMax)
    .optional()
    .describe(
      'pagination - how many results to return after skip, defaults to 50',
    ),
  from: zod
    .string()
    .datetime({})
    .optional()
    .describe('beginning of time window'),
  to: zod.string().datetime({}).optional().describe('end of time window'),
  department_id: zod
    .string()
    .uuid()
    .optional()
    .describe('only return transactions for this department'),
  bobcat_order_id: zod
    .string()
    .optional()
    .describe('only return transactions with this exact bobcat order id'),
  source: zod
    .enum([
      'portal',
      'allpay',
      'walletcard',
      'alltix-resellers',
      'alltix-resellers-portal',
    ])
    .optional()
    .describe('only return transactions from this source'),
  state: zod
    .enum(['captured', 'refunded'])
    .optional()
    .describe('only return transactions in this state'),
});

export const getTransactionsResponseTransactionVatItemRateMin = 0;
export const getTransactionsResponseTransactionVatItemRateMax = 100;

export const getTransactionsResponseTransactionVatItemAmountMin = 0;

export const getTransactionsResponseItem = zod.object({
  transaction: zod.object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    organization_id: zod.string().uuid(),
    department_id: zod.string().uuid(),
    order_id: zod.string().uuid(),
    collection_ticket_claim_id: zod.string().uuid().optional(),
    collection_id: zod.string().uuid().optional(),
    state: zod.enum(['captured', 'refunded']),
    refund_transaction_id: zod.string().uuid().optional(),
    refunded_transaction_id: zod.string().uuid().optional(),
    bobcat_order_id: zod
      .string()
      .optional()
      .describe(
        "The Bobcat order ID of the Bobcat purchase this transaction settles, or\nfor a refund the purchase it refunds. Absent when no Bobcat purchase is\nbehind the transaction, as for monthly partial-payment fees. The Bobcat\npurchase that issued a ticket is on the ticket's own bobcat_order_id.\n",
      ),
    bobcat_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the Bobcat purchase transaction behind this transaction, with\nthe same presence as bobcat_order_id.\n',
      ),
    amount_inc_vat: zod.number(),
    amount_ex_vat: zod.number(),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    vat: zod.array(
      zod.object({
        rate: zod
          .number()
          .min(getTransactionsResponseTransactionVatItemRateMin)
          .max(getTransactionsResponseTransactionVatItemRateMax)
          .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
        amount: zod
          .number()
          .min(getTransactionsResponseTransactionVatItemAmountMin),
      }),
    ),
    source: zod.enum([
      'portal',
      'allpay',
      'walletcard',
      'alltix-resellers',
      'alltix-resellers-portal',
    ]),
    sales_channel: zod.enum(['corporate', 'school', 'benefit']),
    reason: zod
      .string()
      .optional()
      .describe(
        'A short (possible single-word) description of the purpose for this\npurchase. Printed in invoice specifications.\n',
      ),
    grouping_key: zod
      .string()
      .optional()
      .describe(
        'Used to group transactions together in invoice specifications',
      ),
  }),
  transaction_product: zod.object({
    id: zod.string().uuid(),
    transaction_id: zod.string().uuid(),
    count: zod.number(),
    title: zod.string(),
    subtitle: zod.string().optional(),
    bobcat_tags: zod.array(zod.string()),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    deleted_at: zod.string().datetime({}).optional(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
  }),
});
export const getTransactionsResponse = zod.array(getTransactionsResponseItem);

/**
 * Export transactions for a tenant/organization
 * @summary Export transactions for a tenant/organization
 */
export const exportTransactionsQueryParams = zod.object({
  from: zod.string().datetime({}).describe('time range must not exceed 1y'),
  to: zod.string().datetime({}).describe('time range must not exceed 1y'),
});

export const exportTransactionsResponseTransactionVatItemRateMin = 0;
export const exportTransactionsResponseTransactionVatItemRateMax = 100;

export const exportTransactionsResponseTransactionVatItemAmountMin = 0;

export const exportTransactionsResponseOrganizationOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const exportTransactionsResponseItem = zod.object({
  transaction: zod.object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    organization_id: zod.string().uuid(),
    department_id: zod.string().uuid(),
    order_id: zod.string().uuid(),
    collection_ticket_claim_id: zod.string().uuid().optional(),
    collection_id: zod.string().uuid().optional(),
    state: zod.enum(['captured', 'refunded']),
    refund_transaction_id: zod.string().uuid().optional(),
    refunded_transaction_id: zod.string().uuid().optional(),
    bobcat_order_id: zod
      .string()
      .optional()
      .describe(
        "The Bobcat order ID of the Bobcat purchase this transaction settles, or\nfor a refund the purchase it refunds. Absent when no Bobcat purchase is\nbehind the transaction, as for monthly partial-payment fees. The Bobcat\npurchase that issued a ticket is on the ticket's own bobcat_order_id.\n",
      ),
    bobcat_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the Bobcat purchase transaction behind this transaction, with\nthe same presence as bobcat_order_id.\n',
      ),
    amount_inc_vat: zod.number(),
    amount_ex_vat: zod.number(),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    vat: zod.array(
      zod.object({
        rate: zod
          .number()
          .min(exportTransactionsResponseTransactionVatItemRateMin)
          .max(exportTransactionsResponseTransactionVatItemRateMax)
          .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
        amount: zod
          .number()
          .min(exportTransactionsResponseTransactionVatItemAmountMin),
      }),
    ),
    source: zod.enum([
      'portal',
      'allpay',
      'walletcard',
      'alltix-resellers',
      'alltix-resellers-portal',
    ]),
    sales_channel: zod.enum(['corporate', 'school', 'benefit']),
    reason: zod
      .string()
      .optional()
      .describe(
        'A short (possible single-word) description of the purpose for this\npurchase. Printed in invoice specifications.\n',
      ),
    grouping_key: zod
      .string()
      .optional()
      .describe(
        'Used to group transactions together in invoice specifications',
      ),
  }),
  transaction_product: zod.object({
    id: zod.string().uuid(),
    transaction_id: zod.string().uuid(),
    count: zod.number(),
    title: zod.string(),
    subtitle: zod.string().optional(),
    bobcat_tags: zod.array(zod.string()),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    deleted_at: zod.string().datetime({}).optional(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
  }),
  organization: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod
        .object({
          name: zod.string(),
          organization_number: zod
            .string()
            .regex(
              exportTransactionsResponseOrganizationOrganizationNumberRegExp,
            ),
          state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
          credit: zod.number().optional(),
          discount_codes: zod
            .record(
              zod.string(),
              zod.object({
                half_product: zod
                  .string()
                  .optional()
                  .describe('Discount code for half product'),
                full_product: zod
                  .string()
                  .optional()
                  .describe('Discount code for full product'),
              }),
            )
            .describe('Discount codes per collection type'),
          enabled_collection_types: zod
            .array(
              zod.enum([
                'school-transportation',
                'school-student-travel',
                'school-child-and-youth',
              ]),
            )
            .describe('Opt-in collection types enabled for this organization'),
          gln: zod.string().optional(),
          einvoice_email: zod.string().email().optional(),
          selfmanaged_school_claims: zod
            .boolean()
            .optional()
            .describe(
              'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
            ),
        })
        .and(
          zod.object({
            is_internal: zod.boolean(),
          }),
        ),
    ),
  department: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        parent_id: zod.string().uuid().optional(),
        name: zod.string().min(1),
        organization_number: zod.string().optional(),
        delivery_address: zod.object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        }),
      }),
    )
    .and(
      zod.object({
        deleted_at: zod.string().datetime({}).optional(),
        organization_id: zod.string().uuid(),
        payer_id: zod.string().uuid().optional(),
      }),
    ),
  payer_id: zod.string().uuid(),
  payer_address: zod.object({
    street: zod.string().min(1),
    zip_code: zod
      .string()
      .min(1)
      .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
    city: zod.string().min(1),
    care_of: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
      ),
  }),
  payer_reference: zod.string(),
  payer_details: zod.record(zod.string(), zod.string()),
});
export const exportTransactionsResponse = zod.array(
  exportTransactionsResponseItem,
);

/**
 * Get transaction with products
 * @summary Get transaction with products
 */
export const getTransactionWithProductsParams = zod.object({
  transactionID: zod.string().uuid(),
});

export const getTransactionWithProductsResponseTransactionVatItemRateMin = 0;
export const getTransactionWithProductsResponseTransactionVatItemRateMax = 100;

export const getTransactionWithProductsResponseTransactionVatItemAmountMin = 0;

export const getTransactionWithProductsResponse = zod.object({
  transaction: zod.object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    organization_id: zod.string().uuid(),
    department_id: zod.string().uuid(),
    order_id: zod.string().uuid(),
    collection_ticket_claim_id: zod.string().uuid().optional(),
    collection_id: zod.string().uuid().optional(),
    state: zod.enum(['captured', 'refunded']),
    refund_transaction_id: zod.string().uuid().optional(),
    refunded_transaction_id: zod.string().uuid().optional(),
    bobcat_order_id: zod
      .string()
      .optional()
      .describe(
        "The Bobcat order ID of the Bobcat purchase this transaction settles, or\nfor a refund the purchase it refunds. Absent when no Bobcat purchase is\nbehind the transaction, as for monthly partial-payment fees. The Bobcat\npurchase that issued a ticket is on the ticket's own bobcat_order_id.\n",
      ),
    bobcat_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the Bobcat purchase transaction behind this transaction, with\nthe same presence as bobcat_order_id.\n',
      ),
    amount_inc_vat: zod.number(),
    amount_ex_vat: zod.number(),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    vat: zod.array(
      zod.object({
        rate: zod
          .number()
          .min(getTransactionWithProductsResponseTransactionVatItemRateMin)
          .max(getTransactionWithProductsResponseTransactionVatItemRateMax)
          .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
        amount: zod
          .number()
          .min(getTransactionWithProductsResponseTransactionVatItemAmountMin),
      }),
    ),
    source: zod.enum([
      'portal',
      'allpay',
      'walletcard',
      'alltix-resellers',
      'alltix-resellers-portal',
    ]),
    sales_channel: zod.enum(['corporate', 'school', 'benefit']),
    reason: zod
      .string()
      .optional()
      .describe(
        'A short (possible single-word) description of the purpose for this\npurchase. Printed in invoice specifications.\n',
      ),
    grouping_key: zod
      .string()
      .optional()
      .describe(
        'Used to group transactions together in invoice specifications',
      ),
  }),
  transaction_product: zod.object({
    id: zod.string().uuid(),
    transaction_id: zod.string().uuid(),
    count: zod.number(),
    title: zod.string(),
    subtitle: zod.string().optional(),
    bobcat_tags: zod.array(zod.string()),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    deleted_at: zod.string().datetime({}).optional(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
  }),
});

/**
 * Refund a transaction
 * @summary Refund transaction
 */
export const refundTransactionParams = zod.object({
  transactionID: zod.string().uuid(),
});

export const refundTransactionResponseVatItemRateMin = 0;
export const refundTransactionResponseVatItemRateMax = 100;

export const refundTransactionResponseVatItemAmountMin = 0;

export const refundTransactionResponse = zod.object({
  id: zod.string().uuid(),
  tenant_id: zod
    .string()
    .describe(
      'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
    ),
  organization_id: zod.string().uuid(),
  department_id: zod.string().uuid(),
  order_id: zod.string().uuid(),
  collection_ticket_claim_id: zod.string().uuid().optional(),
  collection_id: zod.string().uuid().optional(),
  state: zod.enum(['captured', 'refunded']),
  refund_transaction_id: zod.string().uuid().optional(),
  refunded_transaction_id: zod.string().uuid().optional(),
  bobcat_order_id: zod
    .string()
    .optional()
    .describe(
      "The Bobcat order ID of the Bobcat purchase this transaction settles, or\nfor a refund the purchase it refunds. Absent when no Bobcat purchase is\nbehind the transaction, as for monthly partial-payment fees. The Bobcat\npurchase that issued a ticket is on the ticket's own bobcat_order_id.\n",
    ),
  bobcat_transaction_id: zod
    .string()
    .optional()
    .describe(
      'The ID of the Bobcat purchase transaction behind this transaction, with\nthe same presence as bobcat_order_id.\n',
    ),
  amount_inc_vat: zod.number(),
  amount_ex_vat: zod.number(),
  created_at: zod.string().datetime({}),
  updated_at: zod.string().datetime({}),
  vat: zod.array(
    zod.object({
      rate: zod
        .number()
        .min(refundTransactionResponseVatItemRateMin)
        .max(refundTransactionResponseVatItemRateMax)
        .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
      amount: zod.number().min(refundTransactionResponseVatItemAmountMin),
    }),
  ),
  source: zod.enum([
    'portal',
    'allpay',
    'walletcard',
    'alltix-resellers',
    'alltix-resellers-portal',
  ]),
  sales_channel: zod.enum(['corporate', 'school', 'benefit']),
  reason: zod
    .string()
    .optional()
    .describe(
      'A short (possible single-word) description of the purpose for this\npurchase. Printed in invoice specifications.\n',
    ),
  grouping_key: zod
    .string()
    .optional()
    .describe('Used to group transactions together in invoice specifications'),
});

/**
 * List names for users by IDs
 * @summary List names for users by IDs
 */
export const usersListNamesForIDsQueryParams = zod.object({
  ids: zod
    .string()
    .describe('A comma-separated list of user IDs to list names for'),
});

export const usersListNamesForIDsResponseItem = zod.object({
  id: zod.string().uuid(),
  firstname: zod.string(),
  lastname: zod.string(),
});
export const usersListNamesForIDsResponse = zod.array(
  usersListNamesForIDsResponseItem,
);

/**
 * Deletes a user profile by ID
 * @summary Deletes a user profile by ID
 */
export const deleteUserProfileByIDParams = zod.object({
  ID: zod.string().uuid().describe('The ID of the user profile to delete'),
});

export const deleteUserProfileByIDResponse = zod.object({
  id: zod.string().uuid(),
  email: zod.string().email(),
  tenant_id: zod.string(),
  tenant: zod.string(),
  role_id: zod.string().uuid(),
  role: zod.string(),
  active: zod.boolean(),
  organization_id: zod.string().uuid().optional(),
  organization: zod.string().optional(),
  last_used: zod.string().datetime({}).optional(),
  expires_at: zod.string().datetime({}).optional(),
  created_at: zod.string().datetime({}),
  updated_at: zod.string().datetime({}),
});

/**
 * Get spent credit for organization
 * @summary Get spent credit for organization
 */
export const getSpentCreditResponse = zod.number();

/**
 * TravelCard claimability check
 * @summary TravelCard claimability check
 */
export const travelCardIsClaimableQueryParams = zod.object({
  serial: zod.string(),
});

export const travelCardIsClaimableResponse = zod.object({
  claimable: zod.boolean().describe('is the card claimable?'),
  reason: zod.string().optional(),
});

/**
 * Claim a TravelCard
 * @summary Claim a TravelCard
 */
export const travelCardClaimBodyLabelMax = 100;

export const travelCardClaimBody = zod.object({
  traveller_id: zod.string().uuid(),
  card_serial: zod.string(),
  label: zod.string().max(travelCardClaimBodyLabelMax).optional(),
});

/**
 * Rename a TravelCard
 * @summary Rename a TravelCard
 */
export const travelCardRenameBodyLabelMax = 100;

export const travelCardRenameBody = zod.object({
  traveller_id: zod.string().uuid(),
  serial: zod.string(),
  label: zod.string().max(travelCardRenameBodyLabelMax),
});

export const travelCardRenameResponseLabelMax = 100;

export const travelCardRenameResponse = zod.object({
  card_serial: zod.string(),
  bearer_id: zod.string(),
  label: zod.string().max(travelCardRenameResponseLabelMax).optional(),
});

/**
 * Claim a blank TravelCard for someone who does not exist in the portal. The card is associated with a parking traveller in bobcat and no record of it is kept here.
 * @summary Claim a TravelCard anonymously
 */
export const travelCardClaimAnonymousBodyCardSerialRegExp = new RegExp(
  '^[0-9]+$',
);
export const travelCardClaimAnonymousBodyLabelMax = 100;

export const travelCardClaimAnonymousBody = zod
  .object({
    card_serial: zod
      .string()
      .regex(travelCardClaimAnonymousBodyCardSerialRegExp),
    label: zod.string().max(travelCardClaimAnonymousBodyLabelMax).optional(),
  })
  .describe('Request to claim a TravelCard without recording it in the portal');

/**
 * Get a list of all card credits for the user's organization
 * @summary List card credits
 */
export const listCardCreditsQueryParams = zod.object({
  department_id: zod.string().uuid().optional(),
});

export const listCardCreditsResponseItem = zod
  .object({
    card_serial: zod.string(),
    organization_id: zod.string().uuid(),
    department_id: zod.string().uuid(),
    collection_member_id: zod.string().uuid().optional(),
    credit: zod.number(),
  })
  .and(
    zod.object({
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
      BobcatTravellerID: zod.string(),
      BobcatBearerID: zod.string(),
      BobcatWalletID: zod.string(),
      LastToppedUp: zod.string().datetime({}).optional(),
    }),
  );
export const listCardCreditsResponse = zod.array(listCardCreditsResponseItem);

/**
 * Create a new credit on card
 * @summary Create credit on card
 */
export const createCardCreditBody = zod.object({
  card_serial: zod.string(),
  organization_id: zod.string().uuid(),
  department_id: zod.string().uuid(),
  collection_member_id: zod.string().uuid().optional(),
  credit: zod.number(),
});

/**
 * Check if a card serial is claimable
 * @summary Validate card credit serial
 */
export const validateCardCreditSerialParams = zod.object({
  cardSerial: zod.string(),
});

export const validateCardCreditSerialResponse = zod.object({
  claimable: zod.boolean().describe('Whether the card serial is claimable'),
  reason: zod
    .string()
    .optional()
    .describe('Reason why the card is claimable or not'),
});

/**
 * Update the selected card credit
 * @summary Update card credit
 */
export const updateCardCreditBySerialParams = zod.object({
  cardSerial: zod.string(),
});

export const updateCardCreditBySerialBody = zod.object({
  credit: zod.number().describe('The credit amount to set on the card'),
});

export const updateCardCreditBySerialResponse = zod
  .object({
    card_serial: zod.string(),
    organization_id: zod.string().uuid(),
    department_id: zod.string().uuid(),
    collection_member_id: zod.string().uuid().optional(),
    credit: zod.number(),
  })
  .and(
    zod.object({
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
      BobcatTravellerID: zod.string(),
      BobcatBearerID: zod.string(),
      BobcatWalletID: zod.string(),
      LastToppedUp: zod.string().datetime({}).optional(),
    }),
  );

/**
 * Deletes a card credit by card serial
 * @summary Deletes a card credit
 */
export const deleteCardCreditBySerialParams = zod.object({
  cardSerial: zod.string().describe('The card serial to delete'),
});

export const deleteCardCreditBySerialResponse = zod
  .object({
    card_serial: zod.string(),
    organization_id: zod.string().uuid(),
    department_id: zod.string().uuid(),
    collection_member_id: zod.string().uuid().optional(),
    credit: zod.number(),
  })
  .and(
    zod.object({
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
      BobcatTravellerID: zod.string(),
      BobcatBearerID: zod.string(),
      BobcatWalletID: zod.string(),
      LastToppedUp: zod.string().datetime({}).optional(),
    }),
  );

/**
 * Get a list of all organizations for the current tenant (including deleted)
 * @summary List organizations (including deleted)
 */
export const m2mListOrganizationsIncludingDeletedResponseOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const m2mListOrganizationsIncludingDeletedResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod
      .object({
        name: zod.string(),
        organization_number: zod
          .string()
          .regex(
            m2mListOrganizationsIncludingDeletedResponseOrganizationNumberRegExp,
          ),
        state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
        credit: zod.number().optional(),
        discount_codes: zod
          .record(
            zod.string(),
            zod.object({
              half_product: zod
                .string()
                .optional()
                .describe('Discount code for half product'),
              full_product: zod
                .string()
                .optional()
                .describe('Discount code for full product'),
            }),
          )
          .describe('Discount codes per collection type'),
        enabled_collection_types: zod
          .array(
            zod.enum([
              'school-transportation',
              'school-student-travel',
              'school-child-and-youth',
            ]),
          )
          .describe('Opt-in collection types enabled for this organization'),
        gln: zod.string().optional(),
        einvoice_email: zod.string().email().optional(),
        selfmanaged_school_claims: zod
          .boolean()
          .optional()
          .describe(
            'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
          ),
      })
      .and(
        zod.object({
          is_internal: zod.boolean(),
        }),
      ),
  );
export const m2mListOrganizationsIncludingDeletedResponse = zod.array(
  m2mListOrganizationsIncludingDeletedResponseItem,
);

/**
 * Get departments for tenant (includes deleted)
 * @summary List departments for tenant
 */

export const m2mListDepartmentsForTenantResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      parent_id: zod.string().uuid().optional(),
      name: zod.string().min(1),
      organization_number: zod.string().optional(),
      delivery_address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
    }),
  )
  .and(
    zod.object({
      deleted_at: zod.string().datetime({}).optional(),
      organization_id: zod.string().uuid(),
      payer_id: zod.string().uuid().optional(),
    }),
  );
export const m2mListDepartmentsForTenantResponse = zod.array(
  m2mListDepartmentsForTenantResponseItem,
);

/**
 * Fetches several travellers by ID
 * @summary Get travellers
 */
export const m2mTravellersGetManyQueryParams = zod.object({
  ids: zod.string().optional(),
});

export const m2mTravellersGetManyResponseNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const m2mTravellersGetManyResponsePhoneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const m2mTravellersGetManyResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      first_name: zod.string().optional(),
      last_name: zod.string().optional(),
      email: zod.string().optional(),
      national_identity_number: zod
        .string()
        .regex(m2mTravellersGetManyResponseNationalIdentityNumberRegExp)
        .optional(),
      phone: zod
        .string()
        .regex(m2mTravellersGetManyResponsePhoneRegExp)
        .optional(),
      delivery_address: zod
        .object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        })
        .optional(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod
        .string()
        .uuid()
        .describe('The unique identifier of an organization\n'),
      anonymized_at: zod.string().datetime({}).optional(),
      deleted_at: zod
        .string()
        .datetime({})
        .optional()
        .describe(
          'When the traveller was deleted. The global search is the only\ntraveller endpoint that returns deleted travellers; every other\ntraveller endpoint excludes them.\n',
        ),
      bobcat_private_email: zod.string().email().optional(),
      bobcat_private_id: zod.string().optional(),
      bobcat_alltix_id: zod.string().optional(),
      favored_bobcat_bearer_id: zod.string().optional(),
      keywords: zod
        .array(zod.string())
        .describe(
          'Searchable keywords associated with the traveller, such as the\nnational identity numbers of people the traveller has purchased\ntickets for. Read-only — cannot be set through the API.\n',
        ),
    }),
  );
export const m2mTravellersGetManyResponse = zod.array(
  m2mTravellersGetManyResponseItem,
);

/**
 * Get a list of all payers for the current tenant
 * @summary List payers for tenant
 */

export const m2mListPayersForTenantResponseItem = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
  })
  .and(
    zod.object({
      address: zod.object({
        street: zod.string().min(1),
        zip_code: zod
          .string()
          .min(1)
          .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
        city: zod.string().min(1),
        care_of: zod
          .string()
          .min(1)
          .optional()
          .describe(
            "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
          ),
      }),
      reference: zod.string(),
    }),
  )
  .and(
    zod.object({
      organization_id: zod.string().uuid(),
      details: zod.record(zod.string(), zod.string()),
    }),
  );
export const m2mListPayersForTenantResponse = zod.array(
  m2mListPayersForTenantResponseItem,
);

/**
 * Get Allpay users with billing details
 * @summary Get Allpay users with billing details
 */
export const m2mListAllpayUsersWithBillingDetailsResponseTravellerNationalIdentityNumberRegExp =
  new RegExp(
    '^\\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01]|[6-9]\\d)-[A-Z\\d]{2}\\d{2}$',
  );
export const m2mListAllpayUsersWithBillingDetailsResponseTravellerPhoneRegExp =
  new RegExp('^\\+[1-9][0-9]{1,14}$');

export const m2mListAllpayUsersWithBillingDetailsResponseOrganizationOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const m2mListAllpayUsersWithBillingDetailsResponseItem = zod.object({
  allpay_user: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        department_id: zod.string().uuid(),
        collection_member_id: zod.string().uuid(),
        credit: zod.number(),
      }),
    ),
  traveller: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        first_name: zod.string().optional(),
        last_name: zod.string().optional(),
        email: zod.string().optional(),
        national_identity_number: zod
          .string()
          .regex(
            m2mListAllpayUsersWithBillingDetailsResponseTravellerNationalIdentityNumberRegExp,
          )
          .optional(),
        phone: zod
          .string()
          .regex(
            m2mListAllpayUsersWithBillingDetailsResponseTravellerPhoneRegExp,
          )
          .optional(),
        delivery_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
      }),
    )
    .and(
      zod.object({
        organization_id: zod
          .string()
          .uuid()
          .describe('The unique identifier of an organization\n'),
        anonymized_at: zod.string().datetime({}).optional(),
        deleted_at: zod
          .string()
          .datetime({})
          .optional()
          .describe(
            'When the traveller was deleted. The global search is the only\ntraveller endpoint that returns deleted travellers; every other\ntraveller endpoint excludes them.\n',
          ),
        bobcat_private_email: zod.string().email().optional(),
        bobcat_private_id: zod.string().optional(),
        bobcat_alltix_id: zod.string().optional(),
        favored_bobcat_bearer_id: zod.string().optional(),
        keywords: zod
          .array(zod.string())
          .describe(
            'Searchable keywords associated with the traveller, such as the\nnational identity numbers of people the traveller has purchased\ntickets for. Read-only — cannot be set through the API.\n',
          ),
      }),
    ),
  collection_member: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        collection_id: zod.string().uuid(),
        guardian1_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
        guardian1_bus_stop: zod.string().optional().describe('Bus stop name'),
        guardian1_email: zod.string().email().optional(),
        guardian2_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
        guardian2_bus_stop: zod.string().optional().describe('Bus stop name'),
        guardian2_email: zod.string().email().optional(),
        school_name: zod.string().optional(),
        school_address: zod
          .object({
            street: zod.string().min(1),
            zip_code: zod
              .string()
              .min(1)
              .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
            city: zod.string().min(1),
            care_of: zod
              .string()
              .min(1)
              .optional()
              .describe(
                "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
              ),
          })
          .optional(),
        school_bus_stop: zod.string().optional().describe('Bus stop name'),
        half_product: zod.boolean(),
      }),
    )
    .and(
      zod.object({
        manually_modified: zod.boolean(),
        organization_id: zod
          .string()
          .uuid()
          .describe('The unique identifier of an organization\n'),
        traveller_id: zod.string().uuid(),
        active: zod.boolean(),
        inactivate_at: zod.string().datetime({}).optional(),
        inactivated_at: zod.string().datetime({}).optional(),
        anonymized_at: zod.string().datetime({}).optional(),
      }),
    ),
  organization: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod
        .object({
          name: zod.string(),
          organization_number: zod
            .string()
            .regex(
              m2mListAllpayUsersWithBillingDetailsResponseOrganizationOrganizationNumberRegExp,
            ),
          state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
          credit: zod.number().optional(),
          discount_codes: zod
            .record(
              zod.string(),
              zod.object({
                half_product: zod
                  .string()
                  .optional()
                  .describe('Discount code for half product'),
                full_product: zod
                  .string()
                  .optional()
                  .describe('Discount code for full product'),
              }),
            )
            .describe('Discount codes per collection type'),
          enabled_collection_types: zod
            .array(
              zod.enum([
                'school-transportation',
                'school-student-travel',
                'school-child-and-youth',
              ]),
            )
            .describe('Opt-in collection types enabled for this organization'),
          gln: zod.string().optional(),
          einvoice_email: zod.string().email().optional(),
          selfmanaged_school_claims: zod
            .boolean()
            .optional()
            .describe(
              'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
            ),
        })
        .and(
          zod.object({
            is_internal: zod.boolean(),
          }),
        ),
    ),
  department: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        parent_id: zod.string().uuid().optional(),
        name: zod.string().min(1),
        organization_number: zod.string().optional(),
        delivery_address: zod.object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        }),
      }),
    )
    .and(
      zod.object({
        deleted_at: zod.string().datetime({}).optional(),
        organization_id: zod.string().uuid(),
        payer_id: zod.string().uuid().optional(),
      }),
    ),
  payer_id: zod.string().uuid(),
  payer_address: zod.object({
    street: zod.string().min(1),
    zip_code: zod
      .string()
      .min(1)
      .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
    city: zod.string().min(1),
    care_of: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
      ),
  }),
  payer_reference: zod.string(),
  payer_details: zod.record(zod.string(), zod.string()),
});
export const m2mListAllpayUsersWithBillingDetailsResponse = zod.array(
  m2mListAllpayUsersWithBillingDetailsResponseItem,
);

/**
 * Get Transactions with billing details for date range
 * @summary Get Transactions with billing details for date range
 */
export const m2mListTransactionsWithBillingDetailsQueryParams = zod.object({
  from: zod.string().datetime({}).optional(),
  to: zod.string().datetime({}).optional(),
});

export const m2mListTransactionsWithBillingDetailsResponseTransactionVatItemRateMin = 0;
export const m2mListTransactionsWithBillingDetailsResponseTransactionVatItemRateMax = 100;

export const m2mListTransactionsWithBillingDetailsResponseTransactionVatItemAmountMin = 0;

export const m2mListTransactionsWithBillingDetailsResponseOrganizationOrganizationNumberRegExp =
  new RegExp('^\\d{6}-\\d{4}$');

export const m2mListTransactionsWithBillingDetailsResponseItem = zod.object({
  transaction: zod.object({
    id: zod.string().uuid(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
    organization_id: zod.string().uuid(),
    department_id: zod.string().uuid(),
    order_id: zod.string().uuid(),
    collection_ticket_claim_id: zod.string().uuid().optional(),
    collection_id: zod.string().uuid().optional(),
    state: zod.enum(['captured', 'refunded']),
    refund_transaction_id: zod.string().uuid().optional(),
    refunded_transaction_id: zod.string().uuid().optional(),
    bobcat_order_id: zod
      .string()
      .optional()
      .describe(
        "The Bobcat order ID of the Bobcat purchase this transaction settles, or\nfor a refund the purchase it refunds. Absent when no Bobcat purchase is\nbehind the transaction, as for monthly partial-payment fees. The Bobcat\npurchase that issued a ticket is on the ticket's own bobcat_order_id.\n",
      ),
    bobcat_transaction_id: zod
      .string()
      .optional()
      .describe(
        'The ID of the Bobcat purchase transaction behind this transaction, with\nthe same presence as bobcat_order_id.\n',
      ),
    amount_inc_vat: zod.number(),
    amount_ex_vat: zod.number(),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    vat: zod.array(
      zod.object({
        rate: zod
          .number()
          .min(
            m2mListTransactionsWithBillingDetailsResponseTransactionVatItemRateMin,
          )
          .max(
            m2mListTransactionsWithBillingDetailsResponseTransactionVatItemRateMax,
          )
          .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
        amount: zod
          .number()
          .min(
            m2mListTransactionsWithBillingDetailsResponseTransactionVatItemAmountMin,
          ),
      }),
    ),
    source: zod.enum([
      'portal',
      'allpay',
      'walletcard',
      'alltix-resellers',
      'alltix-resellers-portal',
    ]),
    sales_channel: zod.enum(['corporate', 'school', 'benefit']),
    reason: zod
      .string()
      .optional()
      .describe(
        'A short (possible single-word) description of the purpose for this\npurchase. Printed in invoice specifications.\n',
      ),
    grouping_key: zod
      .string()
      .optional()
      .describe(
        'Used to group transactions together in invoice specifications',
      ),
  }),
  transaction_product: zod.object({
    id: zod.string().uuid(),
    transaction_id: zod.string().uuid(),
    count: zod.number(),
    title: zod.string(),
    subtitle: zod.string().optional(),
    bobcat_tags: zod.array(zod.string()),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    deleted_at: zod.string().datetime({}).optional(),
    tenant_id: zod
      .string()
      .describe(
        'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
      ),
  }),
  organization: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod
        .object({
          name: zod.string(),
          organization_number: zod
            .string()
            .regex(
              m2mListTransactionsWithBillingDetailsResponseOrganizationOrganizationNumberRegExp,
            ),
          state: zod.enum(['inactive', 'submitted', 'approved', 'rejected']),
          credit: zod.number().optional(),
          discount_codes: zod
            .record(
              zod.string(),
              zod.object({
                half_product: zod
                  .string()
                  .optional()
                  .describe('Discount code for half product'),
                full_product: zod
                  .string()
                  .optional()
                  .describe('Discount code for full product'),
              }),
            )
            .describe('Discount codes per collection type'),
          enabled_collection_types: zod
            .array(
              zod.enum([
                'school-transportation',
                'school-student-travel',
                'school-child-and-youth',
              ]),
            )
            .describe('Opt-in collection types enabled for this organization'),
          gln: zod.string().optional(),
          einvoice_email: zod.string().email().optional(),
          selfmanaged_school_claims: zod
            .boolean()
            .optional()
            .describe(
              'Whether the organization may manage its own school collection ticket claims. Omitted on update keeps the current value.',
            ),
        })
        .and(
          zod.object({
            is_internal: zod.boolean(),
          }),
        ),
    ),
  department: zod
    .object({
      id: zod.string().uuid(),
      tenant_id: zod
        .string()
        .describe(
          'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
        ),
      created_at: zod.string().datetime({}),
      updated_at: zod.string().datetime({}),
    })
    .and(
      zod.object({
        parent_id: zod.string().uuid().optional(),
        name: zod.string().min(1),
        organization_number: zod.string().optional(),
        delivery_address: zod.object({
          street: zod.string().min(1),
          zip_code: zod
            .string()
            .min(1)
            .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
          city: zod.string().min(1),
          care_of: zod
            .string()
            .min(1)
            .optional()
            .describe(
              "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
            ),
        }),
      }),
    )
    .and(
      zod.object({
        deleted_at: zod.string().datetime({}).optional(),
        organization_id: zod.string().uuid(),
        payer_id: zod.string().uuid().optional(),
      }),
    ),
  payer_id: zod.string().uuid(),
  payer_address: zod.object({
    street: zod.string().min(1),
    zip_code: zod
      .string()
      .min(1)
      .describe('Swedish zip code, 5 digits (e.g. 12345 or 123 45)'),
    city: zod.string().min(1),
    care_of: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "Recipient the mail is addressed care of (c/o), e.g. a guardian's name. The name only, without the c/o prefix.",
      ),
  }),
  payer_reference: zod.string(),
  payer_details: zod.record(zod.string(), zod.string()),
});
export const m2mListTransactionsWithBillingDetailsResponse = zod.array(
  m2mListTransactionsWithBillingDetailsResponseItem,
);

/**
 * Creates the AllTix-side artifacts for a single reseller ticket purchase:
an order, a transaction (with its transaction_product line item and
transaction_ticket link), a traveller (find-or-create within the
department's organization), a master-collection membership, and an
issued ticket.

The endpoint is non-idempotent — retrying the same call creates a new
order, transaction, and issued ticket. The traveller and collection
membership are upserted by unique constraints and will not duplicate.

 * @summary Create a reseller purchase
 */
export const m2mCreateResellerPurchaseBodyAmountIncVatMin = 0;

export const m2mCreateResellerPurchaseBodyAmountExVatMin = 0;

export const m2mCreateResellerPurchaseBodyVatItemRateMin = 0;
export const m2mCreateResellerPurchaseBodyVatItemRateMax = 100;

export const m2mCreateResellerPurchaseBodyVatItemAmountMin = 0;

export const m2mCreateResellerPurchaseBody = zod.object({
  tenant_id: zod
    .string()
    .describe(
      'The unique identifier of a tenant.\nCommon values include: ltn, ltv, vlt, ltr, ske, llt, but any string is allowed.\n',
    ),
  department_id: zod
    .string()
    .uuid()
    .describe(
      'The department the reseller offering belongs to. Must be a\nversion-4 UUID.\n',
    ),
  bobcat_order_id: zod.string(),
  bobcat_transaction_id: zod.string(),
  offering_name: zod
    .string()
    .describe(
      'Name of the offering sold by the reseller. Stored on the transaction\nand used to group transactions together in invoice specifications.\n',
    ),
  created_at: zod.string().datetime({}),
  amount_inc_vat: zod
    .number()
    .min(m2mCreateResellerPurchaseBodyAmountIncVatMin)
    .describe('Float in SEK (e.g. 106.00 for 106 kronor).'),
  amount_ex_vat: zod
    .number()
    .min(m2mCreateResellerPurchaseBodyAmountExVatMin)
    .describe('Float in SEK (e.g. 100.00 for 100 kronor).'),
  vat: zod
    .array(
      zod.object({
        rate: zod
          .number()
          .min(m2mCreateResellerPurchaseBodyVatItemRateMin)
          .max(m2mCreateResellerPurchaseBodyVatItemRateMax)
          .describe('VAT rate as a percentage (e.g. 6 for 6%).'),
        amount: zod.number().min(m2mCreateResellerPurchaseBodyVatItemAmountMin),
      }),
    )
    .min(1),
  product: zod.object({
    title: zod
      .string()
      .describe(
        'Product line-item title shown on invoices and billing reports.\n',
      ),
    subtitle: zod
      .string()
      .min(1)
      .optional()
      .describe(
        'Optional product line-item subtitle (e.g. route or extra detail).\nMust be non-empty if provided.\n',
      ),
  }),
  traveller: zod.object({
    email: zod.string().email(),
    national_identity_number: zod
      .string()
      .optional()
      .describe(
        'Swedish personal identity number. Both `YYYYMMDD-XXXX`\n(e.g. `20010101-1234`) and `YYYYMMDDXXXX`\n(e.g. `200101011234`) are accepted. Coordination numbers\n(samordningsnummer, day + 60) and interim identifiers (two\nuppercase letters or digits followed by two digits, e.g.\n`20010101-TF42`) are also accepted.\n',
      ),
    bobcat_private_email: zod
      .string()
      .email()
      .optional()
      .describe(
        "Email to use for the Bobcat traveller identity. Falls back to\n`email` if omitted. For linking the traveller's private bobcat account.\n",
      ),
    bobcat_private_id: zod
      .string()
      .optional()
      .describe(
        "Bobcat traveller ID. Must be set if bobcat_private_email is set.\nFor linking the traveller's private bobcat account.\n",
      ),
    first_name: zod
      .string()
      .min(1)
      .optional()
      .describe('Optional. Must be non-empty if provided.'),
    last_name: zod
      .string()
      .min(1)
      .optional()
      .describe('Optional. Must be non-empty if provided.'),
  }),
  ticket: zod.object({
    bobcat_mtb_product_ids: zod.array(zod.string().min(1)).min(1),
    bobcat_mtb_bearer_id: zod
      .string()
      .describe(
        'The Bobcat MTB bearer the ticket was purchased against. Stored\nas `original_bobcat_bearer_id` audit info on the transaction-ticket\nlink.\n',
      ),
    tags: zod
      .array(zod.string().min(1))
      .min(1)
      .describe(
        'The Bobcat tags for this ticket. Tags prefixed `pc_` and `tc_`\nare used to derive product_class and traveller_class on the\nissued ticket and bobcat_tags on the transaction_products line\nitem; all tags are also stored on the issued ticket as-is.\n',
      ),
    state: zod
      .enum(['active', 'inactive'])
      .describe('State of the issued ticket at the time of purchase.'),
    expires_at: zod
      .string()
      .datetime({})
      .describe("The ticket's expiry timestamp (Bobcat MTB end of validity)."),
    original_bearer_type: zod
      .enum(['smartcard', 'smartphone'])
      .describe(
        'Type of the Bobcat bearer the ticket was purchased against.\nAudit info on the transaction-ticket link.\n',
      ),
    original_bearer: zod
      .string()
      .describe(
        'Human-readable identifier for the original bearer. Smartcard\nserial number when `original_bearer_type` is `smartcard`, the\nBobcat traveller email when `smartphone`. Audit info on the\ntransaction-ticket link.\n',
      ),
  }),
});

/**
 * Get your notification settings, if you're an administrator
 * @summary Get your notifications settings
 */
export const getAdminNotificationSettingsResponseDepartmentPayerCreatedDefault = false;

export const getAdminNotificationSettingsResponse = zod.object({
  organization_application_received: zod
    .boolean()
    .describe(
      'Should the administrator receive a notification whenever\na new organization application is submitted.\n',
    ),
  department_payer_created: zod
    .boolean()
    .describe(
      'Should the administrator receive a notification whenever\na new department payer is created.\n',
    ),
});

/**
 * Update your notification settings, if you're an administrator
 * @summary Update your notification settings
 */
export const setAdminNotificationSettingsBodyDepartmentPayerCreatedDefault = false;

export const setAdminNotificationSettingsBody = zod.object({
  organization_application_received: zod
    .boolean()
    .describe(
      'Should the administrator receive a notification whenever\na new organization application is submitted.\n',
    ),
  department_payer_created: zod
    .boolean()
    .describe(
      'Should the administrator receive a notification whenever\na new department payer is created.\n',
    ),
});

export const setAdminNotificationSettingsResponseDepartmentPayerCreatedDefault = false;

export const setAdminNotificationSettingsResponse = zod.object({
  organization_application_received: zod
    .boolean()
    .describe(
      'Should the administrator receive a notification whenever\na new organization application is submitted.\n',
    ),
  department_payer_created: zod
    .boolean()
    .describe(
      'Should the administrator receive a notification whenever\na new department payer is created.\n',
    ),
});

/**
 * Sysadmin-only. Revives a failed card transfer task: clears the failure state, resets the retry budget, and lets the runner resume from the last successful phase. Returns 409 if the task is not failed or if another active task already exists for the same source card.
 * @summary Force-retry a failed card transfer task
 */
export const retryCardTransferTaskParams = zod.object({
  taskID: zod.string().uuid(),
});

export const retryCardTransferTaskResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod.string(),
    source_issued_card_id: zod.string().uuid(),
    source_collection_member_id: zod.string().uuid(),
    source_bobcat_bearer_id: zod.string(),
    target_collection_member_id: zod.string().uuid(),
    phase: zod
      .enum([
        'created',
        'products_listed',
        'old_bearer_deleted',
        'new_bearer_created',
        'products_moved',
        'completed',
      ])
      .describe('Resumable cursor into the bobcat dance.'),
    status: zod
      .enum(['pending', 'completed', 'failed', 'cancelled'])
      .describe('Lifecycle status of the task.'),
    product_ids: zod.array(zod.string()),
    new_bobcat_bearer_id: zod.string().nullish(),
    attempts: zod.number(),
    last_error: zod.string().nullish(),
    next_attempt_at: zod.string().datetime({}),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    completed_at: zod.string().datetime({}).nullish(),
    failed_at: zod.string().datetime({}).nullish(),
    cancelled_at: zod.string().datetime({}).nullish(),
  })
  .describe(
    'A durable, async task tracking the cross-org school card transfer, a.k.a the bobcat dance. Phase and status are derived in the backend from per-step timestamps.',
  );

/**
 * Sysadmin-only. Cancels a card transfer task that has not yet mutated any bobcat state. Only valid while the task is pending and in phase 'created' or 'products_listed'; once the bobcat dance has begun, recovery is force-retry only. Returns 409 if the task is not pending or its phase is past 'products_listed'.
 * @summary Cancel a pre-mutation card transfer task
 */
export const cancelCardTransferTaskParams = zod.object({
  taskID: zod.string().uuid(),
});

export const cancelCardTransferTaskResponse = zod
  .object({
    id: zod.string().uuid(),
    tenant_id: zod.string(),
    source_issued_card_id: zod.string().uuid(),
    source_collection_member_id: zod.string().uuid(),
    source_bobcat_bearer_id: zod.string(),
    target_collection_member_id: zod.string().uuid(),
    phase: zod
      .enum([
        'created',
        'products_listed',
        'old_bearer_deleted',
        'new_bearer_created',
        'products_moved',
        'completed',
      ])
      .describe('Resumable cursor into the bobcat dance.'),
    status: zod
      .enum(['pending', 'completed', 'failed', 'cancelled'])
      .describe('Lifecycle status of the task.'),
    product_ids: zod.array(zod.string()),
    new_bobcat_bearer_id: zod.string().nullish(),
    attempts: zod.number(),
    last_error: zod.string().nullish(),
    next_attempt_at: zod.string().datetime({}),
    created_at: zod.string().datetime({}),
    updated_at: zod.string().datetime({}),
    completed_at: zod.string().datetime({}).nullish(),
    failed_at: zod.string().datetime({}).nullish(),
    cancelled_at: zod.string().datetime({}).nullish(),
  })
  .describe(
    'A durable, async task tracking the cross-org school card transfer, a.k.a the bobcat dance. Phase and status are derived in the backend from per-step timestamps.',
  );

/**
 * Sysadmin-only. Deletes the card's bearer in Bobcat and drops the portal's assignment of the serial so it can be claimed again, mainly to reuse cards during testing. Returns 404 if the serial is not assigned in the tenant, and 409 if the card was issued by the system, backs a wallet card, or carries a live issued ticket.
 * @summary Purge a card serial from the tenant
 */
export const purgeCardParams = zod.object({
  cardSerial: zod.string().describe('The card serial to purge'),
});

/**
 * Sysadmin-only. Every assignment of the serial in the tenant, newest first. A serial that was never assigned has an empty history.
 * @summary Get a card serial's assignment history
 */
export const adminGetCardHistoryParams = zod.object({
  cardSerial: zod.string().describe('The card serial to look up'),
});

export const adminGetCardHistoryResponseItem = zod
  .object({
    card_serial: zod.string().describe('card serial number'),
    type: zod.enum(['travelcard', 'walletcard', 'schoolcard']),
    organization_id: zod.string().uuid(),
    traveller_id: zod
      .string()
      .uuid()
      .optional()
      .describe(
        'Absent for a wallet card that is not tied to a collection member',
      ),
    bobcat_mtb_bearer_id: zod.string(),
    assigned_at: zod.string().datetime({}),
    released_at: zod
      .string()
      .datetime({})
      .optional()
      .describe('Absent while the card is still assigned'),
  })
  .describe('One period during which a card was assigned.');
export const adminGetCardHistoryResponse = zod.array(
  adminGetCardHistoryResponseItem,
);

/**
 * Sysadmin-only. Every card assigned to the traveller anywhere in the tenant, newest first, including cards since released. Deleted travellers keep their history; an unknown traveller has an empty one.
 * @summary Get a traveller's card history across the tenant
 */
export const adminGetTravellerCardHistoryParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const adminGetTravellerCardHistoryResponseItem = zod
  .object({
    card_serial: zod.string().describe('card serial number'),
    type: zod.enum(['travelcard', 'walletcard', 'schoolcard']),
    organization_id: zod.string().uuid(),
    traveller_id: zod
      .string()
      .uuid()
      .optional()
      .describe(
        'Absent for a wallet card that is not tied to a collection member',
      ),
    bobcat_mtb_bearer_id: zod.string(),
    assigned_at: zod.string().datetime({}),
    released_at: zod
      .string()
      .datetime({})
      .optional()
      .describe('Absent while the card is still assigned'),
  })
  .describe('One period during which a card was assigned.');
export const adminGetTravellerCardHistoryResponse = zod.array(
  adminGetTravellerCardHistoryResponseItem,
);

/**
 * Sends a magic link to the provided email address for passwordless authentication
 * @summary Request self-service magic link
 */
export const selfServiceRequestMagicLinkBody = zod.object({
  email: zod.string().email(),
  tenant_id: zod.string(),
});

/**
 * Exchanges a magic link token for a JWT session token
 * @summary Verify magic link token
 */
export const selfServiceVerifyMagicLinkBody = zod.object({
  token: zod.string().uuid(),
  tenant_id: zod.string(),
});

export const selfServiceVerifyMagicLinkResponse = zod.object({
  token: zod.string(),
  expires_at: zod.string().datetime({}),
});

/**
 * Exchanges a valid JWT for a new JWT with fresh expiry (idle timeout mechanism)
 * @summary Refresh JWT token
 */
export const selfServiceRefreshTokenResponse = zod.object({
  token: zod.string(),
  expires_at: zod.string().datetime({}),
});

/**
 * Get all active and inactive tickets for the authenticated user's own travellers (self) and wards (for guardians), grouped by traveller
 * @summary List issued tickets
 */
export const selfServiceListTicketsResponse = zod
  .object({
    self: zod
      .array(
        zod
          .object({
            traveller_id: zod
              .string()
              .uuid()
              .describe('The ID of the traveller'),
            first_name: zod.string().describe("Traveller's first name"),
            last_name: zod.string().describe("Traveller's last name"),
            tickets: zod
              .array(
                zod
                  .object({
                    id: zod
                      .string()
                      .uuid()
                      .describe('The ID of the issued ticket'),
                    state: zod.enum([
                      'active',
                      'inactive',
                      'blacklisted',
                      'cancelled',
                      'expired',
                      'marked_for_deletion',
                      'revoked',
                    ]),
                    product_class: zod.string(),
                    traveller_class: zod.string(),
                    tags: zod.array(zod.string()),
                    expires_at: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe('The date and time when the ticket expires'),
                    revoke_at: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe(
                        'The date and time when the ticket will be revoked',
                      ),
                    bobcat_mtb_product_ids: zod
                      .array(zod.string())
                      .describe(
                        'Bobcat MTB product IDs for bearer correlation',
                      ),
                    bobcat_mtb_bearer_id: zod
                      .string()
                      .optional()
                      .describe(
                        'ID of the Bobcat MTB bearer the ticket is assigned to in Bobcat',
                      ),
                    recipient_name: zod
                      .string()
                      .optional()
                      .describe('The name of the intended recipient'),
                    department_name: zod
                      .string()
                      .describe(
                        'Name of the department that issued the ticket',
                      ),
                    collection_name: zod
                      .string()
                      .optional()
                      .describe(
                        'Name of the collection (if ticket is from a collection)',
                      ),
                    collection_type: zod
                      .enum([
                        'master',
                        'school-transportation',
                        'school-student-travel',
                        'school-child-and-youth',
                      ])
                      .optional(),
                    loan_transaction_id: zod
                      .string()
                      .optional()
                      .describe(
                        'The ID of the active loan transaction. Present when the ticket is currently loaned out.',
                      ),
                    activations_total: zod
                      .number()
                      .optional()
                      .describe(
                        'Total number of activations on the ticket. Present for every ticket Bobcat reports activation counts for.',
                      ),
                    activations_left: zod
                      .number()
                      .optional()
                      .describe('Number of activations left on the ticket.'),
                    current_validity_start: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe(
                        "Start of the current activation's validity. Unset until the ticket has been activated.",
                      ),
                    current_validity_end: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe(
                        "End of the current activation's validity. Unset until the ticket has been activated.",
                      ),
                    earliest_start_of_validity: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe('Earliest time the ticket may be activated.'),
                    latest_start_of_validity: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe('Latest time the ticket may be activated.'),
                    end_of_activation_period: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe(
                        'End of the period in which the ticket can be activated and used.',
                      ),
                  })
                  .describe(
                    'Curated ticket information for self-service portal',
                  ),
              )
              .describe('Tickets belonging to this traveller'),
          })
          .describe(
            'Ticket information grouped by traveller for self-service portal',
          ),
      )
      .describe(
        "Tickets for the authenticated user's own traveller records (may span multiple orgs)",
      ),
    wards: zod
      .array(
        zod
          .object({
            traveller_id: zod
              .string()
              .uuid()
              .describe('The ID of the traveller'),
            first_name: zod.string().describe("Traveller's first name"),
            last_name: zod.string().describe("Traveller's last name"),
            tickets: zod
              .array(
                zod
                  .object({
                    id: zod
                      .string()
                      .uuid()
                      .describe('The ID of the issued ticket'),
                    state: zod.enum([
                      'active',
                      'inactive',
                      'blacklisted',
                      'cancelled',
                      'expired',
                      'marked_for_deletion',
                      'revoked',
                    ]),
                    product_class: zod.string(),
                    traveller_class: zod.string(),
                    tags: zod.array(zod.string()),
                    expires_at: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe('The date and time when the ticket expires'),
                    revoke_at: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe(
                        'The date and time when the ticket will be revoked',
                      ),
                    bobcat_mtb_product_ids: zod
                      .array(zod.string())
                      .describe(
                        'Bobcat MTB product IDs for bearer correlation',
                      ),
                    bobcat_mtb_bearer_id: zod
                      .string()
                      .optional()
                      .describe(
                        'ID of the Bobcat MTB bearer the ticket is assigned to in Bobcat',
                      ),
                    recipient_name: zod
                      .string()
                      .optional()
                      .describe('The name of the intended recipient'),
                    department_name: zod
                      .string()
                      .describe(
                        'Name of the department that issued the ticket',
                      ),
                    collection_name: zod
                      .string()
                      .optional()
                      .describe(
                        'Name of the collection (if ticket is from a collection)',
                      ),
                    collection_type: zod
                      .enum([
                        'master',
                        'school-transportation',
                        'school-student-travel',
                        'school-child-and-youth',
                      ])
                      .optional(),
                    loan_transaction_id: zod
                      .string()
                      .optional()
                      .describe(
                        'The ID of the active loan transaction. Present when the ticket is currently loaned out.',
                      ),
                    activations_total: zod
                      .number()
                      .optional()
                      .describe(
                        'Total number of activations on the ticket. Present for every ticket Bobcat reports activation counts for.',
                      ),
                    activations_left: zod
                      .number()
                      .optional()
                      .describe('Number of activations left on the ticket.'),
                    current_validity_start: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe(
                        "Start of the current activation's validity. Unset until the ticket has been activated.",
                      ),
                    current_validity_end: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe(
                        "End of the current activation's validity. Unset until the ticket has been activated.",
                      ),
                    earliest_start_of_validity: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe('Earliest time the ticket may be activated.'),
                    latest_start_of_validity: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe('Latest time the ticket may be activated.'),
                    end_of_activation_period: zod
                      .string()
                      .datetime({})
                      .optional()
                      .describe(
                        'End of the period in which the ticket can be activated and used.',
                      ),
                  })
                  .describe(
                    'Curated ticket information for self-service portal',
                  ),
              )
              .describe('Tickets belonging to this traveller'),
          })
          .describe(
            'Ticket information grouped by traveller for self-service portal',
          ),
      )
      .describe('Tickets for wards (children/students) of a guardian'),
  })
  .describe(
    'Tickets grouped by traveller (self) and wards for self-service portal',
  );

/**
 * Move an issued ticket to a different bearer owned by the authenticated user or their wards
 * @summary Move ticket to a different bearer
 */
export const selfServiceMoveTicketParams = zod.object({
  ticketID: zod.string().uuid(),
});

export const selfServiceMoveTicketBody = zod
  .object({
    mtb_bearer_id: zod
      .string()
      .describe('ID of the bearer for the bobcat mtb product'),
  })
  .describe('Update bearer for issued ticket');

/**
 * Lend an issued ticket to a different bearer owned by the authenticated user or their wards
 * @summary Lend ticket to a different bearer
 */
export const selfServiceLendTicketParams = zod.object({
  ticketID: zod.string().uuid(),
});

export const selfServiceLendTicketBody = zod
  .object({
    mtb_bearer_id: zod
      .string()
      .describe('ID of the target bearer for the loan'),
  })
  .describe('Lend issued ticket to a different bearer');

/**
 * Get bearers (from Bobcat) and travel cards (from local DB) for authenticated user and their wards
 * @summary List bearers and travel cards
 */
export const selfServiceListBearersResponse = zod
  .object({
    self: zod
      .array(
        zod
          .object({
            traveller_id: zod.string().uuid(),
            organization_name: zod.string().optional(),
            name: zod
              .string()
              .describe("Traveller's display name (first + last)"),
            alltix_bearers: zod.array(
              zod.object({
                id: zod.string(),
                type: zod
                  .enum(['other', 'paper', 'smartcard', 'smartphone'])
                  .optional(),
                name: zod.string().optional(),
                default: zod.boolean().optional(),
                serial: zod.string().optional(),
              }),
            ),
            private_bearers: zod.array(
              zod.object({
                id: zod.string(),
                type: zod
                  .enum(['other', 'paper', 'smartcard', 'smartphone'])
                  .optional(),
                name: zod.string().optional(),
                default: zod.boolean().optional(),
                serial: zod.string().optional(),
              }),
            ),
            bobcat_private_email: zod.string().email().optional(),
            favored_bobcat_bearer_id: zod.string().optional(),
          })
          .describe('Bearer and card information for a traveller'),
      )
      .describe(
        "Authenticated user's own bearer info (may span multiple orgs, empty for guardian-only users)",
      ),
    wards: zod
      .array(
        zod
          .object({
            traveller_id: zod.string().uuid(),
            organization_name: zod.string().optional(),
            name: zod
              .string()
              .describe("Traveller's display name (first + last)"),
            alltix_bearers: zod.array(
              zod.object({
                id: zod.string(),
                type: zod
                  .enum(['other', 'paper', 'smartcard', 'smartphone'])
                  .optional(),
                name: zod.string().optional(),
                default: zod.boolean().optional(),
                serial: zod.string().optional(),
              }),
            ),
            private_bearers: zod.array(
              zod.object({
                id: zod.string(),
                type: zod
                  .enum(['other', 'paper', 'smartcard', 'smartphone'])
                  .optional(),
                name: zod.string().optional(),
                default: zod.boolean().optional(),
                serial: zod.string().optional(),
              }),
            ),
            bobcat_private_email: zod.string().email().optional(),
            favored_bobcat_bearer_id: zod.string().optional(),
          })
          .describe('Bearer and card information for a traveller'),
      )
      .describe("Ward travellers' bearer info (for guardians)"),
  })
  .describe('Bearer listing response with self and wards structure');

/**
 * Add a travel card for self or a ward
 * @summary Claim a travel card
 */
export const selfServiceClaimCardBodyCardSerialRegExp = new RegExp('^[0-9]+$');
export const selfServiceClaimCardBodyLabelMax = 100;

export const selfServiceClaimCardBody = zod
  .object({
    traveller_id: zod.string().uuid(),
    card_serial: zod.string().regex(selfServiceClaimCardBodyCardSerialRegExp),
    label: zod.string().max(selfServiceClaimCardBodyLabelMax).nullish(),
  })
  .describe('Request to claim a travel card in self-service');

/**
 * Check whether a travel card can be claimed in self-service.

A card that is already claimed or not registered is reported as a 200 with
`claimable: false` and a reason, not as an error.

 * @summary Travel card claimability check
 */
export const selfServiceCardIsClaimableQuerySerialRegExp = new RegExp(
  '^[0-9]+$',
);

export const selfServiceCardIsClaimableQueryParams = zod.object({
  serial: zod
    .string()
    .regex(selfServiceCardIsClaimableQuerySerialRegExp)
    .describe('Card serial number'),
});

export const selfServiceCardIsClaimableResponse = zod.object({
  claimable: zod.boolean().describe('is the card claimable?'),
  reason: zod.string().optional(),
});

/**
 * Update bobcat_private_email on a traveller
 * @summary Update a traveller
 */
export const selfServiceUpdateTravellerParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const selfServiceUpdateTravellerBody = zod
  .object({
    bobcat_private_email: zod.string().email().optional(),
  })
  .describe('Request to update a traveller in self-service');

export const selfServiceUpdateTravellerResponse = zod.object({
  id: zod.string().uuid(),
  bobcat_private_email: zod.string().nullable(),
});

/**
 * Set the favored bearer for the authenticated user or one of their wards. The bearer must belong to the traveller in bobcat and must not be blocked.
 * @summary Set the traveller favored bearer
 */
export const selfServiceSetTravellerFavoredBearerParams = zod.object({
  travellerID: zod.string().uuid(),
});

export const selfServiceSetTravellerFavoredBearerBody = zod
  .object({
    mtb_bearer_id: zod
      .string()
      .min(1)
      .describe(
        "ID of the bobcat mtb bearer to favor. Must be an unblocked bearer belonging to the traveller's alltix or private bobcat traveller.",
      ),
  })
  .describe('Set the favored bearer for a traveller');

/**
 * Clear the favored bearer for the authenticated user or one of their wards
 * @summary Clear the traveller favored bearer
 */
export const selfServiceClearTravellerFavoredBearerParams = zod.object({
  travellerID: zod.string().uuid(),
});

/**
 * Rename a bearer for the authenticated user or one of their wards. The bearer must belong to the traveller's alltix bobcat traveller and must not be blocked. Private bearers are read-only from the portal.
 * @summary Rename a traveller bearer
 */
export const selfServiceRenameTravellerBearerParams = zod.object({
  travellerID: zod.string().uuid(),
  mtbBearerID: zod.string(),
});

export const selfServiceRenameTravellerBearerBodyNameMax = 100;

export const selfServiceRenameTravellerBearerBody = zod
  .object({
    name: zod
      .string()
      .min(1)
      .max(selfServiceRenameTravellerBearerBodyNameMax)
      .describe(
        'New display name of the bearer. Surrounding whitespace is trimmed, and a blank name is rejected.',
      ),
  })
  .describe('Rename a bearer in self-service');

export const selfServiceRenameTravellerBearerResponse = zod.object({
  id: zod.string(),
  type: zod.enum(['other', 'paper', 'smartcard', 'smartphone']).optional(),
  name: zod.string().optional(),
  default: zod.boolean().optional(),
  serial: zod.string().optional(),
});
